/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ClientInput = {
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  email?: string | null,
  image?: string | null,
};

export type Client = {
  __typename: "Client",
  id?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  email?: string | null,
  image?: string | null,
  referralSource?: string | null,
  hasShopper?: boolean | null,
  signupTimestamp?: string | null,
  attnPassword?: boolean | null,
  deactivated?: boolean | null,
  hasStreamUser?: boolean | null,
  preferences: ClientPreferences,
};

export type ClientPreferences = {
  __typename: "ClientPreferences",
  id: string,
  surveys:  Array<Survey >,
};

export type Survey = {
  __typename: "Survey",
  id: string,
  completedTimestamp: string,
  name: string,
  responses:  Array<SurveyResponse >,
};

export type SurveyResponse = {
  __typename: "SurveyResponse",
  id: string,
  question: string,
  response?: string | null,
};

export type LinkedClientInput = {
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  image?: string | null,
};

export type LinkedClient = {
  __typename: "LinkedClient",
  id?: string | null,
  client?: Client | null,
  note?: string | null,
  orderCount?: number | null,
  lastOrderTimestamp?: string | null,
  firstConnectTimestamp?: string | null,
  referralSourceMessage?: string | null,
  clientAnnotation: LinkedClientAnnotations,
  lastInviteTimestamp?: string | null,
};

export type LinkedClientAnnotations = {
  __typename: "LinkedClientAnnotations",
  id: string,
  note?: string | null,
  image?: string | null,
  noteLastUpdatedTimestamp?: number | null,
  preferencesLastUpdatedTimestamp?: number | null,
  preferencesLastSeenTimestamp?: number | null,
  needsToSeePreferences: boolean,
};

export type LinkedOrderIdentifiersInput = {
  id?: string | null,
  deliveryTimestamp?: string | null,
};

export type AddressInput = {
  addressName?: string | null,
  addressLine1?: string | null,
  addressLine2?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  country?: string | null,
  isDefault?: boolean | null,
};

export type Address = {
  __typename: "Address",
  id?: string | null,
  addressName?: string | null,
  addressLine1?: string | null,
  addressLine2?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  country?: string | null,
  isDefault?: boolean | null,
};

export type PaymentMethodInput = {
  stripeToken?: string | null,
  isDefault?: boolean | null,
};

export type PaymentMethod = {
  __typename: "PaymentMethod",
  id?: string | null,
  brand?: string | null,
  expirationMonth?: number | null,
  expirationYear?: number | null,
  last4?: string | null,
  isDefault?: boolean | null,
  address?: Address | null,
};

export type OrderInput = {
  version?: string | null,
  shopperId?: string | null,
  deliveryDate?: string | null,
  deliveryTime?: string | null,
  deliveryAddress?: DeliveryAddressInput | null,
  orderPaymentMethod?: OrderPaymentMethodInput | null,
  serviceRequestList?: Array< ServiceRequestInput | null > | null,
  tip?: number | null,
  couponCode?: string | null,
  sharedListIdentifiers?: Array< SharedListIdentifierInput | null > | null,
};

export type DeliveryAddressInput = {
  id?: string | null,
  addressName?: string | null,
  addressLine1?: string | null,
  addressLine2?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  country?: string | null,
  isDefault?: boolean | null,
};

export type OrderPaymentMethodInput = {
  id?: string | null,
  brand?: string | null,
  expirationMonth?: number | null,
  expirationYear?: number | null,
  last4?: string | null,
  isDefault?: boolean | null,
};

export type ServiceRequestInput = {
  serviceId?: string | null,
  serviceName?: string | null,
  image?: string | null,
  errandList?: Array< ErrandInput | null > | null,
};

export type ErrandInput = {
  businessName?: string | null,
  shoppingList?: Array< ShoppingItemInput | null > | null,
};

export type ShoppingItemInput = {
  itemName?: string | null,
  itemNote?: string | null,
};

export type SharedListIdentifierInput = {
  owner?: string | null,
  listId?: string | null,
  listName?: string | null,
  storeName?: string | null,
};

export type Order = {
  __typename: "Order",
  version?: string | null,
  id?: string | null,
  clientId?: string | null,
  shopperId?: string | null,
  shopperInfo?: ShopperInfo | null,
  // These next five fields are dynamically added to the lookup when doing linkedOrders.
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  email?: string | null,
  clientImage?: string | null,
  note?: string | null,
  privateNote?: string | null,
  adminNote?: string | null,
  conciergeNote?: string | null,
  orderStatus?: string | null,
  orderDateTime?: string | null,
  orderTimestamp?: string | null,
  deliveryDate?: string | null,
  deliveryTime?: string | null,
  deliveryTimestamp?: string | null,
  deliveryStartDateTime?: string | null,
  deliveryEndDateTime?: string | null,
  deliveryAddress?: Address | null,
  orderPaymentMethod?: PaymentMethod | null,
  serviceRequestList?:  Array<ServiceRequest | null > | null,
  pricingModel?: PricingModel | null,
  tip?: number | null,
  feeAndPreGratuityDisplay?: string | null,
  deliveryFee?: number | null,
  transactions?: Array< string | null > | null,
  couponCode?: string | null,
  adjustmentDescription?: string | null,
  adjustmentAmount?: number | null,
  adjustments?:  Array<Adjustment > | null,
  lineItems?: LineItems | null,
  priceBreakdown?: PriceBreakdown | null,
  earningsBreakdown?: PriceBreakdown | null,
  review?: Review | null,
  sharedListIdentifiers?:  Array<SharedListIdentifier | null > | null,
  listReferences:  Array<ListReference >,
  additionalTipAmount?: number | null,
  additionalTipDismissed?: boolean | null,
  pricingData?: OrderPricingData | null,
  externalTransactions?:  Array<ExternalTransaction | null > | null,
  assignedTo?: Array< string > | null,
  lockoutHours?: number | null,
  parentOrder?: OrderReference | null,
  childOrders?:  Array<OrderReference > | null,
  credits?:  Array<OrderCredit > | null,
};

export type ShopperInfo = {
  __typename: "ShopperInfo",
  image?: string | null,
  displayName?: string | null,
  email?: string | null,
};

export type ServiceRequest = {
  __typename: "ServiceRequest",
  serviceId?: string | null,
  serviceName?: string | null,
  image?: string | null,
  errandList?:  Array<Errand | null > | null,
};

export type Errand = {
  __typename: "Errand",
  businessName?: string | null,
  shoppingItemCount?: number | null,
  shoppingList?:  Array<ShoppingItem | null > | null,
};

export type ShoppingItem = {
  __typename: "ShoppingItem",
  id?: string | null,
  itemName?: string | null,
  itemNote?: string | null,
  isDone?: boolean | null,
};

export type PricingModel = {
  __typename: "PricingModel",
  version?: string | null,
  // This is displayed on the storefront page.
  // It is meant as a terse description of the pricing model.
  // E.g. "My whiteglove service:  $10 + 15%"
  description?: string | null,
  // Term1: flat fee for service.
  flatPm?: FlatPM | null,
  // Term2: hourly fee for service.
  hourlyPm?: HourlyPM | null,
  // Term3: working capital loan.
  // pexBalance: Int
  // pexBalanceDisplay: Boolean
  // Term4: percent service fee, based on term3, with a floor.
  percentPm?: PercentPM | null,
  // Term5: mostly for backwards compatibility with the current model.
  // This is applaied to (pexBalance+serviceFee)
  preTipPm?: PreTipPM | null,
  // Term6: client platform fee.
  clientPlatformPm?: ClientPlatformPM | null,
  suggestedFlatPm?: SuggestedFlatPM | null,
  suggestedPercentPm?: SuggestedPercentPM | null,
  suggestedFlatPlusPercentPm?: SuggestedFlatPlusPercentPM | null,
};

export type FlatPM = {
  __typename: "FlatPM",
  fee?: string | null,
  feeTitle?: string | null,
  display?: boolean | null,
};

export type HourlyPM = {
  __typename: "HourlyPM",
  rate?: string | null,
  billableHours?: string | null,
  minBillableHours?: string | null,
  feeTitle?: string | null,
  display?: boolean | null,
};

export type PercentPM = {
  __typename: "PercentPM",
  percent?: string | null,
  minFee?: string | null,
  feeTitle?: string | null,
  display?: boolean | null,
};

export type PreTipPM = {
  __typename: "PreTipPM",
  chosenPercent?: string | null,
  percentages?: Array< string | null > | null,
  defaultPercentagesIndex?: number | null,
  footer?: string | null,
  feeTitle?: string | null,
  display?: boolean | null,
  fixedGratuityOptions?: Array< number | null > | null,
  defaultFixedGratuityOptionsIndex?: number | null,
  chosenFixedGratuity?: number | null,
  gratuityType?: GratuityType | null,
  showPreGratuityByDefault?: boolean | null,
  allowOptionalGratuity?: boolean | null,
  showCustomGratuity?: boolean | null,
};

export enum GratuityType {
  FIXED = "FIXED",
  PERCENTAGE = "PERCENTAGE",
}


export type ClientPlatformPM = {
  __typename: "ClientPlatformPM",
  percent?: string | null,
  feeTitle?: string | null,
  display?: boolean | null,
};

export type SuggestedFlatPM = {
  __typename: "SuggestedFlatPM",
  fee?: number | null,
  feeWarningThreshold?: number | null,
  percentages?: Array< number | null > | null,
  gratuityType?: GratuityType | null,
  gratuityOptions?: Array< number | null > | null,
  defaultGratuityOptionsIndex?: number | null,
  clientPaysPlatform?: boolean | null,
  showCustomGratuity?: boolean | null,
  title?: string | null,
  description?: string | null,
};

export type SuggestedPercentPM = {
  __typename: "SuggestedPercentPM",
  percent?: number | null,
  minFee?: number | null,
  percentWarningThreshold?: number | null,
  minFeeWarningThreshold?: number | null,
  gratuityType?: GratuityType | null,
  gratuityOptions?: Array< number | null > | null,
  defaultGratuityOptionsIndex?: number | null,
  clientPaysPlatform?: boolean | null,
  showCustomGratuity?: boolean | null,
  title?: string | null,
  description?: string | null,
};

export type SuggestedFlatPlusPercentPM = {
  __typename: "SuggestedFlatPlusPercentPM",
  fee?: number | null,
  feeWarningThreshold?: number | null,
  percent?: number | null,
  minFee?: number | null,
  percentWarningThreshold?: number | null,
  minFeeWarningThreshold?: number | null,
  gratuityType?: GratuityType | null,
  gratuityOptions?: Array< number | null > | null,
  defaultGratuityOptionsIndex?: number | null,
  clientPaysPlatform?: boolean | null,
  showCustomGratuity?: boolean | null,
  title?: string | null,
  description?: string | null,
};

export type Adjustment = {
  __typename: "Adjustment",
  id: string,
  description: string,
  amount: number,
};

export type LineItems = {
  __typename: "LineItems",
  deliveryFee?: number | null,
  tipPercentage?: number | null,
  tipAmount?: number | null,
  platformPercentage?: number | null,
  platformAmount?: number | null,
  subtotal?: number | null,
  coupon?: number | null,
  total?: number | null,
  earnings?: number | null,
  stores?:  Array<StoreAmount | null > | null,
  couponCode?: string | null,
  additionalTipAmount?: number | null,
  adjustmentDescription?: string | null,
  adjustmentAmount?: number | null,
};

export type StoreAmount = {
  __typename: "StoreAmount",
  storeName?: string | null,
  storeAmount?: number | null,
};

export type PriceBreakdown = {
  __typename: "PriceBreakdown",
  title?: string | null,
  lineItems?:  Array<KeyValue | null > | null,
  final?: KeyValue | null,
};

export type KeyValue = {
  __typename: "KeyValue",
  key?: string | null,
  value?: string | null,
  type?: KVType | null,
  metadata?: KVMetadata | null,
};

export enum KVType {
  PAYOUT_STATUS = "PAYOUT_STATUS",
  PAYMENT_STATUS = "PAYMENT_STATUS",
  UTC_TIMESTAMP = "UTC_TIMESTAMP",
  INVOICE_RECEIPT = "INVOICE_RECEIPT",
  INVOICE_ADJUSTMENT = "INVOICE_ADJUSTMENT",
  INVOICE_EXT_TRANSACTION = "INVOICE_EXT_TRANSACTION",
  PLATFORM_FEE = "PLATFORM_FEE",
  VRC_CREDIT = "VRC_CREDIT",
  PARTIAL_REFUND = "PARTIAL_REFUND",
  PARTIAL_REFUND_FEE = "PARTIAL_REFUND_FEE",
}


export type KVMetadata = {
  __typename: "KVMetadata",
  txId?: string | null,
  adjustmentDescription?: string | null,
  paymentUTCTimestamp?: string | null,
  image?: string | null,
};

export type Review = {
  __typename: "Review",
  id?: string | null,
  quote?: string | null,
  rating?: number | null,
  timestamp?: string | null,
};

export type SharedListIdentifier = {
  __typename: "SharedListIdentifier",
  owner?: string | null,
  listId?: string | null,
  snapshotId?: string | null,
  listName?: string | null,
  storeName?: string | null,
  hasOpenOrder?: boolean | null,
  clientId?: string | null,
  orderId?: string | null,
  orderTimestamp?: string | null,
  serviceImage?: string | null,
  itemCount?: number | null,
  numItems?: number | null,
  numUnits?: number | null,
};

export type ListReference = {
  __typename: "ListReference",
  storeName: string,
  storeImage: string,
  storeId: string,
  id: string,
  listName: string,
  listItemCount: number,
  listVersion: string,
  lastCompletedOrderId?: string | null,
  savedListId?: string | null,
  savedListItemCount: number,
  savedListVersion?: string | null,
};

export type OrderPricingData = {
  __typename: "OrderPricingData",
  preTip?: number | null,
  loan?: number | null,
};

export type ExternalTransaction = {
  __typename: "ExternalTransaction",
  id: string,
  description: string,
  amount: number,
  image?: string | null,
  attachment?: string | null,
  moreAttachments?: Array< string > | null,
};

export type OrderReference = {
  __typename: "OrderReference",
  deliveryTimestamp: string,
  orderTimestamp: string,
  orderId: string,
  clientId: string,
  shopperId: string,
};

export type OrderCredit = {
  __typename: "OrderCredit",
  id: string,
  description: string,
  amount: number,
};

export type OrderInputV2 = {
  id?: string | null,
  version?: string | null,
  shopperId?: string | null,
  deliveryDate?: string | null,
  deliveryTime?: string | null,
  deliveryAddress?: DeliveryAddressInput | null,
  orderPaymentMethod?: OrderPaymentMethodInput | null,
  serviceIds?: Array< string | null > | null,
  sharedListIdentifiers?: Array< SharedListIdentifierInput | null > | null,
  listIds?: Array< string | null > | null,
  pricingModel?: PricingModelInput | null,
  couponCode?: string | null,
  note?: string | null,
  utcOffset?: number | null,
};

export type PricingModelInput = {
  version?: string | null,
  // This is displayed on the storefront page.
  // It is meant as a terse description of the pricing model.
  // E.g. "My whiteglove service:  $10 + 15%"
  description?: string | null,
  // Term1: flat fee for service.
  flatPm?: FlatPMInput | null,
  // Term2: hourly fee for service.
  hourlyPm?: HourlyPMInput | null,
  // Term3: working capital loan.
  // pexBalance: Int
  // pexBalanceDisplay: Boolean
  // Term4: percent service fee, based on term3, with a floor.
  percentPm?: PercentPMInput | null,
  // Term5: mostly for backwards compatibility with the current model.
  // This is applaied to (pexBalance+serviceFee)
  preTipPm?: PreTipPMInput | null,
  // Term6: client platform fee.
  clientPlatformPm?: ClientPlatformPMInput | null,
};

export type FlatPMInput = {
  fee?: string | null,
  feeTitle?: string | null,
  display?: boolean | null,
};

export type HourlyPMInput = {
  rate?: string | null,
  billableHours?: string | null,
  minBillableHours?: string | null,
  feeTitle?: string | null,
  display?: boolean | null,
};

export type PercentPMInput = {
  percent?: string | null,
  minFee?: string | null,
  feeTitle?: string | null,
  display?: boolean | null,
};

export type PreTipPMInput = {
  chosenPercent?: string | null,
  percentages?: Array< string | null > | null,
  defaultPercentagesIndex?: number | null,
  footer?: string | null,
  feeTitle?: string | null,
  display?: boolean | null,
  fixedGratuityOptions?: Array< number | null > | null,
  defaultFixedGratuityOptionsIndex?: number | null,
  chosenFixedGratuity?: number | null,
  gratuityType?: GratuityType | null,
  showPreGratuityByDefault?: boolean | null,
  allowOptionalGratuity?: boolean | null,
  showCustomGratuity?: boolean | null,
};

export type ClientPlatformPMInput = {
  percent?: string | null,
  // This is percentOnTotal
  feeTitle?: string | null,
  display?: boolean | null,
};

export type ShopperInput = {
  firstName?: string | null,
  lastName?: string | null,
  displayName?: string | null,
  announcement?: string | null,
  deliveryArea?: string | null,
  websiteUrl?: string | null,
  phone?: string | null,
  businessPhone?: string | null,
  email?: string | null,
  bio?: string | null,
  image?: string | null,
  branding?: BrandingInput | null,
  businessName?: string | null,
  rating?: string | null,
  specialtyTags?: Array< string | null > | null,
  tagline?: string | null,
  metaTitle?: string | null,
  metaImage?: string | null,
  metaDescription?: string | null,
  deliveryAreaZipcode?: string | null,
  deliveryAreaZipcodes?: Array< string > | null,
  deliveryRadius?: number | null,
  optInEngage?: boolean | null,
  optInZipcode?: boolean | null,
};

export type BrandingInput = {
  coverColor?: string | null,
};

export type Shopper = {
  __typename: "Shopper",
  id?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  displayName?: string | null,
  deliveryArea?: string | null,
  websiteUrl?: string | null,
  phone?: string | null,
  businessPhone?: string | null,
  email?: string | null,
  bio?: string | null,
  image?: string | null,
  businessName?: string | null,
  availabilityDescription?: string | null,
  announcement?: string | null,
  rating?: string | null,
  repeatClientCount?: number | null,
  orderCount?: number | null,
  reviewCount?: number | null,
  specialtyTags?: Array< string | null > | null,
  tagline?: string | null,
  metaTitle?: string | null,
  metaImage?: string | null,
  metaDescription?: string | null,
  deliveryAreaZipcode?: string | null,
  deliveryAreaZipcodes?: Array< string > | null,
  deliveryRadius?: number | null,
  lowestPrice?: string | null,
  subscriptionPlan?: string | null,
  subscriptionPlanDetails?: SubscriptionPlanDetails | null,
  branding?: Branding | null,
  typicalPricing?: TypicalPricing | null,
  allowClientConnection?: boolean | null,
  stripeConnectAcctExists?: boolean | null,
  fullSSNRequired?: boolean | null,
  attnBizProfile?: boolean | null,
  attnDirectDeposit?: boolean | null,
  attnCreditCard?: boolean | null,
  attnServices?: boolean | null,
  attnPassword?: boolean | null,
  statusIdentityVerification?: shopperStatusVariable | null,
  statusChargeCard?: shopperStatusVariable | null,
  optInEngage?: boolean | null,
  optInZipcode?: boolean | null,
  deactivated?: boolean | null,
  acceptsReferralNetwork?: boolean | null,
};

export type SubscriptionPlanDetails = {
  __typename: "SubscriptionPlanDetails",
  id?: string | null,
  // Name of the plan ... same as subscriptionPlan for now.
  textComponents?:  Array<TextComponent | null > | null,
  phases?:  Array<Phase | null > | null,
};

export type TextComponent = {
  __typename: "TextComponent",
  text?: string | null,
  bold?: boolean | null,
};

export type Phase = {
  __typename: "Phase",
  id?: string | null,
  // Name of a plan ... Starter, etc.
  status?: string | null,
};

export type Branding = {
  __typename: "Branding",
  coverColor?: string | null,
};

export type TypicalPricing = {
  __typename: "TypicalPricing",
  summary?: TypicalPricingSummary | null,
  groceries?: string | null,
  shoppingAndDelivery?: string | null,
  minGratuity?: string | null,
  platform?: string | null,
};

export type TypicalPricingSummary = {
  __typename: "TypicalPricingSummary",
  title?: string | null,
  description?: string | null,
};

export type shopperStatusVariable = {
  __typename: "shopperStatusVariable",
  state?: string | null,
  message?: string | null,
  externalLink?: string | null,
};

export type IdentityCreateInput = {
  firstName?: string | null,
  lastName?: string | null,
  dob?: string | null,
  phone?: string | null,
  email?: string | null,
  addressLine1?: string | null,
  addressLine2?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  ssnToken?: string | null,
  ipAddr?: string | null,
};

export type IdentityUpdateInput = {
  phone?: string | null,
  email?: string | null,
  addressLine1?: string | null,
  addressLine2?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
};

export type ServiceOfferingIdsInput = {
  serviceOfferingIds?: Array< string | null > | null,
};

export type ServiceOfferingIds = {
  __typename: "ServiceOfferingIds",
  serviceOfferingIds?: Array< string | null > | null,
};

export type ServiceOfferingInput = {
  serviceName?: string | null,
  serviceImage?: string | null,
  serviceDescription?: string | null,
  defaultErrandBusinessNames?: Array< string | null > | null,
  baseFee?: number | null,
  maxErrands?: number | null,
};

export type ServiceOffering = {
  __typename: "ServiceOffering",
  id?: string | null,
  serviceName?: string | null,
  serviceImage?: string | null,
  serviceDescription?: string | null,
  defaultErrandBusinessNames?: Array< string | null > | null,
  baseFee?: number | null,
  maxErrands?: number | null,
  pricingModel?: PricingModel | null,
  disclaimerText?: string | null,
  useSuggestedPricing?: boolean | null,
};

export type DailySchedulesInput = {
  // create: [DailyScheduleInput]
  update?: Array< UpdateDailyScheduleInput | null > | null,
};

export type UpdateDailyScheduleInput = {
  id?: string | null,
  day?: string | null,
  timeSlots?: Array< TimeSlotsInput | null > | null,
};

export type TimeSlotsInput = {
  id?: string | null,
  slotStart?: string | null,
  slotEnd?: string | null,
  isActive?: boolean | null,
};

export type ShopperSchedule = {
  __typename: "ShopperSchedule",
  id?: string | null,
  dailySchedules?:  Array<DailySchedule | null > | null,
};

export type DailySchedule = {
  __typename: "DailySchedule",
  id?: string | null,
  day?: string | null,
  timeSlots?:  Array<TimeSlot | null > | null,
};

export type TimeSlot = {
  __typename: "TimeSlot",
  id?: string | null,
  slotStart?: string | null,
  slotEnd?: string | null,
  isActive?: boolean | null,
  bufferDuration?: number | null,
  bufferMode?: BufferMode | null,
};

export enum BufferMode {
  SOFT = "SOFT",
  STRICT = "STRICT",
}


export type DailySchedulesInputV2 = {
  id?: string | null,
  day?: string | null,
  timeSlots?: Array< TimeSlotInputV2 | null > | null,
};

export type TimeSlotInputV2 = {
  id?: string | null,
  slotStart?: number | null,
  slotEnd?: number | null,
  maxOrders?: number | null,
  bufferDuration?: number | null,
  bufferMode?: BufferMode | null,
};

export type ShopperScheduleV2 = {
  __typename: "ShopperScheduleV2",
  dailySchedules?:  Array<DailyScheduleV2 | null > | null,
};

export type DailyScheduleV2 = {
  __typename: "DailyScheduleV2",
  id?: string | null,
  day?: string | null,
  timeSlots?:  Array<TimeSlotV2 | null > | null,
};

export type TimeSlotV2 = {
  __typename: "TimeSlotV2",
  id?: string | null,
  slotStart?: number | null,
  slotEnd?: number | null,
  maxOrders?: number | null,
  bufferDuration?: number | null,
  bufferMode?: BufferMode | null,
};

export type ShopperScheduleOptionsInput = {
  defaultMaxOrders?: number | null,
  defaultTimeSlotDuration?: number | null,
  isScheduleAvailable?: boolean | null,
  defaultBufferDuration?: number | null,
  defaultBufferMode?: BufferMode | null,
};

export type ShopperScheduleOptions = {
  __typename: "ShopperScheduleOptions",
  defaultMaxOrders?: number | null,
  defaultTimeSlotDuration?: number | null,
  isScheduleAvailable?: boolean | null,
  defaultBufferDuration: number,
  defaultBufferMode: BufferMode,
};

export type ClosedDateRangesInput = {
  utcOffset?: number | null,
  startDate?: string | null,
  endDate?: string | null,
  closedDateRanges?: Array< ClosedDateRangeInput | null > | null,
};

export type ClosedDateRangeInput = {
  id?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  description?: string | null,
};

export type ShopperClosedDateRanges = {
  __typename: "ShopperClosedDateRanges",
  closedDateRanges?:  Array<ClosedDateRange | null > | null,
};

export type ClosedDateRange = {
  __typename: "ClosedDateRange",
  id?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  description?: string | null,
};

export type ChargeCardInput = {
  nameOnCard?: string | null,
  cardNumber?: string | null,
  expirationMonth?: number | null,
  expirationYear?: number | null,
};

export type ChargeCard = {
  __typename: "ChargeCard",
  id?: string | null,
  brand?: string | null,
  expirationMonth?: number | null,
  expirationYear?: number | null,
  last4?: string | null,
  status?: string | null,
  message?: string | null,
};

export type StripeConnectAccountInput = {
  dateOfBirth?: string | null,
  legalFirstName?: string | null,
  legalLastName?: string | null,
  legalAddressLine1?: string | null,
  legalAddressLine2?: string | null,
  legalCity?: string | null,
  legalState?: string | null,
  legalPostalCode?: string | null,
  ssnLast4?: string | null,
  ipAddr?: string | null,
  ssnToken?: string | null,
};

export type DirectDepositAccountInput = {
  stripeToken?: string | null,
  isDefault?: boolean | null,
};

export type DirectDepositAccount = {
  __typename: "DirectDepositAccount",
  id?: string | null,
  bankName?: string | null,
  accountHolderName?: string | null,
  routingNumber?: string | null,
  last4?: string | null,
  error?: string | null,
  isDefault?: boolean | null,
};

export type ServiceAreaInput = {
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  description?: string | null,
};

export type ServiceArea = {
  __typename: "ServiceArea",
  id?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  description?: string | null,
};

export type ServiceTimeInput = {
  dayOfWeek?: string | null,
  startTime?: string | null,
  endTime?: string | null,
};

export type ServiceTime = {
  __typename: "ServiceTime",
  dayOfWeek?: string | null,
  startTime?: string | null,
  endTime?: string | null,
};

export type CouponInput = {
  couponCode?: string | null,
  couponValue?: number | null,
  paidByShopper?: number | null,
  usesPerClient?: number | null,
};

export type Coupon = {
  __typename: "Coupon",
  id?: string | null,
  couponCode?: string | null,
  couponValue?: number | null,
  paidByShopper?: number | null,
  validClientIds?: Array< string | null > | null,
  usesPerClient?: number | null,
};

export type ItemsStateInput = {
  orderId?: string | null,
  deliveryTimestamp?: string | null,
  items?: Array< ItemStateInput | null > | null,
};

export type ItemStateInput = {
  id?: string | null,
  isDone?: boolean | null,
};

export type UseTransactionsInput = {
  orderId?: string | null,
  deliveryTimestamp?: string | null,
  transactions?: Array< string | null > | null,
  images?: Array< string | null > | null,
  moreImages?: Array< string > | null,
};

export type OrderAdjustmentInput = {
  orderId?: string | null,
  deliveryTimestamp?: string | null,
  adjustmentDescription?: string | null,
  adjustmentAmount?: number | null,
};

export type OrderNotesInput = {
  orderId: string,
  deliveryTimestamp: string,
  note?: string | null,
  privateNote?: string | null,
  adminNote?: string | null,
  conciergeNote?: string | null,
};

export type OrderExternalTransactionInput = {
  orderId: string,
  deliveryTimestamp: string,
  transactionDescription: string,
  transactionAmount: number,
  image?: string | null,
  moreImages?: Array< string > | null,
};

export type OrderExternalTransactionRemovalInput = {
  orderId: string,
  deliveryTimestamp: string,
};

export type ReferralLinkInput = {
  linkType?: string | null,
  shopperId?: string | null,
  webPath?: string | null,
  meta?: string | null,
};

export type ReferralLink = {
  __typename: "ReferralLink",
  linkType?: string | null,
  shopperId?: string | null,
  webPath?: string | null,
  meta?: string | null,
  linkedShopper?: LinkedShopper | null,
};

export type LinkedShopper = {
  __typename: "LinkedShopper",
  id?: string | null,
  shopper?: Shopper | null,
  serviceOfferings?:  Array<ServiceOffering | null > | null,
  serviceArea?: ServiceArea | null,
  serviceTimes?:  Array<ServiceTime | null > | null,
};

export type LinkedShopperAndSchedule = {
  __typename: "LinkedShopperAndSchedule",
  linkedShopper?: LinkedShopper | null,
  linkedShopperSchedule?: ShopperSchedule | null,
};

export type SharedListInput = {
  listName?: string | null,
  storeName?: string | null,
};

export type SharedList = {
  __typename: "SharedList",
  id?: string | null,
  owner?: string | null,
  listId?: string | null,
  listName?: string | null,
  storeName?: string | null,
  items?:  Array<SharedListItem | null > | null,
  sharedWith?: Array< string | null > | null,
  clientId?: string | null,
  orderId?: string | null,
  orderTimestamp?: string | null,
  serviceImage?: string | null,
};

export type SharedListItem = {
  __typename: "SharedListItem",
  owner?: string | null,
  listId?: string | null,
  itemId?: string | null,
  catalogId?: string | null,
  position?: number | null,
  name?: string | null,
  image?: string | null,
  unit?: string | null,
  count?: number | null,
  note?: string | null,
  checkedOff?: boolean | null,
  checkedOffTimestamp?: string | null,
  shopperPosition?: number | null,
  shopperCheckedOff?: boolean | null,
  shopperCheckedOffTimestamp?: string | null,
  description?: string | null,
  price?: number | null,
  pricePerUnit?: number | null,
  weight?: number | null,
  weightUnit?: string | null,
  displaySize?: string | null,
  link?: string | null,
  selectedProductOptions?:  Array<SelectedProductOption | null > | null,
};

export type SelectedProductOption = {
  __typename: "SelectedProductOption",
  name: string,
  selection: string,
};

export type SharedListOperation = {
  __typename: "SharedListOperation",
  // Dictates what happened.
  operation?: string | null,
  // IDs for identifying the list, and potentially the item in question.
  owner?: string | null,
  listId?: string | null,
  itemId?: string | null,
  // Related to changing the list itself.
  listName?: string | null,
  storeName?: string | null,
  // Related to add/update/delete items.
  position?: number | null,
  name?: string | null,
  image?: string | null,
  unit?: string | null,
  count?: number | null,
  note?: string | null,
  checkedOff?: boolean | null,
  checkedOffTimestamp?: string | null,
  shopperPosition?: number | null,
  shopperCheckedOff?: boolean | null,
  shopperCheckedOffTimestamp?: string | null,
};

export type SharedListItemInput = {
  position?: number | null,
  name?: string | null,
  image?: string | null,
  unit?: string | null,
  count?: number | null,
  note?: string | null,
  checkedOff?: boolean | null,
  checkedOffTimestamp?: string | null,
  shopperPosition?: number | null,
  shopperCheckedOff?: boolean | null,
  shopperCheckedOffTimestamp?: string | null,
};

export type SharedListBulkUpdateInput = {
  owner: string,
  listId: string,
  mutationId: string,
  items?: Array< SharedListBulkItemInput | null > | null,
};

export type SharedListBulkItemInput = {
  itemId?: string | null,
  position?: number | null,
  name?: string | null,
  image?: string | null,
  unit?: string | null,
  count?: number | null,
  note?: string | null,
  checkedOff?: boolean | null,
  checkedOffTimestamp?: string | null,
  shopperPosition?: number | null,
  shopperCheckedOff?: boolean | null,
  shopperCheckedOffTimestamp?: string | null,
};

export type SharedListBulkUpdateResponse = {
  __typename: "SharedListBulkUpdateResponse",
  owner: string,
  listId: string,
  mutationId: string,
  items?:  Array<SharedListBulkItemResponse | null > | null,
};

export type SharedListBulkItemResponse = {
  __typename: "SharedListBulkItemResponse",
  itemId?: string | null,
  position?: number | null,
  name?: string | null,
  image?: string | null,
  unit?: string | null,
  count?: number | null,
  note?: string | null,
  checkedOff?: boolean | null,
  checkedOffTimestamp?: string | null,
  shopperPosition?: number | null,
  shopperCheckedOff?: boolean | null,
  shopperCheckedOffTimestamp?: string | null,
};

export type SharedListItemInput2 = {
  position?: number | null,
  name?: string | null,
  image?: string | null,
  price?: number | null,
  unit?: string | null,
  count?: number | null,
  note?: string | null,
  checkedOff?: boolean | null,
  checkedOffTimestamp?: string | null,
  shopperPosition?: number | null,
  shopperCheckedOff?: boolean | null,
  shopperCheckedOffTimestamp?: string | null,
};

export type SharedListOperation2 = {
  __typename: "SharedListOperation2",
  // Dictates what happened.
  operation?: string | null,
  // IDs for identifying the list, and potentially the item in question.
  owner?: string | null,
  listId?: string | null,
  itemId?: string | null,
  // Related to changing the list itself.
  listName?: string | null,
  storeName?: string | null,
  // Related to add/update/delete items.
  position?: number | null,
  name?: string | null,
  image?: string | null,
  unit?: string | null,
  count?: number | null,
  note?: string | null,
  checkedOff?: boolean | null,
  checkedOffTimestamp?: string | null,
  shopperPosition?: number | null,
  shopperCheckedOff?: boolean | null,
  shopperCheckedOffTimestamp?: string | null,
  description?: string | null,
  price?: number | null,
  pricePerUnit?: number | null,
  weight?: number | null,
  weightUnit?: string | null,
  displaySize?: string | null,
  link?: string | null,
};

export type ProductV3Result = {
  __typename: "ProductV3Result",
  id?: string | null,
  dumplingId?: string | null,
  sellerName?: string | null,
  name?: string | null,
  // The store's own unique ID for the product. This could be the SKU.
  sellerId?: string | null,
  available?: boolean | null,
  allowed?: boolean | null,
  // The description of the item should _not_ contain HTML entities or tags.
  description?: string | null,
  upc?: string | null,
  // A 2D array of category paths. Each sub-array is a unique, hierarchical path to the item.
  categories?: Array< string | null > | null,
  price?: number | null,
  salePrice?: number | null,
  clubPrice?: number | null,
  // This is the price per unit (in cents) that this item is measured in.
  pricePerUnit?: number | null,
  salePricePerUnit?: number | null,
  // Sale prices may have effective date range
  // saleStartDate: String
  // saleEndDate: String
  // Either EACH or WEIGHT
  unitType?: string | null,
  // A human-readable unit that this item is weighed or measured by.
  weightUnit?: string | null,
  // If available, the weight or measure of the item specified by `weightUnit`
  weight?: number | null,
  // If provided by the seller, how they represent the size info of a product.
  displaySize?: string | null,
  // A URL of the item image hosted by the store (not our own server).
  imageLink?: string | null,
  // A URL of the item image hosted in our own S3 bucket.
  image?: string | null,
  link?: string | null,
  // This field is only used to convey the note field on the past items screen.
  note?: string | null,
  attributedMedia:  Array<AttributedMedia >,
};

export type AttributedMedia = {
  __typename: "AttributedMedia",
  media?: Media | null,
  sourceUrl: string,
  hostPageUrl?: string | null,
  hostPageName?: string | null,
};

export type Media = MediaImage


export type MediaImage = {
  __typename: "MediaImage",
  small?: SizedMediaImage | null,
  medium?: SizedMediaImage | null,
  large?: SizedMediaImage | null,
  xlarge?: SizedMediaImage | null,
  full: SizedMediaImage,
};

export type SizedMediaImage = {
  __typename: "SizedMediaImage",
  width?: number | null,
  height?: number | null,
  path: string,
  mimeType?: string | null,
};

export type ClientReviewInput = {
  id?: string | null,
  quote?: string | null,
  date?: string | null,
  rating?: number | null,
  clientName?: string | null,
  clientImage?: string | null,
  pinned?: boolean | null,
  hidden?: boolean | null,
};

export type ClientReview = {
  __typename: "ClientReview",
  id?: string | null,
  quote?: string | null,
  date?: string | null,
  rating?: number | null,
  clientName?: string | null,
  clientImage?: string | null,
  pinned?: boolean | null,
  hidden?: boolean | null,
};

export type ConnectToClientAccountResult = {
  __typename: "ConnectToClientAccountResult",
  success?: boolean | null,
  message?: string | null,
};

export type SosIssue = {
  __typename: "SosIssue",
  reason?: string | null,
  note?: string | null,
  orderId?: string | null,
  deliveryTimestamp?: string | null,
};

export type AutoMessageInput = {
  message?: string | null,
  delaySeconds?: number | null,
  enabled?: boolean | null,
};

export type AutoMessage = {
  __typename: "AutoMessage",
  id?: string | null,
  type?: string | null,
  title?: string | null,
  action?: string | null,
  message?: string | null,
  defaultMessage?: string | null,
  description?: string | null,
  enabled?: boolean | null,
  delaySeconds?: number | null,
  defaultDelaySeconds?: number | null,
};

export type ListDetails = {
  __typename: "ListDetails",
  id: string,
  savedListId?: string | null,
  listName: string,
  listVersion: string,
  storeName: string,
  storeId: string,
  items:  Array<ListProduct >,
  estimatedTotal: EstimatedTotal,
  estimatedCheckoutTotal: EstimatedTotal,
};

export type ListProduct = {
  __typename: "ListProduct",
  id: string,
  catalogId?: string | null,
  media:  Array<ProductMedia >,
  attributedMedia:  Array<AttributedMedia >,
  count: number,
  note?: string | null,
  isCustom?: boolean | null,
  name: string,
  priceCents?: number | null,
  displayPrice: string,
  salePriceCents?: number | null,
  saleDisplayPrice?: string | null,
  position: number,
  category: string,
  categoryEmoji: string,
  displayUnit?: string | null,
  referenceLink: string,
  deleted: boolean,
  available: boolean,
  lastUpdatedTimestamp: string,
  shopperNote?: string | null,
  createdByShopperId?: string | null,
  shopperPosition?: number | null,
  shopperCategoryPosition?: number | null,
  shopperCheckedOff: boolean,
  shopperCheckedOffTimestamp: string,
  shopperNotAvailable: boolean,
  selectedProductOptions?:  Array<SelectedProductOption | null > | null,
  packageLineItems?:  Array<PackageLineItem | null > | null,
};

export type ProductMedia = ProductImage | ProductVideo


export type ProductImage = {
  __typename: "ProductImage",
  imageUrl: string,
};

export type ProductVideo = {
  __typename: "ProductVideo",
  videoUrl: string,
};

export type PackageLineItem = {
  __typename: "PackageLineItem",
  productId: string,
  name: string,
  quantity: number,
  note: string,
  selectedProductOptions:  Array<SelectedProductOption >,
};

export type EstimatedTotal = {
  __typename: "EstimatedTotal",
  id: string,
  displayPrice: string,
};

export type ItemPropertiesInput = {
  image?: string | null,
  count?: number | null,
  note?: string | null,
  name?: string | null,
  price?: number | null,
  category?: string | null,
  shopperPosition?: number | null,
  shopperCheckedOff?: boolean | null,
  shopperCheckedOffTimestamp?: string | null,
  shopperNote?: string | null,
  shopperNotAvailable?: boolean | null,
  attributedMedia?: AttributedMediaInput | null,
  id?: string | null,
};

export type AttributedMediaInput = {
  media?: MediaImageInput | null,
  sourceUrl: string,
  hostPageUrl?: string | null,
  hostPageName?: string | null,
};

export type MediaImageInput = {
  small?: SizedMediaImageInput | null,
  medium?: SizedMediaImageInput | null,
  large?: SizedMediaImageInput | null,
  xlarge?: SizedMediaImageInput | null,
  full: SizedMediaImageInput,
};

export type SizedMediaImageInput = {
  width?: number | null,
  height?: number | null,
  path: string,
  mimeType?: string | null,
};

export type ListProductMutationResult = {
  __typename: "ListProductMutationResult",
  product: ListProduct,
  listVersion: string,
  listEstimatedTotal: EstimatedTotal,
  listEstimatedCheckoutTotal: EstimatedTotal,
};

export type ItemChanges = {
  itemId: string,
  itemChanges: ItemPropertiesInput,
};

export type OrderDeliveryChangesInput = {
  deliveryWindow?: DeliveryWindowInput | null,
  deliveryAddress?: DeliveryAddressInput | null,
};

export type DeliveryWindowInput = {
  startDateTime: string,
  endDateTime: string,
};

export type LinkedClientAnnotationsInput = {
  note?: string | null,
  image?: string | null,
  sawClientPreferences?: boolean | null,
};

export type CreateInstantPayoutAccountInput = {
  stripeToken: string,
  isDefault: boolean,
  confirmId?: string | null,
  confirmCode?: string | null,
};

// Intentionally using two possible outputs
// When Input does not contain `confirmId` or `confirmCode`, response will be InstantPayoutAccountConfirmation
// With the `confirmId` in the InstantPayoutAccountConfirmation response AND `confirmCode` provided by the Boss, response will be InstantPayoutAccount
// union InstantPayoutAccountResponse = InstantPayoutAccount | InstantPayoutAccountConfirmation
export type InstantPayoutAccountResponse = InstantPayoutAccount


export type InstantPayoutAccount = {
  __typename: "InstantPayoutAccount",
  id: string,
  brand?: string | null,
  expirationMonth?: number | null,
  expirationYear?: number | null,
  last4?: string | null,
  isDefault: boolean,
  isVerified: boolean,
};

export type UpdateInstantPayoutAccountInput = {
  isDefault: boolean,
};

export type InstantPayoutInput = {
  accountId: string,
  balance: number,
  fee: number,
  amount: number,
};

export type InstantPayout = {
  __typename: "InstantPayout",
  id: string,
  balance: number,
  fee: number,
  amount: number,
  arrivalTimestamp: number,
  status: string,
};

export type CartResponse = {
  __typename: "CartResponse",
  cart: Cart,
  errors?:  Array<CartError > | null,
};

export type Cart = {
  __typename: "Cart",
  id: string,
  type: CartType,
  clientId?: string | null,
  shopper?: CartShopper | null,
  deliveryTimeSlot?: AvailableTimeSlot | null,
  preTip?: ChosenPreTip | null,
  note?: string | null,
  services?:  Array<ServiceLists > | null,
  pricingModel?: PricingModel | null,
  paymentMethod?: PaymentMethod | null,
  deliveryAddress?: Address | null,
  appliedPromos?:  Array<PromoDetails > | null,
  estimatedTotals?:  Array<CartTotalLine > | null,
  createdOn: string,
  lastUpdated: string,
};

export enum CartType {
  STANDARD = "STANDARD",
  COUPON = "COUPON",
  PIGGYBACK = "PIGGYBACK",
}


export type CartShopper = {
  __typename: "CartShopper",
  id: string,
  image?: string | null,
  displayName?: string | null,
  isPro: boolean,
  clientCount: number,
  repeatClientCount: number,
};

export type AvailableTimeSlot = {
  __typename: "AvailableTimeSlot",
  id: string,
  slotStartIso: string,
  slotEndIso: string,
  slotStart?: number | null,
  slotEnd?: number | null,
  maxOrders?: number | null,
  scheduledOrders?: number | null,
  bufferDuration: number,
  bufferMode: BufferMode,
  isAvailable?: boolean | null,
  inBuffer: boolean,
  inTimeSlot: boolean,
  availablePromos?:  Array<PromoDetails > | null,
};

export type PromoDetails = {
  __typename: "PromoDetails",
  id: string,
  type: PromoType,
  code: string,
  displayName?: string | null,
  discountFixed?: number | null,
  discountPercent?: number | null,
};

export enum PromoType {
  COUPON = "COUPON",
  PIGGYBACK = "PIGGYBACK",
}


export type ChosenPreTip = {
  __typename: "ChosenPreTip",
  percent?: number | null,
  fixed?: number | null,
};

export type ServiceLists = {
  __typename: "ServiceLists",
  id: string,
  serviceName: string,
  serviceImage?: string | null,
  listIds: Array< string >,
};

export type CartTotalLine = {
  __typename: "CartTotalLine",
  type: CartTotalLineType,
  label: string,
  value: string,
};

export enum CartTotalLineType {
  GRAND_TOTAL = "GRAND_TOTAL",
  GROCERIES = "GROCERIES",
  SHOPPING_AND_DELIVERY = "SHOPPING_AND_DELIVERY",
  GRATUITY = "GRATUITY",
  PLATFORM_FEE = "PLATFORM_FEE",
  COUPON = "COUPON",
}


export type CartError = {
  __typename: "CartError",
  code: CartErrorCode,
  message: string,
};

export enum CartErrorCode {
  SHOPPER_NOT_AVAILABLE = "SHOPPER_NOT_AVAILABLE",
  TIMESLOT_NOT_AVAILABLE = "TIMESLOT_NOT_AVAILABLE",
  TIMESLOT_CHANGED = "TIMESLOT_CHANGED",
  CART_ALREADY_EXISTS = "CART_ALREADY_EXISTS",
  DELIVERY_ADDRESS_NOT_FOUND = "DELIVERY_ADDRESS_NOT_FOUND",
  PAYMENT_METHOD_NOT_FOUND = "PAYMENT_METHOD_NOT_FOUND",
  PROMO_NOT_FOUND = "PROMO_NOT_FOUND",
  INVALID_PROMO = "INVALID_PROMO",
}


export type CartInput = {
  deliveryAddressId?: string | null,
  paymentMethodId?: string | null,
  appliedPromoIds?: Array< string > | null,
  listIds?: Array< string > | null,
  preTip?: ChosenPreTipInput | null,
  deliveryTimeSlot?: AvailableTimeSlotInput | null,
  note?: string | null,
};

export type ChosenPreTipInput = {
  percent?: number | null,
  fixed?: number | null,
};

export type AvailableTimeSlotInput = {
  id: string,
  slotStartIso: string,
  slotEndIso: string,
  slotStart?: number | null,
  slotEnd?: number | null,
  maxOrders?: number | null,
  scheduledOrders?: number | null,
  bufferDuration: number,
  bufferMode: BufferMode,
  isAvailable?: boolean | null,
  inBuffer: boolean,
  inTimeSlot: boolean,
  availablePromos?: Array< string > | null,
};

export type ShopperFundingInfo = {
  __typename: "ShopperFundingInfo",
  id?: string | null,
  fundingProfile?: string | null,
  merchantCategoryId?: number | null,
  transactionLimit?: number | null,
  dailySpendLimit?: number | null,
  dailySpendLimitCeiling?: number | null,
  virtualBalance?: number | null,
  todaysSpend?: number | null,
  fundingPerOrder?: number | null,
};

export type TransactionFullInput = {
  ignore?: boolean | null,
};

export type TransactionFull = {
  __typename: "TransactionFull",
  id?: string | null,
  update_time?: string | null,
  merchantName?: string | null,
  merchantCity?: string | null,
  merchantState?: string | null,
  merchantZip?: string | null,
  merchantCountry?: string | null,
  merchantLocalTime?: string | null,
  transactionUtcTime?: string | null,
  transactionAmount?: number | null,
  image?: string | null,
  ignore?: boolean | null,
};

export type SyntheticTransactionInput = {
  merchantName?: string | null,
  merchantCity?: string | null,
  merchantState?: string | null,
  merchantZip?: string | null,
  merchantCountry?: string | null,
  merchantLocalTime?: string | null,
  transactionAmount?: number | null,
  image?: string | null,
};

export type AssignLinkedOrdersToInput = {
  buddyIds: Array< string >,
  linkedOrderIdentifiers: Array< LinkedOrderIdentifiersInput >,
};

export type PaginatedOrders = {
  __typename: "PaginatedOrders",
  orders?:  Array<Order | null > | null,
  nextToken?: string | null,
  prevToken?: string | null,
  pageNumber?: number | null,
};

export type ResortClosedDate = {
  __typename: "ResortClosedDate",
  id: string,
  date: string,
};

export type ForgotPasswordStatus = {
  __typename: "ForgotPasswordStatus",
  status?: boolean | null,
};

export type GlobalLogoutUserStatus = {
  __typename: "GlobalLogoutUserStatus",
  status?: boolean | null,
};

export type CardFunding = {
  __typename: "CardFunding",
  userId: string,
  fundingCents: number,
};

export type UserRemapping = {
  __typename: "UserRemapping",
  userId: string,
  phoneNumber?: string | null,
  email?: string | null,
  type?: string | null,
  expiresAt?: string | null,
};

export type ProposedCartInput = {
  shopperId?: string | null,
  serviceName?: string | null,
  deliveryDate?: string | null,
  deliveryTime?: string | null,
  promoCode?: string | null,
};

export type PaginatedAddresses = {
  __typename: "PaginatedAddresses",
  addresses?:  Array<Address | null > | null,
  nextToken?: string | null,
};

export type AddressSearchResult = {
  __typename: "AddressSearchResult",
  lat: number,
  lon: number,
  addressLine1: string,
  addressLine2?: string | null,
  city: string,
  state: string,
  zipcode: string,
  country: string,
  freeForm: string,
};

export type PaginatedPaymentMethods = {
  __typename: "PaginatedPaymentMethods",
  paymentMethods?:  Array<PaymentMethod | null > | null,
  nextToken?: string | null,
};

export type PaginatedPastOrderLists = {
  __typename: "PaginatedPastOrderLists",
  pastOrderLists:  Array<PastOrderList >,
  nextToken?: string | null,
};

export type PastOrderList = {
  __typename: "PastOrderList",
  title: string,
  deliveryTimestamp?: string | null,
  categorizedListProducts:  Array<CategorizedListProducts >,
};

export type CategorizedListProducts = {
  __typename: "CategorizedListProducts",
  category: string,
  categoryEmoji: string,
  listProducts:  Array<ListProduct >,
};

export type PaginatedSharedOrders = {
  __typename: "PaginatedSharedOrders",
  sharedOrders?:  Array<SharedOrder | null > | null,
  nextToken?: string | null,
};

export type SharedOrder = {
  __typename: "SharedOrder",
  version?: string | null,
  id?: string | null,
  clientId?: string | null,
  shopperId?: string | null,
  // These next five fields are dynamically added to the lookup when doing linkedOrders.
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  email?: string | null,
  clientImage?: string | null,
  orderStatus?: string | null,
  orderDateTime?: string | null,
  orderTimestamp?: string | null,
  deliveryDate?: string | null,
  deliveryTime?: string | null,
  deliveryTimestamp?: string | null,
  deliveryAddress?: Address | null,
  orderPaymentMethod?: PaymentMethod | null,
  serviceRequestList?:  Array<ServiceRequest | null > | null,
  pricingModel?: PricingModel | null,
  tip?: number | null,
  deliveryFee?: number | null,
  transactions?: Array< string | null > | null,
  couponCode?: string | null,
  adjustmentDescription?: string | null,
  adjustmentAmount?: number | null,
  lineItems?: LineItems | null,
  // rating
  // testimonial
  sharedListIdentifiers?:  Array<SharedListIdentifier | null > | null,
};

export type Identity = {
  __typename: "Identity",
  firstName?: string | null,
  lastName?: string | null,
  dob?: string | null,
  phone?: string | null,
  email?: string | null,
  addressLine1?: string | null,
  addressLine2?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  ssn?: string | null,
  completed?: boolean | null,
};

export type ShopperBusinessProfile = {
  __typename: "ShopperBusinessProfile",
  shopper?: Shopper | null,
  serviceOfferings?:  Array<ServiceOffering | null > | null,
};

export type PaginatedChargeCards = {
  __typename: "PaginatedChargeCards",
  chargeCards?:  Array<ChargeCard | null > | null,
  nextToken?: string | null,
};

export type ShopperClosedDateRangesInput = {
  utcOffset?: number | null,
  startDate?: string | null,
  endDate?: string | null,
};

export type ShopperAvailableScheduleInput = {
  utcOffset?: number | null,
  startDate?: string | null,
  numDays?: number | null,
  cartId?: string | null,
};

export type ShopperAvailableSchedule = {
  __typename: "ShopperAvailableSchedule",
  firstAvailableDayIndex?: number | null,
  firstAvailableTimeSlotOfDayIndex?: number | null,
  dailyAvailableSchedules?:  Array<DailyAvailableSchedule | null > | null,
};

export type DailyAvailableSchedule = {
  __typename: "DailyAvailableSchedule",
  day?: string | null,
  date?: string | null,
  isClosed?: boolean | null,
  availableTimeSlots?:  Array<AvailableTimeSlot | null > | null,
};

export type PaginatedServiceTimes = {
  __typename: "PaginatedServiceTimes",
  serviceTimes?:  Array<ServiceTime | null > | null,
  nextToken?: string | null,
};

export type PaginatedLinkedClients = {
  __typename: "PaginatedLinkedClients",
  linkedClients?:  Array<LinkedClient | null > | null,
  nextToken?: string | null,
};

export type QuerySortInput = {
  property: string,
  direction: SortDirection,
};

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type QueryFilterInput = {
  operator: FilterOperator,
  property: string,
  values: Array< string >,
};

export enum FilterOperator {
  EQ = "EQ",
  NE = "NE",
  IN = "IN",
  NIN = "NIN",
  LT = "LT",
  LTE = "LTE",
  GT = "GT",
  GTE = "GTE",
  ANY = "ANY",
  ALL = "ALL",
}


export type QuerySortFilterOptions = {
  __typename: "QuerySortFilterOptions",
  sortOptions:  Array<QuerySortOption >,
  filterOptions:  Array<QueryFilterOption >,
};

export type QuerySortOption = {
  __typename: "QuerySortOption",
  name: string,
  property: string,
};

export type QueryFilterOption = {
  __typename: "QueryFilterOption",
  name: string,
  property: string,
  type: FilterType,
};

export type FilterType = DateRangeFilterType | IntRangeFilterType | ChoiceFilterType | BooleanFilterType


export type DateRangeFilterType = {
  __typename: "DateRangeFilterType",
  minTimestamp?: string | null,
  // smallest timestamp we let them pick (null = no min)
  maxTimestamp?: string | null,
};

export type IntRangeFilterType = {
  __typename: "IntRangeFilterType",
  minRange?: number | null,
  // smallest number we let them pick (null = no min)
  minValue?: number | null,
  // smallest number of all possible values (null = unknown)
  maxRange?: number | null,
  // largest number we let them pick (null = no max)
  maxValue?: number | null,
};

export type ChoiceFilterType = {
  __typename: "ChoiceFilterType",
  options:  Array<ChoiceFilterTypeOption >,
  isRadioButton: boolean,
};

export type ChoiceFilterTypeOption = {
  __typename: "ChoiceFilterTypeOption",
  name: string,
  property: string,
};

export type BooleanFilterType = {
  __typename: "BooleanFilterType",
  name: string,
};

export type QuerySortFilterPreset = {
  __typename: "QuerySortFilterPreset",
  name: string,
  description?: string | null,
  sort?: QuerySort | null,
  filters:  Array<QueryFilter >,
  children:  Array<QuerySortFilterPreset >,
};

export type QuerySort = {
  __typename: "QuerySort",
  property: string,
  direction: SortDirection,
};

export type QueryFilter = {
  __typename: "QueryFilter",
  operator: FilterOperator,
  property: string,
  values: Array< string >,
};

export type PaginatedDirectDepositAccounts = {
  __typename: "PaginatedDirectDepositAccounts",
  directDepositAccounts?:  Array<DirectDepositAccount | null > | null,
  nextToken?: string | null,
};

export type ServiceOfferingListItem = {
  __typename: "ServiceOfferingListItem",
  id?: string | null,
  serviceName?: string | null,
  serviceImage?: string | null,
};

export type PaginatedCoupons = {
  __typename: "PaginatedCoupons",
  coupons?:  Array<Coupon | null > | null,
  nextToken?: string | null,
};

export type PaginatedTransactions = {
  __typename: "PaginatedTransactions",
  transactions?:  Array<Transaction | null > | null,
  nextToken?: string | null,
};

export type Transaction = {
  __typename: "Transaction",
  id?: string | null,
  update_time?: string | null,
  merchantName?: string | null,
  merchantCity?: string | null,
  merchantState?: string | null,
  merchantZip?: string | null,
  merchantCountry?: string | null,
  merchantLocalTime?: string | null,
  transactionUtcTime?: string | null,
  transactionAmount?: number | null,
  image?: string | null,
  last4?: string | null,
  moreImages?: Array< string > | null,
};

export type PresignedPostUrlAndUrl = {
  __typename: "PresignedPostUrlAndUrl",
  presignedPostUrl?: string | null,
  presignedPostUrlFields?: string | null,
  url?: string | null,
};

export type TransactionPresignedPostUrlAndUrl = {
  __typename: "TransactionPresignedPostUrlAndUrl",
  fileName?: string | null,
  presignedPostUrl?: string | null,
  presignedPostUrlFields?: string | null,
  url?: string | null,
};

export type Profile = {
  __typename: "Profile",
  userId?: string | null,
  phone?: string | null,
};

export type PaginatedSharedListIdentifiers = {
  __typename: "PaginatedSharedListIdentifiers",
  sharedListIdentifiers?:  Array<SharedListIdentifier | null > | null,
  nextToken?: string | null,
};

export type ImageLinkResults = {
  __typename: "ImageLinkResults",
  text?: string | null,
  timestamp?: string | null,
  results?:  Array<ImageLinkResult | null > | null,
};

export type ImageLinkResult = {
  __typename: "ImageLinkResult",
  image?: string | null,
  text?: string | null,
};

export type ProductDetails = {
  __typename: "ProductDetails",
  id: string,
  product: Product,
  note?: string | null,
  quantity?: number | null,
};

export type Product = {
  __typename: "Product",
  id: string,
  name: string,
  // The description of the item __cannot__ contain HTML entities or tags.
  description?: string | null,
  // A 2D array of category paths. Each sub-array is a unique, hierarchical path to the item.
  categories?: Array< string > | null,
  price?: ProductPrice | null,
  salePrice?: ProductPrice | null,
  displaySize?: string | null,
  media:  Array<Media | null >,
  link?: string | null,
  isCustom: boolean,
};

export type ProductPrice = {
  __typename: "ProductPrice",
  cents: number,
  text: string,
};

export type StreamToken = {
  __typename: "StreamToken",
  token: string,
};

export enum SearchResultsSortOptionType {
  PRICE_ASCENDING = "PRICE_ASCENDING",
  PRICE_DESCENDING = "PRICE_DESCENDING",
  NAME_ASCENDING = "NAME_ASCENDING",
}


export type ProductV3Results = {
  __typename: "ProductV3Results",
  store?: string | null,
  category?: string | null,
  text?: string | null,
  results?:  Array<ProductV3Result | null > | null,
  categories: Array< string >,
};

export type ProductV3StoreCategories = {
  __typename: "ProductV3StoreCategories",
  store?: string | null,
  categories?: Array< string | null > | null,
};

export enum GenericProductResultsGroupType {
  CURRENT_ORDER = "CURRENT_ORDER",
  PAST_ORDER = "PAST_ORDER",
  SITE = "SITE",
  GENERIC_GROCERY = "GENERIC_GROCERY",
  IMAGE = "IMAGE",
  CATALOG_GROCERY = "CATALOG_GROCERY",
}


export type GenericProductResultsGroup = {
  __typename: "GenericProductResultsGroup",
  store: string,
  title: string,
  subTitle?: string | null,
  description?: string | null,
  externalUrl?: string | null,
  internalUrl?: string | null,
  type: GenericProductResultsGroupType,
  results?:  Array<ProductV3Result | null > | null,
};

export type PaginatedClientReviews = {
  __typename: "PaginatedClientReviews",
  clientReviews?:  Array<ClientReview | null > | null,
  nextToken?: string | null,
};

export type PaginatedShopperGeoSearchResults = {
  __typename: "PaginatedShopperGeoSearchResults",
  announcement?: string | null,
  shoppers?:  Array<Shopper | null > | null,
  nextToken?: string | null,
};

export type ShopperDetails = {
  __typename: "ShopperDetails",
  // This ID is the ID inside of shopper.
  id?: string | null,
  shopper?: Shopper | null,
  serviceOfferings?:  Array<ServiceOffering | null > | null,
  shopperSchedule?: ShopperSchedule | null,
};

export type EstimatedCartTotal = {
  __typename: "EstimatedCartTotal",
  owner?: string | null,
  listId?: string | null,
  snapshotId?: string | null,
  cartTotalLines?:  Array<EstimatedCartTotalLine | null > | null,
  cartTotal?: EstimatedCartTotalLine | null,
};

export type EstimatedCartTotalLine = {
  __typename: "EstimatedCartTotalLine",
  count?: number | null,
  label?: string | null,
  value?: string | null,
};

export type EstimatedOrderTotal = {
  __typename: "EstimatedOrderTotal",
  deliveryFee?: number | null,
  tip?: number | null,
  couponCode?: string | null,
  owner?: string | null,
  listId?: string | null,
  snapshotId?: string | null,
  orderTotalLines?:  Array<EstimatedOrderTotalLine | null > | null,
  orderCoupon?: EstimatedOrderTotalLine | null,
  orderTotal?: EstimatedOrderTotalLine | null,
  authValue?: string | null,
};

export type EstimatedOrderTotalLine = {
  __typename: "EstimatedOrderTotalLine",
  label?: string | null,
  value?: string | null,
  icon?: IconType | null,
};

export enum IconType {
  HEART = "HEART",
  SHOPPING_CART = "SHOPPING_CART",
  DUMPLING = "DUMPLING",
}


export type OrderPreviewInput = {
  shopperId: string,
  serviceId: string,
  owner: string,
  listId: string,
  coupon?: string | null,
  chosenPercent?: string | null,
  chosenFixedGratuity?: number | null,
  deliveryDate?: string | null,
  deliveryTime?: string | null,
};

export type PostTip = {
  __typename: "PostTip",
  baseDisplayAmount?: string | null,
};

export type PostTipReference = {
  __typename: "PostTipReference",
  orderId?: string | null,
  clientId?: string | null,
  orderTimestamp?: string | null,
};

export type PostTipInfo = {
  __typename: "PostTipInfo",
  orderId?: string | null,
  clientId?: string | null,
  orderTimestamp?: string | null,
  orderTotal?: number | null,
  preTipAmount?: string | null,
  shopperDisplayName?: string | null,
  shopperImage?: string | null,
  serviceName?: string | null,
  serviceImage?: string | null,
};

export type OrderPostGratuityAndReviewInfo = {
  __typename: "OrderPostGratuityAndReviewInfo",
  showPostGratuity: boolean,
  showReview: boolean,
  order: Order,
  baseAmount: number,
  defaultPaymentMethod?: PaymentMethod | null,
  gratuityType: GratuityType,
  gratuityOptions: Array< number >,
};

export type OrderPostGratuityInfo = {
  __typename: "OrderPostGratuityInfo",
  order: Order,
  baseAmount: number,
  defaultPaymentMethod?: PaymentMethod | null,
  gratuityType: GratuityType,
  gratuityOptions: Array< number >,
};

export type BossPlan = {
  __typename: "BossPlan",
  id?: string | null,
  // Starter, Legacy Starter, Pro, Legacy Pro, Tycoon
  title?: string | null,
  // Probably be same as id.
  description?: string | null,
  // blah
  cost?: string | null,
  // This is just the money portion e.g "$99"
  interval?: string | null,
  // e.g. Month, Week, Year, etc.  ... probably just Month
  mostPopular?: boolean | null,
};

export type BossPlanPreview = {
  __typename: "BossPlanPreview",
  title?: string | null,
  // "Changing your plan"
  description?: string | null,
  // "Are you sure you want to move from X to Y" In case a legacy plan is being abandoned it would be mentioned here.
  breakdown?:  Array<KeyValue | null > | null,
  cta?: string | null,
  paymentRequired?: boolean | null,
};

export type PaginatedPayouts = {
  __typename: "PaginatedPayouts",
  futurePayoutAmount?: string | null,
  payouts?:  Array<Payout | null > | null,
  nextToken?: string | null,
};

export type Payout = {
  __typename: "Payout",
  id?: string | null,
  amount?: string | null,
  status?: string | null,
  arrivalTimestamp?: string | null,
};

export type BossPayoutDetails = {
  __typename: "BossPayoutDetails",
  id?: string | null,
  header?:  Array<KeyValue | null > | null,
  payments?:  Array<BossPayment | null > | null,
};

export type BossPayment = {
  __typename: "BossPayment",
  id?: string | null,
  // payment ID
  amount?: string | null,
  client?: string | null,
  date?: string | null,
  orderId?: string | null,
  deliveryTimestamp?: string | null,
  postTip?: boolean | null,
};

export type InsightsBasic = {
  __typename: "InsightsBasic",
  profileImage: string,
  ratings: InsightsRatings,
  trends: InsightsTrends,
};

export type InsightsRatings = {
  __typename: "InsightsRatings",
  score: string,
  // e.g 4.6/5
  reviewCount: number,
  reviewCountBreakdown: Array< number >,
};

export type InsightsTrends = {
  __typename: "InsightsTrends",
  charts:  Array<InsightsChart >,
};

export type InsightsChart = {
  __typename: "InsightsChart",
  tab: string,
  // e.g Earnings, Orders
  maxBarHeight: number,
  // e.g 2000
  bars:  Array<InsightsBar >,
};

export type InsightsBar = {
  __typename: "InsightsBar",
  xLabel: string,
  // e.g JUN
  barLabel: string,
  // e.g $1,532
  barHeight: number,
};

export type InsightsMetrics = {
  __typename: "InsightsMetrics",
  tab: string,
  // e.g 4w, 3m, etc
  dateRange: string,
  // e.g Aug 11 - Sept 2, 2020
  earnings: string,
  // e.g. $1,234,567
  orderCount: number,
  clientCount: number,
  repeatClientCount: number,
};

export type StripeAccountVerifyLink = {
  __typename: "StripeAccountVerifyLink",
  url?: string | null,
  expiresAt?: string | null,
};

export type PaginatedAutoMessages = {
  __typename: "PaginatedAutoMessages",
  autoMessages?:  Array<AutoMessage | null > | null,
  nextToken?: string | null,
};

export type AvailableUpdate = {
  __typename: "AvailableUpdate",
  isRequired: boolean,
  availableVersion: string,
  note: string,
  infoUrl?: string | null,
};

export type PaginatedListReferences = {
  __typename: "PaginatedListReferences",
  nextToken?: string | null,
  listReferences:  Array<ListReference >,
};

export type CardFundingOrder = {
  __typename: "CardFundingOrder",
  userId: string,
  orderId: string,
  deliveryTimestamp: string,
  fundingCents: number,
  fundingDisplayCents: string,
  fundingDisplayDollars: string,
  fundingStatus: string,
  fundingWarning?: string | null,
  contactMessage?: string | null,
  displayFunding: boolean,
};

export type AvailableStores = {
  __typename: "AvailableStores",
  displayShopperFee?: boolean | null,
  displayRequestFee?: boolean | null,
  displayRequestBanner?: boolean | null,
  disclaimer: string,
  storesSections:  Array<StoresSection >,
};

export type StoresSection = {
  __typename: "StoresSection",
  title: string,
  description?: string | null,
  storeReferences:  Array<StoreReference >,
};

export type StoreReference = {
  __typename: "StoreReference",
  storeImage: string,
  storeName: string,
  id: string,
  storeReferencePricing?: StoreReferencePricing | null,
};

export type StoreReferencePricing = {
  __typename: "StoreReferencePricing",
  type: StorePriceType,
  price: string,
};

export enum StorePriceType {
  Special = "Special",
  Shopper = "Shopper",
}


export type Store = {
  __typename: "Store",
  name: string,
  image: string,
  id: string,
  disclaimer?: string | null,
  isCustom?: boolean | null,
};

export type SearchTermResult = SearchTermAutocompleteResult | SearchTermAutosuggestResult | SearchTermProductResult | SearchTermInCategoryResult


export type SearchTermAutocompleteResult = {
  __typename: "SearchTermAutocompleteResult",
  completedTerm: string,
};

export type SearchTermAutosuggestResult = {
  __typename: "SearchTermAutosuggestResult",
  suggestedTerm: string,
};

export type SearchTermProductResult = {
  __typename: "SearchTermProductResult",
  name: string,
  itemId: string,
};

export type SearchTermInCategoryResult = {
  __typename: "SearchTermInCategoryResult",
  name: string,
  breadcrumbs: Array< string >,
};

export type ShopperSupportedStores = {
  __typename: "ShopperSupportedStores",
  supportedStores:  Array<StoreReference >,
  unsupportedStores:  Array<StoreReference >,
};

export type ShopperAvailability = {
  __typename: "ShopperAvailability",
  id?: string | null,
  shopperAvailabilityDays:  Array<ShopperDayAvailability >,
};

export type ShopperDayAvailability = {
  __typename: "ShopperDayAvailability",
  dayOfWeekType: DayOfWeekType,
  shopperAvailabilityType: ShopperAvailabilityType,
};

export enum DayOfWeekType {
  Sunday = "Sunday",
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
}


export enum ShopperAvailabilityType {
  Closed = "Closed",
  Open = "Open",
  FullyBooked = "FullyBooked",
}


export type ListNotice = {
  __typename: "ListNotice",
  id: string,
  type: ListNoticeType,
  title: string,
  body: string,
};

export enum ListNoticeType {
  OpenOrder = "OpenOrder",
  OtherOpenOrder = "OtherOpenOrder",
}


export type ShopperAvailabilityDescription = {
  __typename: "ShopperAvailabilityDescription",
  id?: string | null,
  description: string,
};

export type SearchOptions = {
  __typename: "SearchOptions",
  id: string,
  categories:  Array<ProductCategory >,
  sort:  Array<SearchResultsSortOption >,
};

export type ProductCategory = {
  __typename: "ProductCategory",
  name: string,
  breadcrumbs: Array< string >,
  children?:  Array<ProductCategory > | null,
  image?: string | null,
  categoryEmoji: string,
};

export type SearchResultsSortOption = {
  __typename: "SearchResultsSortOption",
  name: string,
  type: SearchResultsSortOptionType,
};

export type StoreListActions = {
  __typename: "StoreListActions",
  id: string,
  actions:  Array<ListAction >,
};

export type ListAction = SearchStoreListAction | BrowseListAction | BuyAgainListAction | AddItemsListAction | PastItemsListAction | FilterListAction | SavedItemsListAction | BrowseStoreListAction


export type SearchStoreListAction = {
  __typename: "SearchStoreListAction",
  name: string,
  buyAgainBreadcrumbs?: Array< string > | null,
};

export type BrowseListAction = {
  __typename: "BrowseListAction",
  name: string,
  buyAgainBreadcrumbs?: Array< string > | null,
};

export type BuyAgainListAction = {
  __typename: "BuyAgainListAction",
  name: string,
  breadcrumbs: Array< string >,
};

export type AddItemsListAction = {
  __typename: "AddItemsListAction",
  name: string,
};

export type PastItemsListAction = {
  __typename: "PastItemsListAction",
  name: string,
  breadcrumbs: Array< string >,
};

export type FilterListAction = {
  __typename: "FilterListAction",
  name: string,
  breadcrumbs: Array< string >,
  sortType?: SearchResultsSortOptionType | null,
};

export type SavedItemsListAction = {
  __typename: "SavedItemsListAction",
  name: string,
  listId: string,
  listItemCount: number,
};

export type BrowseStoreListAction = {
  __typename: "BrowseStoreListAction",
  name: string,
};

export type ProductCarouselList = {
  __typename: "ProductCarouselList",
  id: string,
  carousels:  Array<ProductCarousel >,
};

export type ProductCarousel = {
  __typename: "ProductCarousel",
  id: string,
  name: string,
  products:  Array<ProductV3Result | null >,
  action?: ProductCarouselAction | null,
};

export type ProductCarouselAction = ProductFilterAction


export type ProductFilterAction = {
  __typename: "ProductFilterAction",
  breadcrumbs?: Array< string > | null,
  sortType?: SearchResultsSortOptionType | null,
};

export type ProductCategoryList = {
  __typename: "ProductCategoryList",
  id: string,
  categories:  Array<ProductCategory >,
};

export type ListChange = {
  __typename: "ListChange",
  id: string,
  fromListVersion: string,
  toListVersion: string,
  changes:  Array<ListProductChange >,
  list: ListDetails,
};

export type ListProductChange = {
  __typename: "ListProductChange",
  itemId: string,
  changedBy: Array< string >,
  added: boolean,
  deleted: boolean,
  diff: ListProductDiff,
};

export type ListProductDiff = {
  __typename: "ListProductDiff",
  added:  Array<TypedKeyValue >,
  deleted:  Array<TypedKeyValue >,
  updated:  Array<TypedKeyChangedValue >,
};

export type TypedKeyValue = {
  __typename: "TypedKeyValue",
  key: string,
  value: string,
  dataType: DataType,
};

export enum DataType {
  BOOLEAN = "BOOLEAN",
  FLOAT = "FLOAT",
  INTEGER = "INTEGER",
  STRING = "STRING",
}


export type TypedKeyChangedValue = {
  __typename: "TypedKeyChangedValue",
  key: string,
  old: string,
  new: string,
  dataType: DataType,
};

export type AvailableInstantPayoutDetails = {
  __typename: "AvailableInstantPayoutDetails",
  balance: number,
  fee: number,
  amount: number,
  calculatedTimestamp: number,
};

export type FeatureState = {
  __typename: "FeatureState",
  id: string,
  enabled: boolean,
  state:  Array<TypedKeyValue >,
};

export type MarketplaceInfo = {
  __typename: "MarketplaceInfo",
  zipcode: string,
  marketplaceType: MarketplaceType,
};

export enum MarketplaceType {
  SHOPPER_SEARCH = "SHOPPER_SEARCH",
  ACTIVITY_SEARCH = "ACTIVITY_SEARCH",
}


export type ActivityList = {
  __typename: "ActivityList",
  storeFilters:  Array<StoreInfo >,
  upcomingActivities:  Array<Activity >,
  pastActivities:  Array<Activity >,
  neCorner: MapCoordinate,
  swCorner: MapCoordinate,
};

export type StoreInfo = {
  __typename: "StoreInfo",
  name: string,
  imageUri: string,
};

export type Activity = OrderActivity


export type OrderActivity = {
  __typename: "OrderActivity",
  id: string,
  pinCoordinate?: MapCoordinate | null,
  activityType: OrderActivityType,
  performerId: string,
  shopperId: string,
  performerBadge: PerformerBadgeType,
  performerDisplayName: string,
  performerImageUri: string,
  performerActionText: string,
  timeDisplay: string,
  deliveryStartTimestamp: string,
  deliveryEndTimestamp: string,
  timeslotSpotsRemaining: number,
  timeslotSpotsTotal?: number | null,
  storeDisplayName: string,
  storeDisplayImageUri: string,
  pricingDisplayBase: string,
  pricingDisplayMin?: string | null,
  ctaHeaderDisplay?: string | null,
  discountDisplay?: string | null,
};

export type MapCoordinate = {
  __typename: "MapCoordinate",
  lat: number,
  lon: number,
};

export enum OrderActivityType {
  UPCOMING_AVAILABILITY = "UPCOMING_AVAILABILITY",
  PIGGYBACK = "PIGGYBACK",
  PAST_ORDER = "PAST_ORDER",
}


export enum PerformerBadgeType {
  PRO = "PRO",
}


export type CustomItemImages = {
  __typename: "CustomItemImages",
  images:  Array<AttributedMedia >,
  title?: string | null,
  subTitle?: string | null,
  nextOffset?: number | null,
};

export type PriceAndEarningsBreakdown = {
  __typename: "PriceAndEarningsBreakdown",
  priceBreakdown?: PriceBreakdown | null,
  earningsBreakdown?: PriceBreakdown | null,
  paymentsBreakdown?: PriceBreakdown | null,
};

export type LoginClientStatus = {
  __typename: "LoginClientStatus",
  status?: boolean | null,
};

export type BossBuddyInfo = {
  __typename: "BossBuddyInfo",
  bossBuddyProfiles:  Array<BossBuddyProfile >,
};

export type BossBuddyProfile = {
  __typename: "BossBuddyProfile",
  id: string,
  name: string,
  phone: string,
  permissionLevel: BuddyPermissions,
};

export type BossBuddyInput = {
  buddyId: string,
  permissionLevel: BuddyPermissions,
};

export type CreateBossBuddyInput = {
  phone: string,
  firstName: string,
  lastName: string,
  permissionLevel: BuddyPermissions,
};

export enum BuddyPermissions {
  Nothing = "Nothing",
  Shop = "Shop",
  ShopAndClose = "ShopAndClose",
  Admin = "Admin",
  AdminLite = "AdminLite",
  AdminRO = "AdminRO",
}


export type ResortClosedDates = {
  __typename: "ResortClosedDates",
  dates:  Array<ResortClosedDate >,
};

export type MapviewData = {
  __typename: "MapviewData",
  geoJsons: Array< string | null >,
  swLonLat: Array< number >,
  neLonLat: Array< number >,
};

export type ResortCatalog = {
  __typename: "ResortCatalog",
  serviceName?: string | null,
  products?:  Array<ResortProduct | null > | null,
};

export type ResortProduct = {
  __typename: "ResortProduct",
  id?: string | null,
  name?: string | null,
  description?: string | null,
  image?: string | null,
  thumbnail?: string | null,
  options?:  Array<ProductOption | null > | null,
  customizations?:  Array<ProductCustomization | null > | null,
};

export type ProductOption = {
  __typename: "ProductOption",
  name: string,
  choices: Array< string | null >,
  required: boolean,
  placeholderText?: string | null,
};

export type ProductCustomization = {
  __typename: "ProductCustomization",
  name: string,
  maxLength?: number | null,
  required: boolean,
  placeholderText?: string | null,
};

export type Concierge = {
  __typename: "Concierge",
  id?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  businessName?: string | null,
  phone?: string | null,
  email?: string | null,
  image?: string | null,
  signupTimestamp?: string | null,
  deactivated?: boolean | null,
};

export type UpdateClientMutationVariables = {
  input: ClientInput,
};

export type UpdateClientMutation = {
  // Client related.
  updateClient?:  {
    __typename: "Client",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    image?: string | null,
    referralSource?: string | null,
    hasShopper?: boolean | null,
    signupTimestamp?: string | null,
    attnPassword?: boolean | null,
    deactivated?: boolean | null,
    hasStreamUser?: boolean | null,
    preferences:  {
      __typename: "ClientPreferences",
      id: string,
      surveys:  Array< {
        __typename: "Survey",
        id: string,
        completedTimestamp: string,
        name: string,
        responses:  Array< {
          __typename: "SurveyResponse",
          id: string,
          question: string,
          response?: string | null,
        } >,
      } >,
    },
  } | null,
};

export type UpdateLinkedClientMutationVariables = {
  clientId: string,
  clientEmail?: string | null,
  orderShopperId?: string | null,
  orderId?: string | null,
  deliveryTimestamp?: string | null,
  input: LinkedClientInput,
};

export type UpdateLinkedClientMutation = {
  updateLinkedClient?:  {
    __typename: "LinkedClient",
    id?: string | null,
    client?:  {
      __typename: "Client",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      image?: string | null,
      referralSource?: string | null,
      hasShopper?: boolean | null,
      signupTimestamp?: string | null,
      attnPassword?: boolean | null,
      deactivated?: boolean | null,
      hasStreamUser?: boolean | null,
      preferences:  {
        __typename: "ClientPreferences",
        id: string,
        surveys:  Array< {
          __typename: "Survey",
          id: string,
          completedTimestamp: string,
          name: string,
          responses:  Array< {
            __typename: "SurveyResponse",
            id: string,
            question: string,
            response?: string | null,
          } >,
        } >,
      },
    } | null,
    note?: string | null,
    orderCount?: number | null,
    lastOrderTimestamp?: string | null,
    firstConnectTimestamp?: string | null,
    referralSourceMessage?: string | null,
    clientAnnotation:  {
      __typename: "LinkedClientAnnotations",
      id: string,
      note?: string | null,
      image?: string | null,
      noteLastUpdatedTimestamp?: number | null,
      preferencesLastUpdatedTimestamp?: number | null,
      preferencesLastSeenTimestamp?: number | null,
      needsToSeePreferences: boolean,
    },
    lastInviteTimestamp?: string | null,
  } | null,
};

export type ResendWixOrderConfirmationMutationVariables = {
  clientId: string,
  clientEmail?: string | null,
  input: LinkedOrderIdentifiersInput,
};

export type ResendWixOrderConfirmationMutation = {
  resendWixOrderConfirmation?: boolean | null,
};

export type CreateAddressMutationVariables = {
  input: AddressInput,
};

export type CreateAddressMutation = {
  createAddress?:  {
    __typename: "Address",
    id?: string | null,
    addressName?: string | null,
    addressLine1?: string | null,
    addressLine2?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    country?: string | null,
    isDefault?: boolean | null,
  } | null,
};

export type UpdateAddressMutationVariables = {
  id: string,
  input: AddressInput,
};

export type UpdateAddressMutation = {
  updateAddress?:  {
    __typename: "Address",
    id?: string | null,
    addressName?: string | null,
    addressLine1?: string | null,
    addressLine2?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    country?: string | null,
    isDefault?: boolean | null,
  } | null,
};

export type DeleteAddressMutationVariables = {
  id: string,
};

export type DeleteAddressMutation = {
  deleteAddress?:  {
    __typename: "Address",
    id?: string | null,
    addressName?: string | null,
    addressLine1?: string | null,
    addressLine2?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    country?: string | null,
    isDefault?: boolean | null,
  } | null,
};

export type CreatePaymentMethodMutationVariables = {
  input: PaymentMethodInput,
};

export type CreatePaymentMethodMutation = {
  createPaymentMethod?:  {
    __typename: "PaymentMethod",
    id?: string | null,
    brand?: string | null,
    expirationMonth?: number | null,
    expirationYear?: number | null,
    last4?: string | null,
    isDefault?: boolean | null,
    address?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
  } | null,
};

export type UpdatePaymentMethodMutationVariables = {
  id: string,
  input: PaymentMethodInput,
};

export type UpdatePaymentMethodMutation = {
  updatePaymentMethod?:  {
    __typename: "PaymentMethod",
    id?: string | null,
    brand?: string | null,
    expirationMonth?: number | null,
    expirationYear?: number | null,
    last4?: string | null,
    isDefault?: boolean | null,
    address?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
  } | null,
};

export type DeletePaymentMethodMutationVariables = {
  id: string,
};

export type DeletePaymentMethodMutation = {
  deletePaymentMethod?:  {
    __typename: "PaymentMethod",
    id?: string | null,
    brand?: string | null,
    expirationMonth?: number | null,
    expirationYear?: number | null,
    last4?: string | null,
    isDefault?: boolean | null,
    address?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
  } | null,
};

export type CreateClientOrderMutationVariables = {
  input?: OrderInput | null,
};

export type CreateClientOrderMutation = {
  createClientOrder?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type CreateClientOrderV2MutationVariables = {
  input?: OrderInputV2 | null,
};

export type CreateClientOrderV2Mutation = {
  // Pricing model is now variable.
  createClientOrderV2?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type ClientCancelOrderMutationVariables = {
  id: string,
  orderTimestamp: string,
};

export type ClientCancelOrderMutation = {
  clientCancelOrder?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type DeleteLinkedClientMutationVariables = {
  id: string,
};

export type DeleteLinkedClientMutation = {
  // createLinkedShopper(id: ID!): Shopper
  deleteLinkedClient?:  {
    __typename: "LinkedClient",
    id?: string | null,
    client?:  {
      __typename: "Client",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      image?: string | null,
      referralSource?: string | null,
      hasShopper?: boolean | null,
      signupTimestamp?: string | null,
      attnPassword?: boolean | null,
      deactivated?: boolean | null,
      hasStreamUser?: boolean | null,
      preferences:  {
        __typename: "ClientPreferences",
        id: string,
        surveys:  Array< {
          __typename: "Survey",
          id: string,
          completedTimestamp: string,
          name: string,
          responses:  Array< {
            __typename: "SurveyResponse",
            id: string,
            question: string,
            response?: string | null,
          } >,
        } >,
      },
    } | null,
    note?: string | null,
    orderCount?: number | null,
    lastOrderTimestamp?: string | null,
    firstConnectTimestamp?: string | null,
    referralSourceMessage?: string | null,
    clientAnnotation:  {
      __typename: "LinkedClientAnnotations",
      id: string,
      note?: string | null,
      image?: string | null,
      noteLastUpdatedTimestamp?: number | null,
      preferencesLastUpdatedTimestamp?: number | null,
      preferencesLastSeenTimestamp?: number | null,
      needsToSeePreferences: boolean,
    },
    lastInviteTimestamp?: string | null,
  } | null,
};

export type InviteClientMutationVariables = {
  input?: ClientInput | null,
};

export type InviteClientMutation = {
  // Shopper related.
  inviteClient?:  {
    __typename: "Client",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    image?: string | null,
    referralSource?: string | null,
    hasShopper?: boolean | null,
    signupTimestamp?: string | null,
    attnPassword?: boolean | null,
    deactivated?: boolean | null,
    hasStreamUser?: boolean | null,
    preferences:  {
      __typename: "ClientPreferences",
      id: string,
      surveys:  Array< {
        __typename: "Survey",
        id: string,
        completedTimestamp: string,
        name: string,
        responses:  Array< {
          __typename: "SurveyResponse",
          id: string,
          question: string,
          response?: string | null,
        } >,
      } >,
    },
  } | null,
};

export type InviteClientV2MutationVariables = {
  input?: ClientInput | null,
};

export type InviteClientV2Mutation = {
  inviteClientV2?:  {
    __typename: "LinkedClient",
    id?: string | null,
    client?:  {
      __typename: "Client",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      image?: string | null,
      referralSource?: string | null,
      hasShopper?: boolean | null,
      signupTimestamp?: string | null,
      attnPassword?: boolean | null,
      deactivated?: boolean | null,
      hasStreamUser?: boolean | null,
      preferences:  {
        __typename: "ClientPreferences",
        id: string,
        surveys:  Array< {
          __typename: "Survey",
          id: string,
          completedTimestamp: string,
          name: string,
          responses:  Array< {
            __typename: "SurveyResponse",
            id: string,
            question: string,
            response?: string | null,
          } >,
        } >,
      },
    } | null,
    note?: string | null,
    orderCount?: number | null,
    lastOrderTimestamp?: string | null,
    firstConnectTimestamp?: string | null,
    referralSourceMessage?: string | null,
    clientAnnotation:  {
      __typename: "LinkedClientAnnotations",
      id: string,
      note?: string | null,
      image?: string | null,
      noteLastUpdatedTimestamp?: number | null,
      preferencesLastUpdatedTimestamp?: number | null,
      preferencesLastSeenTimestamp?: number | null,
      needsToSeePreferences: boolean,
    },
    lastInviteTimestamp?: string | null,
  } | null,
};

export type DeleteInviteClientV2MutationVariables = {
  id: string,
};

export type DeleteInviteClientV2Mutation = {
  deleteInviteClientV2?:  {
    __typename: "LinkedClient",
    id?: string | null,
    client?:  {
      __typename: "Client",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      image?: string | null,
      referralSource?: string | null,
      hasShopper?: boolean | null,
      signupTimestamp?: string | null,
      attnPassword?: boolean | null,
      deactivated?: boolean | null,
      hasStreamUser?: boolean | null,
      preferences:  {
        __typename: "ClientPreferences",
        id: string,
        surveys:  Array< {
          __typename: "Survey",
          id: string,
          completedTimestamp: string,
          name: string,
          responses:  Array< {
            __typename: "SurveyResponse",
            id: string,
            question: string,
            response?: string | null,
          } >,
        } >,
      },
    } | null,
    note?: string | null,
    orderCount?: number | null,
    lastOrderTimestamp?: string | null,
    firstConnectTimestamp?: string | null,
    referralSourceMessage?: string | null,
    clientAnnotation:  {
      __typename: "LinkedClientAnnotations",
      id: string,
      note?: string | null,
      image?: string | null,
      noteLastUpdatedTimestamp?: number | null,
      preferencesLastUpdatedTimestamp?: number | null,
      preferencesLastSeenTimestamp?: number | null,
      needsToSeePreferences: boolean,
    },
    lastInviteTimestamp?: string | null,
  } | null,
};

export type UpdateShopperMutationVariables = {
  input: ShopperInput,
};

export type UpdateShopperMutation = {
  updateShopper?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type CreateShopperIdentityMutationVariables = {
  input: IdentityCreateInput,
};

export type CreateShopperIdentityMutation = {
  createShopperIdentity?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type UpdateShopperIdentityMutationVariables = {
  input: IdentityUpdateInput,
};

export type UpdateShopperIdentityMutation = {
  updateShopperIdentity?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type RequestChargeCardMutationVariables = {
  name?: string | null,
  addressLine1?: string | null,
  addressLine2?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  ipAddr?: string | null,
};

export type RequestChargeCardMutation = {
  requestChargeCard?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type UpdateServicesOrderingMutationVariables = {
  input?: ServiceOfferingIdsInput | null,
};

export type UpdateServicesOrderingMutation = {
  updateServicesOrdering?:  {
    __typename: "ServiceOfferingIds",
    serviceOfferingIds?: Array< string | null > | null,
  } | null,
};

export type CreateServiceOfferingMutationVariables = {
  input?: ServiceOfferingInput | null,
};

export type CreateServiceOfferingMutation = {
  // Depricated
  createServiceOffering?:  {
    __typename: "ServiceOffering",
    id?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
    serviceDescription?: string | null,
    defaultErrandBusinessNames?: Array< string | null > | null,
    baseFee?: number | null,
    maxErrands?: number | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    disclaimerText?: string | null,
    useSuggestedPricing?: boolean | null,
  } | null,
};

export type UpdateServiceOfferingMutationVariables = {
  id?: string | null,
  input?: ServiceOfferingInput | null,
};

export type UpdateServiceOfferingMutation = {
  // Depricated
  updateServiceOffering?:  {
    __typename: "ServiceOffering",
    id?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
    serviceDescription?: string | null,
    defaultErrandBusinessNames?: Array< string | null > | null,
    baseFee?: number | null,
    maxErrands?: number | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    disclaimerText?: string | null,
    useSuggestedPricing?: boolean | null,
  } | null,
};

export type DeleteServiceOfferingMutationVariables = {
  id?: string | null,
};

export type DeleteServiceOfferingMutation = {
  deleteServiceOffering?:  {
    __typename: "ServiceOffering",
    id?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
    serviceDescription?: string | null,
    defaultErrandBusinessNames?: Array< string | null > | null,
    baseFee?: number | null,
    maxErrands?: number | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    disclaimerText?: string | null,
    useSuggestedPricing?: boolean | null,
  } | null,
};

export type CreateServiceOfferingV2MutationVariables = {
  id?: string | null,
  serviceName?: string | null,
  serviceImage?: string | null,
  flatFee?: string | null,
  percent?: string | null,
  minFee?: string | null,
  clientPaysPlatform?: boolean | null,
  preTipPercentages?: Array< string | null > | null,
  defaultPercentagesIndex?: number | null,
  fixedGratuityOptions?: Array< number | null > | null,
  defaultFixedGratuityOptionsIndex?: number | null,
  useSuggestedPricing?: boolean | null,
};

export type CreateServiceOfferingV2Mutation = {
  // V2 Service creation and update.  We use the old delete function.
  createServiceOfferingV2?:  {
    __typename: "ServiceOffering",
    id?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
    serviceDescription?: string | null,
    defaultErrandBusinessNames?: Array< string | null > | null,
    baseFee?: number | null,
    maxErrands?: number | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    disclaimerText?: string | null,
    useSuggestedPricing?: boolean | null,
  } | null,
};

export type UpdateServiceOfferingV2MutationVariables = {
  id?: string | null,
  serviceName?: string | null,
  serviceImage?: string | null,
  flatFee?: string | null,
  percent?: string | null,
  minFee?: string | null,
  clientPaysPlatform?: boolean | null,
  preTipPercentages?: Array< string | null > | null,
  defaultPercentagesIndex?: number | null,
  fixedGratuityOptions?: Array< number | null > | null,
  defaultFixedGratuityOptionsIndex?: number | null,
  useSuggestedPricing?: boolean | null,
};

export type UpdateServiceOfferingV2Mutation = {
  updateServiceOfferingV2?:  {
    __typename: "ServiceOffering",
    id?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
    serviceDescription?: string | null,
    defaultErrandBusinessNames?: Array< string | null > | null,
    baseFee?: number | null,
    maxErrands?: number | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    disclaimerText?: string | null,
    useSuggestedPricing?: boolean | null,
  } | null,
};

export type UpdateDailySchedulesMutationVariables = {
  input?: DailySchedulesInput | null,
};

export type UpdateDailySchedulesMutation = {
  // updateShopperSchedule(input: ShopperScheduleInput): ShopperSchedule
  // updateDailySchedule(id: ID, dailyScheduleInput: DailyScheduleInput): DailySchedule
  // To be depricated, return error asking biz owner to upgrade app
  updateDailySchedules?:  {
    __typename: "ShopperSchedule",
    id?: string | null,
    dailySchedules?:  Array< {
      __typename: "DailySchedule",
      id?: string | null,
      day?: string | null,
      timeSlots?:  Array< {
        __typename: "TimeSlot",
        id?: string | null,
        slotStart?: string | null,
        slotEnd?: string | null,
        isActive?: boolean | null,
        bufferDuration?: number | null,
        bufferMode?: BufferMode | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type UpdateDailySchedulesV2MutationVariables = {
  input?: Array< DailySchedulesInputV2 | null > | null,
};

export type UpdateDailySchedulesV2Mutation = {
  updateDailySchedulesV2?:  {
    __typename: "ShopperScheduleV2",
    dailySchedules?:  Array< {
      __typename: "DailyScheduleV2",
      id?: string | null,
      day?: string | null,
      timeSlots?:  Array< {
        __typename: "TimeSlotV2",
        id?: string | null,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        bufferDuration?: number | null,
        bufferMode?: BufferMode | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type UpdateScheduleOptionsMutationVariables = {
  input?: ShopperScheduleOptionsInput | null,
};

export type UpdateScheduleOptionsMutation = {
  updateScheduleOptions?:  {
    __typename: "ShopperScheduleOptions",
    defaultMaxOrders?: number | null,
    defaultTimeSlotDuration?: number | null,
    isScheduleAvailable?: boolean | null,
    defaultBufferDuration: number,
    defaultBufferMode: BufferMode,
  } | null,
};

export type UpdateClosedDateRangesMutationVariables = {
  input?: ClosedDateRangesInput | null,
};

export type UpdateClosedDateRangesMutation = {
  updateClosedDateRanges?:  {
    __typename: "ShopperClosedDateRanges",
    closedDateRanges?:  Array< {
      __typename: "ClosedDateRange",
      id?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      description?: string | null,
    } | null > | null,
  } | null,
};

export type ActivateChargeCardMutationVariables = {
  input: ChargeCardInput,
};

export type ActivateChargeCardMutation = {
  activateChargeCard?:  {
    __typename: "ChargeCard",
    id?: string | null,
    brand?: string | null,
    expirationMonth?: number | null,
    expirationYear?: number | null,
    last4?: string | null,
    status?: string | null,
    message?: string | null,
  } | null,
};

export type CreateStripeConnectAccountMutationVariables = {
  input?: StripeConnectAccountInput | null,
};

export type CreateStripeConnectAccountMutation = {
  createStripeConnectAccount?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type CreateStripeConnectAccountV2MutationVariables = {
  input?: StripeConnectAccountInput | null,
};

export type CreateStripeConnectAccountV2Mutation = {
  createStripeConnectAccountV2?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type UpgradeStripeConnectAccountFromV1ToV2MutationVariables = {
  input?: StripeConnectAccountInput | null,
};

export type UpgradeStripeConnectAccountFromV1ToV2Mutation = {
  upgradeStripeConnectAccountFromV1ToV2?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type CreateDirectDepositAccountMutationVariables = {
  input?: DirectDepositAccountInput | null,
};

export type CreateDirectDepositAccountMutation = {
  createDirectDepositAccount?:  {
    __typename: "DirectDepositAccount",
    id?: string | null,
    bankName?: string | null,
    accountHolderName?: string | null,
    routingNumber?: string | null,
    last4?: string | null,
    error?: string | null,
    isDefault?: boolean | null,
  } | null,
};

export type UpdateDirectDepositAccountMutationVariables = {
  id?: string | null,
  input?: DirectDepositAccountInput | null,
};

export type UpdateDirectDepositAccountMutation = {
  updateDirectDepositAccount?:  {
    __typename: "DirectDepositAccount",
    id?: string | null,
    bankName?: string | null,
    accountHolderName?: string | null,
    routingNumber?: string | null,
    last4?: string | null,
    error?: string | null,
    isDefault?: boolean | null,
  } | null,
};

export type DeleteDirectDepositAccountMutationVariables = {
  id?: string | null,
};

export type DeleteDirectDepositAccountMutation = {
  deleteDirectDepositAccount?:  {
    __typename: "DirectDepositAccount",
    id?: string | null,
    bankName?: string | null,
    accountHolderName?: string | null,
    routingNumber?: string | null,
    last4?: string | null,
    error?: string | null,
    isDefault?: boolean | null,
  } | null,
};

export type UpdateServiceAreaMutationVariables = {
  input?: ServiceAreaInput | null,
};

export type UpdateServiceAreaMutation = {
  updateServiceArea?:  {
    __typename: "ServiceArea",
    id?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    description?: string | null,
  } | null,
};

export type CreateServiceTimeMutationVariables = {
  input?: ServiceTimeInput | null,
};

export type CreateServiceTimeMutation = {
  createServiceTime?:  {
    __typename: "ServiceTime",
    dayOfWeek?: string | null,
    startTime?: string | null,
    endTime?: string | null,
  } | null,
};

export type UpdateServiceTimeMutationVariables = {
  id?: string | null,
  input?: ServiceTimeInput | null,
};

export type UpdateServiceTimeMutation = {
  updateServiceTime?:  {
    __typename: "ServiceTime",
    dayOfWeek?: string | null,
    startTime?: string | null,
    endTime?: string | null,
  } | null,
};

export type DeleteServiceTimeMutationVariables = {
  id?: string | null,
};

export type DeleteServiceTimeMutation = {
  deleteServiceTime?:  {
    __typename: "ServiceTime",
    dayOfWeek?: string | null,
    startTime?: string | null,
    endTime?: string | null,
  } | null,
};

export type CreateCouponMutationVariables = {
  input?: CouponInput | null,
};

export type CreateCouponMutation = {
  createCoupon?:  {
    __typename: "Coupon",
    id?: string | null,
    couponCode?: string | null,
    couponValue?: number | null,
    paidByShopper?: number | null,
    validClientIds?: Array< string | null > | null,
    usesPerClient?: number | null,
  } | null,
};

export type UpdateCouponMutationVariables = {
  id?: string | null,
  input?: CouponInput | null,
};

export type UpdateCouponMutation = {
  updateCoupon?:  {
    __typename: "Coupon",
    id?: string | null,
    couponCode?: string | null,
    couponValue?: number | null,
    paidByShopper?: number | null,
    validClientIds?: Array< string | null > | null,
    usesPerClient?: number | null,
  } | null,
};

export type DeleteCouponMutationVariables = {
  id?: string | null,
};

export type DeleteCouponMutation = {
  deleteCoupon?:  {
    __typename: "Coupon",
    id?: string | null,
    couponCode?: string | null,
    couponValue?: number | null,
    paidByShopper?: number | null,
    validClientIds?: Array< string | null > | null,
    usesPerClient?: number | null,
  } | null,
};

export type UpdateShoppingListMutationVariables = {
  input?: ItemsStateInput | null,
};

export type UpdateShoppingListMutation = {
  updateShoppingList?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type UseTransactionsMutationVariables = {
  input?: UseTransactionsInput | null,
};

export type UseTransactionsMutation = {
  useTransactions?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type DissociateTransactionMutationVariables = {
  input?: UseTransactionsInput | null,
};

export type DissociateTransactionMutation = {
  dissociateTransaction?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type AddOrderAdjustmentMutationVariables = {
  input?: OrderAdjustmentInput | null,
};

export type AddOrderAdjustmentMutation = {
  addOrderAdjustment?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type UpdateOrderAdjustmentMutationVariables = {
  input?: OrderAdjustmentInput | null,
};

export type UpdateOrderAdjustmentMutation = {
  updateOrderAdjustment?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type RemoveOrderAdjustmentMutationVariables = {
  input?: OrderAdjustmentInput | null,
};

export type RemoveOrderAdjustmentMutation = {
  removeOrderAdjustment?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type AddOrderAdjustment2MutationVariables = {
  input?: OrderAdjustmentInput | null,
};

export type AddOrderAdjustment2Mutation = {
  addOrderAdjustment2?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type RemoveOrderAdjustment2MutationVariables = {
  id: string,
  orderId: string,
  deliveryTimestamp: string,
};

export type RemoveOrderAdjustment2Mutation = {
  removeOrderAdjustment2?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type AddOrderCreditMutationVariables = {
  orderId: string,
  deliveryTimestamp: string,
  description: string,
  amount: number,
};

export type AddOrderCreditMutation = {
  addOrderCredit?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type RemoveOrderCreditMutationVariables = {
  id: string,
  orderId: string,
  deliveryTimestamp: string,
};

export type RemoveOrderCreditMutation = {
  removeOrderCredit?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type UpdateOrderNotesMutationVariables = {
  input: OrderNotesInput,
};

export type UpdateOrderNotesMutation = {
  updateOrderNotes?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type AddOrderExternalTransactionMutationVariables = {
  input: OrderExternalTransactionInput,
};

export type AddOrderExternalTransactionMutation = {
  addOrderExternalTransaction?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
      moreAttachments?: Array< string > | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type RemoveOrderExternalTransactionMutationVariables = {
  id: string,
  input: OrderExternalTransactionRemovalInput,
};

export type RemoveOrderExternalTransactionMutation = {
  removeOrderExternalTransaction?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type CompleteOrderMutationVariables = {
  id: string,
  deliveryTimestamp: string,
};

export type CompleteOrderMutation = {
  completeOrder?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type CancelOrderMutationVariables = {
  id: string,
  deliveryTimestamp: string,
};

export type CancelOrderMutation = {
  cancelOrder?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type AssociateClientWithShopperMutationVariables = {
  input?: ReferralLinkInput | null,
};

export type AssociateClientWithShopperMutation = {
  associateClientWithShopper?:  {
    __typename: "ReferralLink",
    linkType?: string | null,
    shopperId?: string | null,
    webPath?: string | null,
    meta?: string | null,
    linkedShopper?:  {
      __typename: "LinkedShopper",
      id?: string | null,
      shopper?:  {
        __typename: "Shopper",
        id?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        displayName?: string | null,
        deliveryArea?: string | null,
        websiteUrl?: string | null,
        phone?: string | null,
        businessPhone?: string | null,
        email?: string | null,
        bio?: string | null,
        image?: string | null,
        businessName?: string | null,
        availabilityDescription?: string | null,
        announcement?: string | null,
        rating?: string | null,
        repeatClientCount?: number | null,
        orderCount?: number | null,
        reviewCount?: number | null,
        specialtyTags?: Array< string | null > | null,
        tagline?: string | null,
        metaTitle?: string | null,
        metaImage?: string | null,
        metaDescription?: string | null,
        deliveryAreaZipcode?: string | null,
        deliveryAreaZipcodes?: Array< string > | null,
        deliveryRadius?: number | null,
        lowestPrice?: string | null,
        subscriptionPlan?: string | null,
        subscriptionPlanDetails?:  {
          __typename: "SubscriptionPlanDetails",
          id?: string | null,
          // Name of the plan ... same as subscriptionPlan for now.
          textComponents?:  Array< {
            __typename: "TextComponent",
            text?: string | null,
            bold?: boolean | null,
          } | null > | null,
          phases?:  Array< {
            __typename: "Phase",
            id?: string | null,
            // Name of a plan ... Starter, etc.
            status?: string | null,
          } | null > | null,
        } | null,
        branding?:  {
          __typename: "Branding",
          coverColor?: string | null,
        } | null,
        typicalPricing?:  {
          __typename: "TypicalPricing",
          summary?:  {
            __typename: "TypicalPricingSummary",
            title?: string | null,
            description?: string | null,
          } | null,
          groceries?: string | null,
          shoppingAndDelivery?: string | null,
          minGratuity?: string | null,
          platform?: string | null,
        } | null,
        allowClientConnection?: boolean | null,
        stripeConnectAcctExists?: boolean | null,
        fullSSNRequired?: boolean | null,
        attnBizProfile?: boolean | null,
        attnDirectDeposit?: boolean | null,
        attnCreditCard?: boolean | null,
        attnServices?: boolean | null,
        attnPassword?: boolean | null,
        statusIdentityVerification?:  {
          __typename: "shopperStatusVariable",
          state?: string | null,
          message?: string | null,
          externalLink?: string | null,
        } | null,
        statusChargeCard?:  {
          __typename: "shopperStatusVariable",
          state?: string | null,
          message?: string | null,
          externalLink?: string | null,
        } | null,
        optInEngage?: boolean | null,
        optInZipcode?: boolean | null,
        deactivated?: boolean | null,
        acceptsReferralNetwork?: boolean | null,
      } | null,
      serviceOfferings?:  Array< {
        __typename: "ServiceOffering",
        id?: string | null,
        serviceName?: string | null,
        serviceImage?: string | null,
        serviceDescription?: string | null,
        defaultErrandBusinessNames?: Array< string | null > | null,
        baseFee?: number | null,
        maxErrands?: number | null,
        pricingModel?:  {
          __typename: "PricingModel",
          version?: string | null,
          // This is displayed on the storefront page.
          // It is meant as a terse description of the pricing model.
          // E.g. "My whiteglove service:  $10 + 15%"
          description?: string | null,
          // Term1: flat fee for service.
          flatPm?:  {
            __typename: "FlatPM",
            fee?: string | null,
            feeTitle?: string | null,
            display?: boolean | null,
          } | null,
          // Term2: hourly fee for service.
          hourlyPm?:  {
            __typename: "HourlyPM",
            rate?: string | null,
            billableHours?: string | null,
            minBillableHours?: string | null,
            feeTitle?: string | null,
            display?: boolean | null,
          } | null,
          // Term3: working capital loan.
          // pexBalance: Int
          // pexBalanceDisplay: Boolean
          // Term4: percent service fee, based on term3, with a floor.
          percentPm?:  {
            __typename: "PercentPM",
            percent?: string | null,
            minFee?: string | null,
            feeTitle?: string | null,
            display?: boolean | null,
          } | null,
          // Term5: mostly for backwards compatibility with the current model.
          // This is applaied to (pexBalance+serviceFee)
          preTipPm?:  {
            __typename: "PreTipPM",
            chosenPercent?: string | null,
            percentages?: Array< string | null > | null,
            defaultPercentagesIndex?: number | null,
            footer?: string | null,
            feeTitle?: string | null,
            display?: boolean | null,
            fixedGratuityOptions?: Array< number | null > | null,
            defaultFixedGratuityOptionsIndex?: number | null,
            chosenFixedGratuity?: number | null,
            gratuityType?: GratuityType | null,
            showPreGratuityByDefault?: boolean | null,
            allowOptionalGratuity?: boolean | null,
            showCustomGratuity?: boolean | null,
          } | null,
          // Term6: client platform fee.
          clientPlatformPm?:  {
            __typename: "ClientPlatformPM",
            percent?: string | null,
            feeTitle?: string | null,
            display?: boolean | null,
          } | null,
          suggestedFlatPm?:  {
            __typename: "SuggestedFlatPM",
            fee?: number | null,
            feeWarningThreshold?: number | null,
            percentages?: Array< number | null > | null,
            gratuityType?: GratuityType | null,
            gratuityOptions?: Array< number | null > | null,
            defaultGratuityOptionsIndex?: number | null,
            clientPaysPlatform?: boolean | null,
            showCustomGratuity?: boolean | null,
            title?: string | null,
            description?: string | null,
          } | null,
          suggestedPercentPm?:  {
            __typename: "SuggestedPercentPM",
            percent?: number | null,
            minFee?: number | null,
            percentWarningThreshold?: number | null,
            minFeeWarningThreshold?: number | null,
            gratuityType?: GratuityType | null,
            gratuityOptions?: Array< number | null > | null,
            defaultGratuityOptionsIndex?: number | null,
            clientPaysPlatform?: boolean | null,
            showCustomGratuity?: boolean | null,
            title?: string | null,
            description?: string | null,
          } | null,
          suggestedFlatPlusPercentPm?:  {
            __typename: "SuggestedFlatPlusPercentPM",
            fee?: number | null,
            feeWarningThreshold?: number | null,
            percent?: number | null,
            minFee?: number | null,
            percentWarningThreshold?: number | null,
            minFeeWarningThreshold?: number | null,
            gratuityType?: GratuityType | null,
            gratuityOptions?: Array< number | null > | null,
            defaultGratuityOptionsIndex?: number | null,
            clientPaysPlatform?: boolean | null,
            showCustomGratuity?: boolean | null,
            title?: string | null,
            description?: string | null,
          } | null,
        } | null,
        disclaimerText?: string | null,
        useSuggestedPricing?: boolean | null,
      } | null > | null,
      serviceArea?:  {
        __typename: "ServiceArea",
        id?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        description?: string | null,
      } | null,
      serviceTimes?:  Array< {
        __typename: "ServiceTime",
        dayOfWeek?: string | null,
        startTime?: string | null,
        endTime?: string | null,
      } | null > | null,
    } | null,
  } | null,
};

export type AssociateClientWithShopperV2MutationVariables = {
  input?: ReferralLinkInput | null,
};

export type AssociateClientWithShopperV2Mutation = {
  associateClientWithShopperV2?:  {
    __typename: "LinkedShopperAndSchedule",
    linkedShopper?:  {
      __typename: "LinkedShopper",
      id?: string | null,
      shopper?:  {
        __typename: "Shopper",
        id?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        displayName?: string | null,
        deliveryArea?: string | null,
        websiteUrl?: string | null,
        phone?: string | null,
        businessPhone?: string | null,
        email?: string | null,
        bio?: string | null,
        image?: string | null,
        businessName?: string | null,
        availabilityDescription?: string | null,
        announcement?: string | null,
        rating?: string | null,
        repeatClientCount?: number | null,
        orderCount?: number | null,
        reviewCount?: number | null,
        specialtyTags?: Array< string | null > | null,
        tagline?: string | null,
        metaTitle?: string | null,
        metaImage?: string | null,
        metaDescription?: string | null,
        deliveryAreaZipcode?: string | null,
        deliveryAreaZipcodes?: Array< string > | null,
        deliveryRadius?: number | null,
        lowestPrice?: string | null,
        subscriptionPlan?: string | null,
        subscriptionPlanDetails?:  {
          __typename: "SubscriptionPlanDetails",
          id?: string | null,
          // Name of the plan ... same as subscriptionPlan for now.
          textComponents?:  Array< {
            __typename: "TextComponent",
            text?: string | null,
            bold?: boolean | null,
          } | null > | null,
          phases?:  Array< {
            __typename: "Phase",
            id?: string | null,
            // Name of a plan ... Starter, etc.
            status?: string | null,
          } | null > | null,
        } | null,
        branding?:  {
          __typename: "Branding",
          coverColor?: string | null,
        } | null,
        typicalPricing?:  {
          __typename: "TypicalPricing",
          summary?:  {
            __typename: "TypicalPricingSummary",
            title?: string | null,
            description?: string | null,
          } | null,
          groceries?: string | null,
          shoppingAndDelivery?: string | null,
          minGratuity?: string | null,
          platform?: string | null,
        } | null,
        allowClientConnection?: boolean | null,
        stripeConnectAcctExists?: boolean | null,
        fullSSNRequired?: boolean | null,
        attnBizProfile?: boolean | null,
        attnDirectDeposit?: boolean | null,
        attnCreditCard?: boolean | null,
        attnServices?: boolean | null,
        attnPassword?: boolean | null,
        statusIdentityVerification?:  {
          __typename: "shopperStatusVariable",
          state?: string | null,
          message?: string | null,
          externalLink?: string | null,
        } | null,
        statusChargeCard?:  {
          __typename: "shopperStatusVariable",
          state?: string | null,
          message?: string | null,
          externalLink?: string | null,
        } | null,
        optInEngage?: boolean | null,
        optInZipcode?: boolean | null,
        deactivated?: boolean | null,
        acceptsReferralNetwork?: boolean | null,
      } | null,
      serviceOfferings?:  Array< {
        __typename: "ServiceOffering",
        id?: string | null,
        serviceName?: string | null,
        serviceImage?: string | null,
        serviceDescription?: string | null,
        defaultErrandBusinessNames?: Array< string | null > | null,
        baseFee?: number | null,
        maxErrands?: number | null,
        pricingModel?:  {
          __typename: "PricingModel",
          version?: string | null,
          // This is displayed on the storefront page.
          // It is meant as a terse description of the pricing model.
          // E.g. "My whiteglove service:  $10 + 15%"
          description?: string | null,
          // Term1: flat fee for service.
          flatPm?:  {
            __typename: "FlatPM",
            fee?: string | null,
            feeTitle?: string | null,
            display?: boolean | null,
          } | null,
          // Term2: hourly fee for service.
          hourlyPm?:  {
            __typename: "HourlyPM",
            rate?: string | null,
            billableHours?: string | null,
            minBillableHours?: string | null,
            feeTitle?: string | null,
            display?: boolean | null,
          } | null,
          // Term3: working capital loan.
          // pexBalance: Int
          // pexBalanceDisplay: Boolean
          // Term4: percent service fee, based on term3, with a floor.
          percentPm?:  {
            __typename: "PercentPM",
            percent?: string | null,
            minFee?: string | null,
            feeTitle?: string | null,
            display?: boolean | null,
          } | null,
          // Term5: mostly for backwards compatibility with the current model.
          // This is applaied to (pexBalance+serviceFee)
          preTipPm?:  {
            __typename: "PreTipPM",
            chosenPercent?: string | null,
            percentages?: Array< string | null > | null,
            defaultPercentagesIndex?: number | null,
            footer?: string | null,
            feeTitle?: string | null,
            display?: boolean | null,
            fixedGratuityOptions?: Array< number | null > | null,
            defaultFixedGratuityOptionsIndex?: number | null,
            chosenFixedGratuity?: number | null,
            gratuityType?: GratuityType | null,
            showPreGratuityByDefault?: boolean | null,
            allowOptionalGratuity?: boolean | null,
            showCustomGratuity?: boolean | null,
          } | null,
          // Term6: client platform fee.
          clientPlatformPm?:  {
            __typename: "ClientPlatformPM",
            percent?: string | null,
            feeTitle?: string | null,
            display?: boolean | null,
          } | null,
          suggestedFlatPm?:  {
            __typename: "SuggestedFlatPM",
            fee?: number | null,
            feeWarningThreshold?: number | null,
            percentages?: Array< number | null > | null,
            gratuityType?: GratuityType | null,
            gratuityOptions?: Array< number | null > | null,
            defaultGratuityOptionsIndex?: number | null,
            clientPaysPlatform?: boolean | null,
            showCustomGratuity?: boolean | null,
            title?: string | null,
            description?: string | null,
          } | null,
          suggestedPercentPm?:  {
            __typename: "SuggestedPercentPM",
            percent?: number | null,
            minFee?: number | null,
            percentWarningThreshold?: number | null,
            minFeeWarningThreshold?: number | null,
            gratuityType?: GratuityType | null,
            gratuityOptions?: Array< number | null > | null,
            defaultGratuityOptionsIndex?: number | null,
            clientPaysPlatform?: boolean | null,
            showCustomGratuity?: boolean | null,
            title?: string | null,
            description?: string | null,
          } | null,
          suggestedFlatPlusPercentPm?:  {
            __typename: "SuggestedFlatPlusPercentPM",
            fee?: number | null,
            feeWarningThreshold?: number | null,
            percent?: number | null,
            minFee?: number | null,
            percentWarningThreshold?: number | null,
            minFeeWarningThreshold?: number | null,
            gratuityType?: GratuityType | null,
            gratuityOptions?: Array< number | null > | null,
            defaultGratuityOptionsIndex?: number | null,
            clientPaysPlatform?: boolean | null,
            showCustomGratuity?: boolean | null,
            title?: string | null,
            description?: string | null,
          } | null,
        } | null,
        disclaimerText?: string | null,
        useSuggestedPricing?: boolean | null,
      } | null > | null,
      serviceArea?:  {
        __typename: "ServiceArea",
        id?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        description?: string | null,
      } | null,
      serviceTimes?:  Array< {
        __typename: "ServiceTime",
        dayOfWeek?: string | null,
        startTime?: string | null,
        endTime?: string | null,
      } | null > | null,
    } | null,
    linkedShopperSchedule?:  {
      __typename: "ShopperSchedule",
      id?: string | null,
      dailySchedules?:  Array< {
        __typename: "DailySchedule",
        id?: string | null,
        day?: string | null,
        timeSlots?:  Array< {
          __typename: "TimeSlot",
          id?: string | null,
          slotStart?: string | null,
          slotEnd?: string | null,
          isActive?: boolean | null,
          bufferDuration?: number | null,
          bufferMode?: BufferMode | null,
        } | null > | null,
      } | null > | null,
    } | null,
  } | null,
};

export type ConnectClientToShopperMutationVariables = {
  shopperId: string,
};

export type ConnectClientToShopperMutation = {
  // This link function is used from the shopper search details page to link the client.
  connectClientToShopper?:  {
    __typename: "LinkedShopper",
    id?: string | null,
    shopper?:  {
      __typename: "Shopper",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      displayName?: string | null,
      deliveryArea?: string | null,
      websiteUrl?: string | null,
      phone?: string | null,
      businessPhone?: string | null,
      email?: string | null,
      bio?: string | null,
      image?: string | null,
      businessName?: string | null,
      availabilityDescription?: string | null,
      announcement?: string | null,
      rating?: string | null,
      repeatClientCount?: number | null,
      orderCount?: number | null,
      reviewCount?: number | null,
      specialtyTags?: Array< string | null > | null,
      tagline?: string | null,
      metaTitle?: string | null,
      metaImage?: string | null,
      metaDescription?: string | null,
      deliveryAreaZipcode?: string | null,
      deliveryAreaZipcodes?: Array< string > | null,
      deliveryRadius?: number | null,
      lowestPrice?: string | null,
      subscriptionPlan?: string | null,
      subscriptionPlanDetails?:  {
        __typename: "SubscriptionPlanDetails",
        id?: string | null,
        // Name of the plan ... same as subscriptionPlan for now.
        textComponents?:  Array< {
          __typename: "TextComponent",
          text?: string | null,
          bold?: boolean | null,
        } | null > | null,
        phases?:  Array< {
          __typename: "Phase",
          id?: string | null,
          // Name of a plan ... Starter, etc.
          status?: string | null,
        } | null > | null,
      } | null,
      branding?:  {
        __typename: "Branding",
        coverColor?: string | null,
      } | null,
      typicalPricing?:  {
        __typename: "TypicalPricing",
        summary?:  {
          __typename: "TypicalPricingSummary",
          title?: string | null,
          description?: string | null,
        } | null,
        groceries?: string | null,
        shoppingAndDelivery?: string | null,
        minGratuity?: string | null,
        platform?: string | null,
      } | null,
      allowClientConnection?: boolean | null,
      stripeConnectAcctExists?: boolean | null,
      fullSSNRequired?: boolean | null,
      attnBizProfile?: boolean | null,
      attnDirectDeposit?: boolean | null,
      attnCreditCard?: boolean | null,
      attnServices?: boolean | null,
      attnPassword?: boolean | null,
      statusIdentityVerification?:  {
        __typename: "shopperStatusVariable",
        state?: string | null,
        message?: string | null,
        externalLink?: string | null,
      } | null,
      statusChargeCard?:  {
        __typename: "shopperStatusVariable",
        state?: string | null,
        message?: string | null,
        externalLink?: string | null,
      } | null,
      optInEngage?: boolean | null,
      optInZipcode?: boolean | null,
      deactivated?: boolean | null,
      acceptsReferralNetwork?: boolean | null,
    } | null,
    serviceOfferings?:  Array< {
      __typename: "ServiceOffering",
      id?: string | null,
      serviceName?: string | null,
      serviceImage?: string | null,
      serviceDescription?: string | null,
      defaultErrandBusinessNames?: Array< string | null > | null,
      baseFee?: number | null,
      maxErrands?: number | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      disclaimerText?: string | null,
      useSuggestedPricing?: boolean | null,
    } | null > | null,
    serviceArea?:  {
      __typename: "ServiceArea",
      id?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      description?: string | null,
    } | null,
    serviceTimes?:  Array< {
      __typename: "ServiceTime",
      dayOfWeek?: string | null,
      startTime?: string | null,
      endTime?: string | null,
    } | null > | null,
  } | null,
};

export type CreateSharedListMutationVariables = {
  input: SharedListInput,
};

export type CreateSharedListMutation = {
  // SHARED LIST!
  createSharedList:  {
    __typename: "SharedList",
    id?: string | null,
    owner?: string | null,
    listId?: string | null,
    listName?: string | null,
    storeName?: string | null,
    items?:  Array< {
      __typename: "SharedListItem",
      owner?: string | null,
      listId?: string | null,
      itemId?: string | null,
      catalogId?: string | null,
      position?: number | null,
      name?: string | null,
      image?: string | null,
      unit?: string | null,
      count?: number | null,
      note?: string | null,
      checkedOff?: boolean | null,
      checkedOffTimestamp?: string | null,
      shopperPosition?: number | null,
      shopperCheckedOff?: boolean | null,
      shopperCheckedOffTimestamp?: string | null,
      description?: string | null,
      price?: number | null,
      pricePerUnit?: number | null,
      weight?: number | null,
      weightUnit?: string | null,
      displaySize?: string | null,
      link?: string | null,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
    } | null > | null,
    sharedWith?: Array< string | null > | null,
    clientId?: string | null,
    orderId?: string | null,
    orderTimestamp?: string | null,
    serviceImage?: string | null,
  },
};

export type CopySharedListMutationVariables = {
  owner: string,
  listId: string,
};

export type CopySharedListMutation = {
  // Create a new shared list in your profile from another shared list which you may not own.
  copySharedList:  {
    __typename: "SharedListOperation",
    // Dictates what happened.
    operation?: string | null,
    // IDs for identifying the list, and potentially the item in question.
    owner?: string | null,
    listId?: string | null,
    itemId?: string | null,
    // Related to changing the list itself.
    listName?: string | null,
    storeName?: string | null,
    // Related to add/update/delete items.
    position?: number | null,
    name?: string | null,
    image?: string | null,
    unit?: string | null,
    count?: number | null,
    note?: string | null,
    checkedOff?: boolean | null,
    checkedOffTimestamp?: string | null,
    shopperPosition?: number | null,
    shopperCheckedOff?: boolean | null,
    shopperCheckedOffTimestamp?: string | null,
  },
};

export type AddItemToSharedListMutationVariables = {
  owner: string,
  listId: string,
  input: SharedListItemInput,
};

export type AddItemToSharedListMutation = {
  addItemToSharedList:  {
    __typename: "SharedListOperation",
    // Dictates what happened.
    operation?: string | null,
    // IDs for identifying the list, and potentially the item in question.
    owner?: string | null,
    listId?: string | null,
    itemId?: string | null,
    // Related to changing the list itself.
    listName?: string | null,
    storeName?: string | null,
    // Related to add/update/delete items.
    position?: number | null,
    name?: string | null,
    image?: string | null,
    unit?: string | null,
    count?: number | null,
    note?: string | null,
    checkedOff?: boolean | null,
    checkedOffTimestamp?: string | null,
    shopperPosition?: number | null,
    shopperCheckedOff?: boolean | null,
    shopperCheckedOffTimestamp?: string | null,
  },
};

export type UpdateItemOnSharedListMutationVariables = {
  owner: string,
  listId: string,
  itemId: string,
  input: SharedListItemInput,
};

export type UpdateItemOnSharedListMutation = {
  updateItemOnSharedList:  {
    __typename: "SharedListOperation",
    // Dictates what happened.
    operation?: string | null,
    // IDs for identifying the list, and potentially the item in question.
    owner?: string | null,
    listId?: string | null,
    itemId?: string | null,
    // Related to changing the list itself.
    listName?: string | null,
    storeName?: string | null,
    // Related to add/update/delete items.
    position?: number | null,
    name?: string | null,
    image?: string | null,
    unit?: string | null,
    count?: number | null,
    note?: string | null,
    checkedOff?: boolean | null,
    checkedOffTimestamp?: string | null,
    shopperPosition?: number | null,
    shopperCheckedOff?: boolean | null,
    shopperCheckedOffTimestamp?: string | null,
  },
};

export type BulkUpdateItemOnSharedListMutationVariables = {
  input: SharedListBulkUpdateInput,
};

export type BulkUpdateItemOnSharedListMutation = {
  bulkUpdateItemOnSharedList:  {
    __typename: "SharedListBulkUpdateResponse",
    owner: string,
    listId: string,
    mutationId: string,
    items?:  Array< {
      __typename: "SharedListBulkItemResponse",
      itemId?: string | null,
      position?: number | null,
      name?: string | null,
      image?: string | null,
      unit?: string | null,
      count?: number | null,
      note?: string | null,
      checkedOff?: boolean | null,
      checkedOffTimestamp?: string | null,
      shopperPosition?: number | null,
      shopperCheckedOff?: boolean | null,
      shopperCheckedOffTimestamp?: string | null,
    } | null > | null,
  },
};

export type DeleteItemFromSharedListMutationVariables = {
  owner: string,
  listId: string,
  itemId: string,
};

export type DeleteItemFromSharedListMutation = {
  deleteItemFromSharedList:  {
    __typename: "SharedListOperation",
    // Dictates what happened.
    operation?: string | null,
    // IDs for identifying the list, and potentially the item in question.
    owner?: string | null,
    listId?: string | null,
    itemId?: string | null,
    // Related to changing the list itself.
    listName?: string | null,
    storeName?: string | null,
    // Related to add/update/delete items.
    position?: number | null,
    name?: string | null,
    image?: string | null,
    unit?: string | null,
    count?: number | null,
    note?: string | null,
    checkedOff?: boolean | null,
    checkedOffTimestamp?: string | null,
    shopperPosition?: number | null,
    shopperCheckedOff?: boolean | null,
    shopperCheckedOffTimestamp?: string | null,
  },
};

export type ShareListByPhoneMutationVariables = {
  phone: string,
  owner: string,
  listId: string,
};

export type ShareListByPhoneMutation = {
  shareListByPhone:  {
    __typename: "SharedListIdentifier",
    owner?: string | null,
    listId?: string | null,
    snapshotId?: string | null,
    listName?: string | null,
    storeName?: string | null,
    hasOpenOrder?: boolean | null,
    clientId?: string | null,
    orderId?: string | null,
    orderTimestamp?: string | null,
    serviceImage?: string | null,
    itemCount?: number | null,
    numItems?: number | null,
    numUnits?: number | null,
  },
};

export type AddItemToSharedList2MutationVariables = {
  owner: string,
  listId: string,
  itemId: string,
  input: SharedListItemInput2,
};

export type AddItemToSharedList2Mutation = {
  addItemToSharedList2:  {
    __typename: "SharedListOperation2",
    // Dictates what happened.
    operation?: string | null,
    // IDs for identifying the list, and potentially the item in question.
    owner?: string | null,
    listId?: string | null,
    itemId?: string | null,
    // Related to changing the list itself.
    listName?: string | null,
    storeName?: string | null,
    // Related to add/update/delete items.
    position?: number | null,
    name?: string | null,
    image?: string | null,
    unit?: string | null,
    count?: number | null,
    note?: string | null,
    checkedOff?: boolean | null,
    checkedOffTimestamp?: string | null,
    shopperPosition?: number | null,
    shopperCheckedOff?: boolean | null,
    shopperCheckedOffTimestamp?: string | null,
    description?: string | null,
    price?: number | null,
    pricePerUnit?: number | null,
    weight?: number | null,
    weightUnit?: string | null,
    displaySize?: string | null,
    link?: string | null,
  },
};

export type UpdateItemOnSharedList2MutationVariables = {
  owner: string,
  listId: string,
  itemId: string,
  input: SharedListItemInput2,
};

export type UpdateItemOnSharedList2Mutation = {
  updateItemOnSharedList2:  {
    __typename: "SharedListOperation2",
    // Dictates what happened.
    operation?: string | null,
    // IDs for identifying the list, and potentially the item in question.
    owner?: string | null,
    listId?: string | null,
    itemId?: string | null,
    // Related to changing the list itself.
    listName?: string | null,
    storeName?: string | null,
    // Related to add/update/delete items.
    position?: number | null,
    name?: string | null,
    image?: string | null,
    unit?: string | null,
    count?: number | null,
    note?: string | null,
    checkedOff?: boolean | null,
    checkedOffTimestamp?: string | null,
    shopperPosition?: number | null,
    shopperCheckedOff?: boolean | null,
    shopperCheckedOffTimestamp?: string | null,
    description?: string | null,
    price?: number | null,
    pricePerUnit?: number | null,
    weight?: number | null,
    weightUnit?: string | null,
    displaySize?: string | null,
    link?: string | null,
  },
};

export type DeleteItemFromSharedList2MutationVariables = {
  owner: string,
  listId: string,
  itemId: string,
};

export type DeleteItemFromSharedList2Mutation = {
  deleteItemFromSharedList2:  {
    __typename: "SharedListOperation2",
    // Dictates what happened.
    operation?: string | null,
    // IDs for identifying the list, and potentially the item in question.
    owner?: string | null,
    listId?: string | null,
    itemId?: string | null,
    // Related to changing the list itself.
    listName?: string | null,
    storeName?: string | null,
    // Related to add/update/delete items.
    position?: number | null,
    name?: string | null,
    image?: string | null,
    unit?: string | null,
    count?: number | null,
    note?: string | null,
    checkedOff?: boolean | null,
    checkedOffTimestamp?: string | null,
    shopperPosition?: number | null,
    shopperCheckedOff?: boolean | null,
    shopperCheckedOffTimestamp?: string | null,
    description?: string | null,
    price?: number | null,
    pricePerUnit?: number | null,
    weight?: number | null,
    weightUnit?: string | null,
    displaySize?: string | null,
    link?: string | null,
  },
};

export type DeleteItemFromPastItemsSharedListMutationVariables = {
  itemId: string,
  store: string,
};

export type DeleteItemFromPastItemsSharedListMutation = {
  deleteItemFromPastItemsSharedList?:  {
    __typename: "ProductV3Result",
    id?: string | null,
    dumplingId?: string | null,
    sellerName?: string | null,
    name?: string | null,
    // The store's own unique ID for the product. This could be the SKU.
    sellerId?: string | null,
    available?: boolean | null,
    allowed?: boolean | null,
    // The description of the item should _not_ contain HTML entities or tags.
    description?: string | null,
    upc?: string | null,
    // A 2D array of category paths. Each sub-array is a unique, hierarchical path to the item.
    categories?: Array< string | null > | null,
    price?: number | null,
    salePrice?: number | null,
    clubPrice?: number | null,
    // This is the price per unit (in cents) that this item is measured in.
    pricePerUnit?: number | null,
    salePricePerUnit?: number | null,
    // Sale prices may have effective date range
    // saleStartDate: String
    // saleEndDate: String
    // Either EACH or WEIGHT
    unitType?: string | null,
    // A human-readable unit that this item is weighed or measured by.
    weightUnit?: string | null,
    // If available, the weight or measure of the item specified by `weightUnit`
    weight?: number | null,
    // If provided by the seller, how they represent the size info of a product.
    displaySize?: string | null,
    // A URL of the item image hosted by the store (not our own server).
    imageLink?: string | null,
    // A URL of the item image hosted in our own S3 bucket.
    image?: string | null,
    link?: string | null,
    // This field is only used to convey the note field on the past items screen.
    note?: string | null,
    attributedMedia:  Array< {
      __typename: "AttributedMedia",
      media: ( {
          __typename: "MediaImage",
          small?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          medium?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          large?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          xlarge?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          full:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          },
        }
      ) | null,
      sourceUrl: string,
      hostPageUrl?: string | null,
      hostPageName?: string | null,
    } >,
  } | null,
};

export type UpdateClientReviewMutationVariables = {
  input?: ClientReviewInput | null,
};

export type UpdateClientReviewMutation = {
  // Review related functionality
  updateClientReview?:  Array< {
    __typename: "ClientReview",
    id?: string | null,
    quote?: string | null,
    date?: string | null,
    rating?: number | null,
    clientName?: string | null,
    clientImage?: string | null,
    pinned?: boolean | null,
    hidden?: boolean | null,
  } | null > | null,
};

export type ConnectToClientAccountMutationVariables = {
  clientId: string,
};

export type ConnectToClientAccountMutation = {
  // Client list creation/curation hack.
  connectToClientAccount?:  {
    __typename: "ConnectToClientAccountResult",
    success?: boolean | null,
    message?: string | null,
  } | null,
};

export type AddPostTipToOrderMutationVariables = {
  clientId: string,
  orderId: string,
  orderTimestamp: string,
  paymentMethodId?: string | null,
  amount?: number | null,
};

export type AddPostTipToOrderMutation = {
  addPostTipToOrder?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type DismissPostTipMutationVariables = {
  clientId: string,
  orderId: string,
  orderTimestamp: string,
};

export type DismissPostTipMutation = {
  dismissPostTip?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type DismissReviewMutationVariables = {
  clientId: string,
  orderId: string,
  orderTimestamp: string,
};

export type DismissReviewMutation = {
  dismissReview?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type LeaveOrderReviewMutationVariables = {
  orderId: string,
  orderTimestamp: string,
  rating: number,
  quote: string,
};

export type LeaveOrderReviewMutation = {
  leaveOrderReview?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type CreateSosIssueMutationVariables = {
  reason: string,
  note: string,
  orderId: string,
  deliveryTimestamp: string,
};

export type CreateSosIssueMutation = {
  createSosIssue?:  {
    __typename: "SosIssue",
    reason?: string | null,
    note?: string | null,
    orderId?: string | null,
    deliveryTimestamp?: string | null,
  } | null,
};

export type BossCreatePasswordMutationVariables = {
  password?: string | null,
};

export type BossCreatePasswordMutation = {
  bossCreatePassword?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type ClientCreatePasswordMutationVariables = {
  password?: string | null,
};

export type ClientCreatePasswordMutation = {
  clientCreatePassword?:  {
    __typename: "Client",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    image?: string | null,
    referralSource?: string | null,
    hasShopper?: boolean | null,
    signupTimestamp?: string | null,
    attnPassword?: boolean | null,
    deactivated?: boolean | null,
    hasStreamUser?: boolean | null,
    preferences:  {
      __typename: "ClientPreferences",
      id: string,
      surveys:  Array< {
        __typename: "Survey",
        id: string,
        completedTimestamp: string,
        name: string,
        responses:  Array< {
          __typename: "SurveyResponse",
          id: string,
          question: string,
          response?: string | null,
        } >,
      } >,
    },
  } | null,
};

export type BossChangePlanMutationVariables = {
  id?: string | null,
};

export type BossChangePlanMutation = {
  bossChangePlan?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type BossCreatePaymentMethodMutationVariables = {
  stripeToken?: string | null,
};

export type BossCreatePaymentMethodMutation = {
  bossCreatePaymentMethod?:  {
    __typename: "PaymentMethod",
    id?: string | null,
    brand?: string | null,
    expirationMonth?: number | null,
    expirationYear?: number | null,
    last4?: string | null,
    isDefault?: boolean | null,
    address?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
  } | null,
};

export type BossDeletePaymentMethodMutationVariables = {
  id?: string | null,
};

export type BossDeletePaymentMethodMutation = {
  bossDeletePaymentMethod?:  {
    __typename: "PaymentMethod",
    id?: string | null,
    brand?: string | null,
    expirationMonth?: number | null,
    expirationYear?: number | null,
    last4?: string | null,
    isDefault?: boolean | null,
    address?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
  } | null,
};

export type BossSetDefaultPaymentMethodMutationVariables = {
  id?: string | null,
};

export type BossSetDefaultPaymentMethodMutation = {
  bossSetDefaultPaymentMethod?:  {
    __typename: "PaymentMethod",
    id?: string | null,
    brand?: string | null,
    expirationMonth?: number | null,
    expirationYear?: number | null,
    last4?: string | null,
    isDefault?: boolean | null,
    address?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
  } | null,
};

export type BossExportEarningsReportMutationVariables = {
  period: string,
};

export type BossExportEarningsReportMutation = {
  bossExportEarningsReport: boolean,
};

export type UpdateAutoMessageMutationVariables = {
  id: string,
  input: AutoMessageInput,
};

export type UpdateAutoMessageMutation = {
  updateAutoMessage?:  {
    __typename: "AutoMessage",
    id?: string | null,
    type?: string | null,
    title?: string | null,
    action?: string | null,
    message?: string | null,
    defaultMessage?: string | null,
    description?: string | null,
    enabled?: boolean | null,
    delaySeconds?: number | null,
    defaultDelaySeconds?: number | null,
  } | null,
};

export type CreateListMutationVariables = {
  storeId?: string | null,
};

export type CreateListMutation = {
  // New list experience.
  createList:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type CreateOrFindListMutationVariables = {
  storeId?: string | null,
};

export type CreateOrFindListMutation = {
  createOrFindList:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type DeleteListMutationVariables = {
  listId: string,
};

export type DeleteListMutation = {
  deleteList:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type UpdateItemOnListMutationVariables = {
  listId: string,
  itemId: string,
  itemProperties: ItemPropertiesInput,
};

export type UpdateItemOnListMutation = {
  updateItemOnList:  {
    __typename: "ListProductMutationResult",
    product:  {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    },
    listVersion: string,
    listEstimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    listEstimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type DeleteItemOnListMutationVariables = {
  listId: string,
  itemId: string,
};

export type DeleteItemOnListMutation = {
  deleteItemOnList:  {
    __typename: "ListProductMutationResult",
    product:  {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    },
    listVersion: string,
    listEstimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    listEstimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type MoveItemBetweenListsMutationVariables = {
  fromListId: string,
  toListId: string,
  itemId: string,
};

export type MoveItemBetweenListsMutation = {
  moveItemBetweenLists:  {
    __typename: "ListProductMutationResult",
    product:  {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    },
    listVersion: string,
    listEstimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    listEstimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type MoveAllItemsBetweenListsMutationVariables = {
  fromListId: string,
  toListId: string,
};

export type MoveAllItemsBetweenListsMutation = {
  moveAllItemsBetweenLists:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type UpdateListNameMutationVariables = {
  listId: string,
  name: string,
};

export type UpdateListNameMutation = {
  updateListName:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type DeleteAllItemsFromListMutationVariables = {
  listId: string,
};

export type DeleteAllItemsFromListMutation = {
  deleteAllItemsFromList:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type AddItemToListMutationVariables = {
  listId: string,
  itemId: string,
  itemProperties: ItemPropertiesInput,
};

export type AddItemToListMutation = {
  addItemToList:  {
    __typename: "ListProductMutationResult",
    product:  {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    },
    listVersion: string,
    listEstimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    listEstimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type CreateCustomItemForListMutationVariables = {
  listId: string,
  itemProperties: ItemPropertiesInput,
};

export type CreateCustomItemForListMutation = {
  createCustomItemForList:  {
    __typename: "ListProductMutationResult",
    product:  {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    },
    listVersion: string,
    listEstimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    listEstimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type ShopperUpdateItemOnListMutationVariables = {
  listId: string,
  itemId: string,
  itemProperties: ItemPropertiesInput,
  owner?: string | null,
  snapshot?: string | null,
};

export type ShopperUpdateItemOnListMutation = {
  shopperUpdateItemOnList:  {
    __typename: "ListProductMutationResult",
    product:  {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    },
    listVersion: string,
    listEstimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    listEstimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type ShopperUpdateItemsOnListMutationVariables = {
  listId: string,
  changedItems: Array< ItemChanges >,
  owner?: string | null,
  snapshot?: string | null,
};

export type ShopperUpdateItemsOnListMutation = {
  shopperUpdateItemsOnList:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type ShopperCreateCustomItemForListMutationVariables = {
  listId: string,
  itemProperties: ItemPropertiesInput,
  owner?: string | null,
  snapshot?: string | null,
};

export type ShopperCreateCustomItemForListMutation = {
  shopperCreateCustomItemForList:  {
    __typename: "ListProductMutationResult",
    product:  {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    },
    listVersion: string,
    listEstimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    listEstimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type ShopperReplaceItemInListMutationVariables = {
  listId: string,
  itemId: string,
  replacementProperties: ItemPropertiesInput,
  owner?: string | null,
  snapshot?: string | null,
};

export type ShopperReplaceItemInListMutation = {
  shopperReplaceItemInList:  {
    __typename: "ListProductMutationResult",
    product:  {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    },
    listVersion: string,
    listEstimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    listEstimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type ShopperChangeOrderDeliveryMutationVariables = {
  orderId: string,
  deliveryTimestamp: string,
  deliveryChanges: OrderDeliveryChangesInput,
};

export type ShopperChangeOrderDeliveryMutation = {
  shopperChangeOrderDelivery:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  },
};

export type UpdateLinkedClientAnnotationsMutationVariables = {
  clientId: string,
  annotationChanges: LinkedClientAnnotationsInput,
};

export type UpdateLinkedClientAnnotationsMutation = {
  updateLinkedClientAnnotations:  {
    __typename: "LinkedClientAnnotations",
    id: string,
    note?: string | null,
    image?: string | null,
    noteLastUpdatedTimestamp?: number | null,
    preferencesLastUpdatedTimestamp?: number | null,
    preferencesLastSeenTimestamp?: number | null,
    needsToSeePreferences: boolean,
  },
};

export type CreateInstantPayoutAccountMutationVariables = {
  input: CreateInstantPayoutAccountInput,
};

export type CreateInstantPayoutAccountMutation = {
  createInstantPayoutAccount: ( {
      __typename: "InstantPayoutAccount",
      id: string,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault: boolean,
      isVerified: boolean,
    }
  ),
};

export type UpdateInstantPayoutAccountMutationVariables = {
  id: string,
  input: UpdateInstantPayoutAccountInput,
};

export type UpdateInstantPayoutAccountMutation = {
  updateInstantPayoutAccount:  {
    __typename: "InstantPayoutAccount",
    id: string,
    brand?: string | null,
    expirationMonth?: number | null,
    expirationYear?: number | null,
    last4?: string | null,
    isDefault: boolean,
    isVerified: boolean,
  },
};

export type DeleteInstantPayoutAccountMutationVariables = {
  id: string,
};

export type DeleteInstantPayoutAccountMutation = {
  deleteInstantPayoutAccount:  {
    __typename: "InstantPayoutAccount",
    id: string,
    brand?: string | null,
    expirationMonth?: number | null,
    expirationYear?: number | null,
    last4?: string | null,
    isDefault: boolean,
    isVerified: boolean,
  },
};

export type IssueInstantPayoutMutationVariables = {
  input: InstantPayoutInput,
};

export type IssueInstantPayoutMutation = {
  issueInstantPayout:  {
    __typename: "InstantPayout",
    id: string,
    balance: number,
    fee: number,
    amount: number,
    arrivalTimestamp: number,
    status: string,
  },
};

export type RequestVirtualCardMutationVariables = {
};

export type RequestVirtualCardMutation = {
  requestVirtualCard?: boolean | null,
};

export type RequestCustomUrlMutationVariables = {
};

export type RequestCustomUrlMutation = {
  requestCustomUrl?: boolean | null,
};

export type ReportIncorrectProductDetailsMutationVariables = {
  itemId: string,
};

export type ReportIncorrectProductDetailsMutation = {
  reportIncorrectProductDetails?: boolean | null,
};

export type AdoptCartMutationVariables = {
  proposedCartId: string,
  replaceCart?: boolean | null,
};

export type AdoptCartMutation = {
  adoptCart:  {
    __typename: "CartResponse",
    cart:  {
      __typename: "Cart",
      id: string,
      type: CartType,
      clientId?: string | null,
      shopper?:  {
        __typename: "CartShopper",
        id: string,
        image?: string | null,
        displayName?: string | null,
        isPro: boolean,
        clientCount: number,
        repeatClientCount: number,
      } | null,
      deliveryTimeSlot?:  {
        __typename: "AvailableTimeSlot",
        id: string,
        slotStartIso: string,
        slotEndIso: string,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        scheduledOrders?: number | null,
        bufferDuration: number,
        bufferMode: BufferMode,
        isAvailable?: boolean | null,
        inBuffer: boolean,
        inTimeSlot: boolean,
        availablePromos?:  Array< {
          __typename: "PromoDetails",
          id: string,
          type: PromoType,
          code: string,
          displayName?: string | null,
          discountFixed?: number | null,
          discountPercent?: number | null,
        } > | null,
      } | null,
      preTip?:  {
        __typename: "ChosenPreTip",
        percent?: number | null,
        fixed?: number | null,
      } | null,
      note?: string | null,
      services?:  Array< {
        __typename: "ServiceLists",
        id: string,
        serviceName: string,
        serviceImage?: string | null,
        listIds: Array< string >,
      } > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      paymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      appliedPromos?:  Array< {
        __typename: "PromoDetails",
        id: string,
        type: PromoType,
        code: string,
        displayName?: string | null,
        discountFixed?: number | null,
        discountPercent?: number | null,
      } > | null,
      estimatedTotals?:  Array< {
        __typename: "CartTotalLine",
        type: CartTotalLineType,
        label: string,
        value: string,
      } > | null,
      createdOn: string,
      lastUpdated: string,
    },
    errors?:  Array< {
      __typename: "CartError",
      code: CartErrorCode,
      message: string,
    } > | null,
  },
};

export type AdoptCartWithUpdatesMutationVariables = {
  proposedCartId: string,
  cartUpdates: CartInput,
  replaceCart?: boolean | null,
};

export type AdoptCartWithUpdatesMutation = {
  adoptCartWithUpdates:  {
    __typename: "CartResponse",
    cart:  {
      __typename: "Cart",
      id: string,
      type: CartType,
      clientId?: string | null,
      shopper?:  {
        __typename: "CartShopper",
        id: string,
        image?: string | null,
        displayName?: string | null,
        isPro: boolean,
        clientCount: number,
        repeatClientCount: number,
      } | null,
      deliveryTimeSlot?:  {
        __typename: "AvailableTimeSlot",
        id: string,
        slotStartIso: string,
        slotEndIso: string,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        scheduledOrders?: number | null,
        bufferDuration: number,
        bufferMode: BufferMode,
        isAvailable?: boolean | null,
        inBuffer: boolean,
        inTimeSlot: boolean,
        availablePromos?:  Array< {
          __typename: "PromoDetails",
          id: string,
          type: PromoType,
          code: string,
          displayName?: string | null,
          discountFixed?: number | null,
          discountPercent?: number | null,
        } > | null,
      } | null,
      preTip?:  {
        __typename: "ChosenPreTip",
        percent?: number | null,
        fixed?: number | null,
      } | null,
      note?: string | null,
      services?:  Array< {
        __typename: "ServiceLists",
        id: string,
        serviceName: string,
        serviceImage?: string | null,
        listIds: Array< string >,
      } > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      paymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      appliedPromos?:  Array< {
        __typename: "PromoDetails",
        id: string,
        type: PromoType,
        code: string,
        displayName?: string | null,
        discountFixed?: number | null,
        discountPercent?: number | null,
      } > | null,
      estimatedTotals?:  Array< {
        __typename: "CartTotalLine",
        type: CartTotalLineType,
        label: string,
        value: string,
      } > | null,
      createdOn: string,
      lastUpdated: string,
    },
    errors?:  Array< {
      __typename: "CartError",
      code: CartErrorCode,
      message: string,
    } > | null,
  },
};

export type UpdateCartMutationVariables = {
  cartUpdates: CartInput,
};

export type UpdateCartMutation = {
  updateCart:  {
    __typename: "CartResponse",
    cart:  {
      __typename: "Cart",
      id: string,
      type: CartType,
      clientId?: string | null,
      shopper?:  {
        __typename: "CartShopper",
        id: string,
        image?: string | null,
        displayName?: string | null,
        isPro: boolean,
        clientCount: number,
        repeatClientCount: number,
      } | null,
      deliveryTimeSlot?:  {
        __typename: "AvailableTimeSlot",
        id: string,
        slotStartIso: string,
        slotEndIso: string,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        scheduledOrders?: number | null,
        bufferDuration: number,
        bufferMode: BufferMode,
        isAvailable?: boolean | null,
        inBuffer: boolean,
        inTimeSlot: boolean,
        availablePromos?:  Array< {
          __typename: "PromoDetails",
          id: string,
          type: PromoType,
          code: string,
          displayName?: string | null,
          discountFixed?: number | null,
          discountPercent?: number | null,
        } > | null,
      } | null,
      preTip?:  {
        __typename: "ChosenPreTip",
        percent?: number | null,
        fixed?: number | null,
      } | null,
      note?: string | null,
      services?:  Array< {
        __typename: "ServiceLists",
        id: string,
        serviceName: string,
        serviceImage?: string | null,
        listIds: Array< string >,
      } > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      paymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      appliedPromos?:  Array< {
        __typename: "PromoDetails",
        id: string,
        type: PromoType,
        code: string,
        displayName?: string | null,
        discountFixed?: number | null,
        discountPercent?: number | null,
      } > | null,
      estimatedTotals?:  Array< {
        __typename: "CartTotalLine",
        type: CartTotalLineType,
        label: string,
        value: string,
      } > | null,
      createdOn: string,
      lastUpdated: string,
    },
    errors?:  Array< {
      __typename: "CartError",
      code: CartErrorCode,
      message: string,
    } > | null,
  },
};

export type AddListToCartMutationVariables = {
  listId: string,
  replaceCart?: boolean | null,
};

export type AddListToCartMutation = {
  addListToCart:  {
    __typename: "CartResponse",
    cart:  {
      __typename: "Cart",
      id: string,
      type: CartType,
      clientId?: string | null,
      shopper?:  {
        __typename: "CartShopper",
        id: string,
        image?: string | null,
        displayName?: string | null,
        isPro: boolean,
        clientCount: number,
        repeatClientCount: number,
      } | null,
      deliveryTimeSlot?:  {
        __typename: "AvailableTimeSlot",
        id: string,
        slotStartIso: string,
        slotEndIso: string,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        scheduledOrders?: number | null,
        bufferDuration: number,
        bufferMode: BufferMode,
        isAvailable?: boolean | null,
        inBuffer: boolean,
        inTimeSlot: boolean,
        availablePromos?:  Array< {
          __typename: "PromoDetails",
          id: string,
          type: PromoType,
          code: string,
          displayName?: string | null,
          discountFixed?: number | null,
          discountPercent?: number | null,
        } > | null,
      } | null,
      preTip?:  {
        __typename: "ChosenPreTip",
        percent?: number | null,
        fixed?: number | null,
      } | null,
      note?: string | null,
      services?:  Array< {
        __typename: "ServiceLists",
        id: string,
        serviceName: string,
        serviceImage?: string | null,
        listIds: Array< string >,
      } > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      paymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      appliedPromos?:  Array< {
        __typename: "PromoDetails",
        id: string,
        type: PromoType,
        code: string,
        displayName?: string | null,
        discountFixed?: number | null,
        discountPercent?: number | null,
      } > | null,
      estimatedTotals?:  Array< {
        __typename: "CartTotalLine",
        type: CartTotalLineType,
        label: string,
        value: string,
      } > | null,
      createdOn: string,
      lastUpdated: string,
    },
    errors?:  Array< {
      __typename: "CartError",
      code: CartErrorCode,
      message: string,
    } > | null,
  },
};

export type RemoveListFromCartMutationVariables = {
  listId: string,
};

export type RemoveListFromCartMutation = {
  removeListFromCart:  {
    __typename: "CartResponse",
    cart:  {
      __typename: "Cart",
      id: string,
      type: CartType,
      clientId?: string | null,
      shopper?:  {
        __typename: "CartShopper",
        id: string,
        image?: string | null,
        displayName?: string | null,
        isPro: boolean,
        clientCount: number,
        repeatClientCount: number,
      } | null,
      deliveryTimeSlot?:  {
        __typename: "AvailableTimeSlot",
        id: string,
        slotStartIso: string,
        slotEndIso: string,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        scheduledOrders?: number | null,
        bufferDuration: number,
        bufferMode: BufferMode,
        isAvailable?: boolean | null,
        inBuffer: boolean,
        inTimeSlot: boolean,
        availablePromos?:  Array< {
          __typename: "PromoDetails",
          id: string,
          type: PromoType,
          code: string,
          displayName?: string | null,
          discountFixed?: number | null,
          discountPercent?: number | null,
        } > | null,
      } | null,
      preTip?:  {
        __typename: "ChosenPreTip",
        percent?: number | null,
        fixed?: number | null,
      } | null,
      note?: string | null,
      services?:  Array< {
        __typename: "ServiceLists",
        id: string,
        serviceName: string,
        serviceImage?: string | null,
        listIds: Array< string >,
      } > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      paymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      appliedPromos?:  Array< {
        __typename: "PromoDetails",
        id: string,
        type: PromoType,
        code: string,
        displayName?: string | null,
        discountFixed?: number | null,
        discountPercent?: number | null,
      } > | null,
      estimatedTotals?:  Array< {
        __typename: "CartTotalLine",
        type: CartTotalLineType,
        label: string,
        value: string,
      } > | null,
      createdOn: string,
      lastUpdated: string,
    },
    errors?:  Array< {
      __typename: "CartError",
      code: CartErrorCode,
      message: string,
    } > | null,
  },
};

export type CreateOrderWithCartMutationVariables = {
};

export type CreateOrderWithCartMutation = {
  createOrderWithCart:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  },
};

export type CreateAdditionalOrderMutationVariables = {
  deliveryTimestamp: string,
  orderId: string,
  flatFee: string,
  percent: string,
  applyGratuity: boolean,
};

export type CreateAdditionalOrderMutation = {
  createAdditionalOrder:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  },
};

export type DeactivateClientMutationVariables = {
  id: string,
};

export type DeactivateClientMutation = {
  deactivateClient?:  {
    __typename: "Client",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    image?: string | null,
    referralSource?: string | null,
    hasShopper?: boolean | null,
    signupTimestamp?: string | null,
    attnPassword?: boolean | null,
    deactivated?: boolean | null,
    hasStreamUser?: boolean | null,
    preferences:  {
      __typename: "ClientPreferences",
      id: string,
      surveys:  Array< {
        __typename: "Survey",
        id: string,
        completedTimestamp: string,
        name: string,
        responses:  Array< {
          __typename: "SurveyResponse",
          id: string,
          question: string,
          response?: string | null,
        } >,
      } >,
    },
  } | null,
};

export type ActivateClientMutationVariables = {
  id: string,
};

export type ActivateClientMutation = {
  activateClient?:  {
    __typename: "Client",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    image?: string | null,
    referralSource?: string | null,
    hasShopper?: boolean | null,
    signupTimestamp?: string | null,
    attnPassword?: boolean | null,
    deactivated?: boolean | null,
    hasStreamUser?: boolean | null,
    preferences:  {
      __typename: "ClientPreferences",
      id: string,
      surveys:  Array< {
        __typename: "Survey",
        id: string,
        completedTimestamp: string,
        name: string,
        responses:  Array< {
          __typename: "SurveyResponse",
          id: string,
          question: string,
          response?: string | null,
        } >,
      } >,
    },
  } | null,
};

export type DeleteClientMutationVariables = {
  id: string,
};

export type DeleteClientMutation = {
  deleteClient?:  {
    __typename: "Client",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    image?: string | null,
    referralSource?: string | null,
    hasShopper?: boolean | null,
    signupTimestamp?: string | null,
    attnPassword?: boolean | null,
    deactivated?: boolean | null,
    hasStreamUser?: boolean | null,
    preferences:  {
      __typename: "ClientPreferences",
      id: string,
      surveys:  Array< {
        __typename: "Survey",
        id: string,
        completedTimestamp: string,
        name: string,
        responses:  Array< {
          __typename: "SurveyResponse",
          id: string,
          question: string,
          response?: string | null,
        } >,
      } >,
    },
  } | null,
};

export type DeactivateShopperMutationVariables = {
  id: string,
};

export type DeactivateShopperMutation = {
  deactivateShopper?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type ActivateShopperMutationVariables = {
  id: string,
};

export type ActivateShopperMutation = {
  activateShopper?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type UpdateShopperFundingInfoMutationVariables = {
  id: string,
  fundingProfile?: string | null,
  virtualBalance?: number | null,
  transactionLimit?: number | null,
};

export type UpdateShopperFundingInfoMutation = {
  updateShopperFundingInfo?:  {
    __typename: "ShopperFundingInfo",
    id?: string | null,
    fundingProfile?: string | null,
    merchantCategoryId?: number | null,
    transactionLimit?: number | null,
    dailySpendLimit?: number | null,
    dailySpendLimitCeiling?: number | null,
    virtualBalance?: number | null,
    todaysSpend?: number | null,
    fundingPerOrder?: number | null,
  } | null,
};

export type ReopenOrderMutationVariables = {
  id: string,
  orderId: string,
  deliveryTimestamp: string,
  orderTimestamp: string,
  clientId: string,
};

export type ReopenOrderMutation = {
  reopenOrder?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type UncancelOrderMutationVariables = {
  id: string,
  orderId: string,
  deliveryTimestamp: string,
  orderTimestamp: string,
  clientId: string,
};

export type UncancelOrderMutation = {
  uncancelOrder?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type MoveOrderMutationVariables = {
  srcShopperId: string,
  dstShopperId: string,
  orderId: string,
  deliveryTimestamp: string,
};

export type MoveOrderMutation = {
  moveOrder?: boolean | null,
};

export type UpdateTransactionMutationVariables = {
  shopperId: string,
  cardAcctId: string,
  transactionType: string,
  transactionId: string,
  input?: TransactionFullInput | null,
};

export type UpdateTransactionMutation = {
  updateTransaction?:  {
    __typename: "TransactionFull",
    id?: string | null,
    update_time?: string | null,
    merchantName?: string | null,
    merchantCity?: string | null,
    merchantState?: string | null,
    merchantZip?: string | null,
    merchantCountry?: string | null,
    merchantLocalTime?: string | null,
    transactionUtcTime?: string | null,
    transactionAmount?: number | null,
    image?: string | null,
    ignore?: boolean | null,
  } | null,
};

export type UpdateOrderPricingMutationVariables = {
  orderId: string,
  deliveryTimestamp: string,
  flatFee: string,
  percent: string,
  minFee: string,
  clientPaysPlatform: boolean,
  platformDisplayName?: string | null,
  chosenPercent?: string | null,
  chosenFixedGratuity?: string | null,
};

export type UpdateOrderPricingMutation = {
  updateOrderPricing?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type CreateSyntheticTransactionMutationVariables = {
  cardAcctId: string,
  input?: SyntheticTransactionInput | null,
};

export type CreateSyntheticTransactionMutation = {
  createSyntheticTransaction?:  {
    __typename: "TransactionFull",
    id?: string | null,
    update_time?: string | null,
    merchantName?: string | null,
    merchantCity?: string | null,
    merchantState?: string | null,
    merchantZip?: string | null,
    merchantCountry?: string | null,
    merchantLocalTime?: string | null,
    transactionUtcTime?: string | null,
    transactionAmount?: number | null,
    image?: string | null,
    ignore?: boolean | null,
  } | null,
};

export type UpdateShopperSubscriptionMutationVariables = {
  id?: string | null,
  subscriptionPlan?: string | null,
};

export type UpdateShopperSubscriptionMutation = {
  updateShopperSubscription?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type AdoptCartFromActivityMutationVariables = {
  activityId: string,
};

export type AdoptCartFromActivityMutation = {
  // Activty/Neighborhood Marketplace
  adoptCartFromActivity:  {
    __typename: "CartResponse",
    cart:  {
      __typename: "Cart",
      id: string,
      type: CartType,
      clientId?: string | null,
      shopper?:  {
        __typename: "CartShopper",
        id: string,
        image?: string | null,
        displayName?: string | null,
        isPro: boolean,
        clientCount: number,
        repeatClientCount: number,
      } | null,
      deliveryTimeSlot?:  {
        __typename: "AvailableTimeSlot",
        id: string,
        slotStartIso: string,
        slotEndIso: string,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        scheduledOrders?: number | null,
        bufferDuration: number,
        bufferMode: BufferMode,
        isAvailable?: boolean | null,
        inBuffer: boolean,
        inTimeSlot: boolean,
        availablePromos?:  Array< {
          __typename: "PromoDetails",
          id: string,
          type: PromoType,
          code: string,
          displayName?: string | null,
          discountFixed?: number | null,
          discountPercent?: number | null,
        } > | null,
      } | null,
      preTip?:  {
        __typename: "ChosenPreTip",
        percent?: number | null,
        fixed?: number | null,
      } | null,
      note?: string | null,
      services?:  Array< {
        __typename: "ServiceLists",
        id: string,
        serviceName: string,
        serviceImage?: string | null,
        listIds: Array< string >,
      } > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      paymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      appliedPromos?:  Array< {
        __typename: "PromoDetails",
        id: string,
        type: PromoType,
        code: string,
        displayName?: string | null,
        discountFixed?: number | null,
        discountPercent?: number | null,
      } > | null,
      estimatedTotals?:  Array< {
        __typename: "CartTotalLine",
        type: CartTotalLineType,
        label: string,
        value: string,
      } > | null,
      createdOn: string,
      lastUpdated: string,
    },
    errors?:  Array< {
      __typename: "CartError",
      code: CartErrorCode,
      message: string,
    } > | null,
  },
};

export type AssignLinkedOrdersToMutationVariables = {
  input?: AssignLinkedOrdersToInput | null,
};

export type AssignLinkedOrdersToMutation = {
  // Boss Web Management Stuff
  assignLinkedOrdersTo:  {
    __typename: "PaginatedOrders",
    orders?:  Array< {
      __typename: "Order",
      version?: string | null,
      id?: string | null,
      clientId?: string | null,
      shopperId?: string | null,
      shopperInfo?:  {
        __typename: "ShopperInfo",
        image?: string | null,
        displayName?: string | null,
        email?: string | null,
      } | null,
      // These next five fields are dynamically added to the lookup when doing linkedOrders.
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      clientImage?: string | null,
      note?: string | null,
      privateNote?: string | null,
      adminNote?: string | null,
      conciergeNote?: string | null,
      orderStatus?: string | null,
      orderDateTime?: string | null,
      orderTimestamp?: string | null,
      deliveryDate?: string | null,
      deliveryTime?: string | null,
      deliveryTimestamp?: string | null,
      deliveryStartDateTime?: string | null,
      deliveryEndDateTime?: string | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      orderPaymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      serviceRequestList?:  Array< {
        __typename: "ServiceRequest",
        serviceId?: string | null,
        serviceName?: string | null,
        image?: string | null,
        errandList?:  Array< {
          __typename: "Errand",
          businessName?: string | null,
          shoppingItemCount?: number | null,
          shoppingList?:  Array< {
            __typename: "ShoppingItem",
            id?: string | null,
            itemName?: string | null,
            itemNote?: string | null,
            isDone?: boolean | null,
          } | null > | null,
        } | null > | null,
      } | null > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      tip?: number | null,
      feeAndPreGratuityDisplay?: string | null,
      deliveryFee?: number | null,
      transactions?: Array< string | null > | null,
      couponCode?: string | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
      adjustments?:  Array< {
        __typename: "Adjustment",
        id: string,
        description: string,
        amount: number,
      } > | null,
      lineItems?:  {
        __typename: "LineItems",
        deliveryFee?: number | null,
        tipPercentage?: number | null,
        tipAmount?: number | null,
        platformPercentage?: number | null,
        platformAmount?: number | null,
        subtotal?: number | null,
        coupon?: number | null,
        total?: number | null,
        earnings?: number | null,
        stores?:  Array< {
          __typename: "StoreAmount",
          storeName?: string | null,
          storeAmount?: number | null,
        } | null > | null,
        couponCode?: string | null,
        additionalTipAmount?: number | null,
        adjustmentDescription?: string | null,
        adjustmentAmount?: number | null,
      } | null,
      priceBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      earningsBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      review?:  {
        __typename: "Review",
        id?: string | null,
        quote?: string | null,
        rating?: number | null,
        timestamp?: string | null,
      } | null,
      sharedListIdentifiers?:  Array< {
        __typename: "SharedListIdentifier",
        owner?: string | null,
        listId?: string | null,
        snapshotId?: string | null,
        listName?: string | null,
        storeName?: string | null,
        hasOpenOrder?: boolean | null,
        clientId?: string | null,
        orderId?: string | null,
        orderTimestamp?: string | null,
        serviceImage?: string | null,
        itemCount?: number | null,
        numItems?: number | null,
        numUnits?: number | null,
      } | null > | null,
      listReferences:  Array< {
        __typename: "ListReference",
        storeName: string,
        storeImage: string,
        storeId: string,
        id: string,
        listName: string,
        listItemCount: number,
        listVersion: string,
        lastCompletedOrderId?: string | null,
        savedListId?: string | null,
        savedListItemCount: number,
        savedListVersion?: string | null,
      } >,
      additionalTipAmount?: number | null,
      additionalTipDismissed?: boolean | null,
      pricingData?:  {
        __typename: "OrderPricingData",
        preTip?: number | null,
        loan?: number | null,
      } | null,
      externalTransactions?:  Array< {
        __typename: "ExternalTransaction",
        id: string,
        description: string,
        amount: number,
        image?: string | null,
        attachment?: string | null,
      } | null > | null,
      assignedTo?: Array< string > | null,
      lockoutHours?: number | null,
      parentOrder?:  {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } | null,
      childOrders?:  Array< {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } > | null,
      credits?:  Array< {
        __typename: "OrderCredit",
        id: string,
        description: string,
        amount: number,
      } > | null,
    } | null > | null,
    nextToken?: string | null,
    prevToken?: string | null,
    pageNumber?: number | null,
  },
};

export type ResortDeleteClosedDateMutationVariables = {
  id: string,
};

export type ResortDeleteClosedDateMutation = {
  resortDeleteClosedDate: boolean,
};

export type ResortCreateClosedDateMutationVariables = {
  date: string,
};

export type ResortCreateClosedDateMutation = {
  resortCreateClosedDate:  {
    __typename: "ResortClosedDate",
    id: string,
    date: string,
  },
};

export type UpdateBossBuddyMutationVariables = {
  input: BossBuddyInput,
};

export type UpdateBossBuddyMutation = {
  updateBossBuddy:  {
    __typename: "BossBuddyProfile",
    id: string,
    name: string,
    phone: string,
    permissionLevel: BuddyPermissions,
  },
};

export type DeleteBossBuddyMutationVariables = {
  buddyId: string,
};

export type DeleteBossBuddyMutation = {
  deleteBossBuddy: boolean,
};

export type CreateBossBuddyMutationVariables = {
  input: CreateBossBuddyInput,
};

export type CreateBossBuddyMutation = {
  createBossBuddy:  {
    __typename: "BossBuddyProfile",
    id: string,
    name: string,
    phone: string,
    permissionLevel: BuddyPermissions,
  },
};

export type BossConfirmForgotPasswordMutationVariables = {
  phone?: string | null,
  code?: string | null,
  password?: string | null,
};

export type BossConfirmForgotPasswordMutation = {
  // API Key access for methods that allow password reset and account creation for new clients.
  bossConfirmForgotPassword?:  {
    __typename: "ForgotPasswordStatus",
    status?: boolean | null,
  } | null,
};

export type ClientConfirmForgotPasswordMutationVariables = {
  phone?: string | null,
  code?: string | null,
  password?: string | null,
};

export type ClientConfirmForgotPasswordMutation = {
  clientConfirmForgotPassword?:  {
    __typename: "ForgotPasswordStatus",
    status?: boolean | null,
  } | null,
};

export type ClientCreateAccountMutationVariables = {
  phone?: string | null,
};

export type ClientCreateAccountMutation = {
  clientCreateAccount?:  {
    __typename: "ForgotPasswordStatus",
    status?: boolean | null,
  } | null,
};

export type BossChangePhoneMutationVariables = {
  shopperId?: string | null,
  newPhone?: string | null,
  oldPhone?: string | null,
};

export type BossChangePhoneMutation = {
  bossChangePhone?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type ClientChangePhoneMutationVariables = {
  clientId?: string | null,
  newPhone?: string | null,
  oldPhone?: string | null,
};

export type ClientChangePhoneMutation = {
  clientChangePhone?:  {
    __typename: "Client",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    image?: string | null,
    referralSource?: string | null,
    hasShopper?: boolean | null,
    signupTimestamp?: string | null,
    attnPassword?: boolean | null,
    deactivated?: boolean | null,
    hasStreamUser?: boolean | null,
    preferences:  {
      __typename: "ClientPreferences",
      id: string,
      surveys:  Array< {
        __typename: "Survey",
        id: string,
        completedTimestamp: string,
        name: string,
        responses:  Array< {
          __typename: "SurveyResponse",
          id: string,
          question: string,
          response?: string | null,
        } >,
      } >,
    },
  } | null,
};

export type GlobalLogoutUserMutationVariables = {
  id: string,
  service: string,
  app: string,
};

export type GlobalLogoutUserMutation = {
  globalLogoutUser?:  {
    __typename: "GlobalLogoutUserStatus",
    status?: boolean | null,
  } | null,
};

export type NotifyListChangeMutationVariables = {
  listId: string,
};

export type NotifyListChangeMutation = {
  notifyListChange:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type NotifyCardFundingChangeMutationVariables = {
  userId: string,
};

export type NotifyCardFundingChangeMutation = {
  notifyCardFundingChange:  {
    __typename: "CardFunding",
    userId: string,
    fundingCents: number,
  },
};

export type RemapUserMutationVariables = {
  userType: string,
  fromId: string,
  toId: string,
  expiresAt?: string | null,
};

export type RemapUserMutation = {
  remapUser?:  {
    __typename: "UserRemapping",
    userId: string,
    phoneNumber?: string | null,
    email?: string | null,
    type?: string | null,
    expiresAt?: string | null,
  } | null,
};

export type CreateProposedCartDeepLinkMutationVariables = {
  cartInput: ProposedCartInput,
};

export type CreateProposedCartDeepLinkMutation = {
  // anonymous access
  createProposedCartDeepLink: string,
};

export type ClientQueryVariables = {
  id: string,
};

export type ClientQuery = {
  // Client related.
  client?:  {
    __typename: "Client",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    image?: string | null,
    referralSource?: string | null,
    hasShopper?: boolean | null,
    signupTimestamp?: string | null,
    attnPassword?: boolean | null,
    deactivated?: boolean | null,
    hasStreamUser?: boolean | null,
    preferences:  {
      __typename: "ClientPreferences",
      id: string,
      surveys:  Array< {
        __typename: "Survey",
        id: string,
        completedTimestamp: string,
        name: string,
        responses:  Array< {
          __typename: "SurveyResponse",
          id: string,
          question: string,
          response?: string | null,
        } >,
      } >,
    },
  } | null,
};

export type ResortClientQueryVariables = {
  id: string,
};

export type ResortClientQuery = {
  resortClient?:  {
    __typename: "Client",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    image?: string | null,
    referralSource?: string | null,
    hasShopper?: boolean | null,
    signupTimestamp?: string | null,
    attnPassword?: boolean | null,
    deactivated?: boolean | null,
    hasStreamUser?: boolean | null,
    preferences:  {
      __typename: "ClientPreferences",
      id: string,
      surveys:  Array< {
        __typename: "Survey",
        id: string,
        completedTimestamp: string,
        name: string,
        responses:  Array< {
          __typename: "SurveyResponse",
          id: string,
          question: string,
          response?: string | null,
        } >,
      } >,
    },
  } | null,
};

export type ClientDefaultAddressQueryVariables = {
  id: string,
};

export type ClientDefaultAddressQuery = {
  clientDefaultAddress?:  {
    __typename: "Address",
    id?: string | null,
    addressName?: string | null,
    addressLine1?: string | null,
    addressLine2?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    country?: string | null,
    isDefault?: boolean | null,
  } | null,
};

export type ClientAddressesQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type ClientAddressesQuery = {
  clientAddresses?:  {
    __typename: "PaginatedAddresses",
    addresses?:  Array< {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type AddressSuggestQueryVariables = {
  query: string,
};

export type AddressSuggestQuery = {
  addressSuggest:  Array< {
    __typename: "AddressSearchResult",
    lat: number,
    lon: number,
    addressLine1: string,
    addressLine2?: string | null,
    city: string,
    state: string,
    zipcode: string,
    country: string,
    freeForm: string,
  } >,
};

export type ClientPaymentMethodsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type ClientPaymentMethodsQuery = {
  clientPaymentMethods?:  {
    __typename: "PaginatedPaymentMethods",
    paymentMethods?:  Array< {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ClientOrdersQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type ClientOrdersQuery = {
  clientOrders?:  {
    __typename: "PaginatedOrders",
    orders?:  Array< {
      __typename: "Order",
      version?: string | null,
      id?: string | null,
      clientId?: string | null,
      shopperId?: string | null,
      shopperInfo?:  {
        __typename: "ShopperInfo",
        image?: string | null,
        displayName?: string | null,
        email?: string | null,
      } | null,
      // These next five fields are dynamically added to the lookup when doing linkedOrders.
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      clientImage?: string | null,
      note?: string | null,
      privateNote?: string | null,
      adminNote?: string | null,
      conciergeNote?: string | null,
      orderStatus?: string | null,
      orderDateTime?: string | null,
      orderTimestamp?: string | null,
      deliveryDate?: string | null,
      deliveryTime?: string | null,
      deliveryTimestamp?: string | null,
      deliveryStartDateTime?: string | null,
      deliveryEndDateTime?: string | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      orderPaymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      serviceRequestList?:  Array< {
        __typename: "ServiceRequest",
        serviceId?: string | null,
        serviceName?: string | null,
        image?: string | null,
        errandList?:  Array< {
          __typename: "Errand",
          businessName?: string | null,
          shoppingItemCount?: number | null,
          shoppingList?:  Array< {
            __typename: "ShoppingItem",
            id?: string | null,
            itemName?: string | null,
            itemNote?: string | null,
            isDone?: boolean | null,
          } | null > | null,
        } | null > | null,
      } | null > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      tip?: number | null,
      feeAndPreGratuityDisplay?: string | null,
      deliveryFee?: number | null,
      transactions?: Array< string | null > | null,
      couponCode?: string | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
      adjustments?:  Array< {
        __typename: "Adjustment",
        id: string,
        description: string,
        amount: number,
      } > | null,
      lineItems?:  {
        __typename: "LineItems",
        deliveryFee?: number | null,
        tipPercentage?: number | null,
        tipAmount?: number | null,
        platformPercentage?: number | null,
        platformAmount?: number | null,
        subtotal?: number | null,
        coupon?: number | null,
        total?: number | null,
        earnings?: number | null,
        stores?:  Array< {
          __typename: "StoreAmount",
          storeName?: string | null,
          storeAmount?: number | null,
        } | null > | null,
        couponCode?: string | null,
        additionalTipAmount?: number | null,
        adjustmentDescription?: string | null,
        adjustmentAmount?: number | null,
      } | null,
      priceBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      earningsBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      review?:  {
        __typename: "Review",
        id?: string | null,
        quote?: string | null,
        rating?: number | null,
        timestamp?: string | null,
      } | null,
      sharedListIdentifiers?:  Array< {
        __typename: "SharedListIdentifier",
        owner?: string | null,
        listId?: string | null,
        snapshotId?: string | null,
        listName?: string | null,
        storeName?: string | null,
        hasOpenOrder?: boolean | null,
        clientId?: string | null,
        orderId?: string | null,
        orderTimestamp?: string | null,
        serviceImage?: string | null,
        itemCount?: number | null,
        numItems?: number | null,
        numUnits?: number | null,
      } | null > | null,
      listReferences:  Array< {
        __typename: "ListReference",
        storeName: string,
        storeImage: string,
        storeId: string,
        id: string,
        listName: string,
        listItemCount: number,
        listVersion: string,
        lastCompletedOrderId?: string | null,
        savedListId?: string | null,
        savedListItemCount: number,
        savedListVersion?: string | null,
      } >,
      additionalTipAmount?: number | null,
      additionalTipDismissed?: boolean | null,
      pricingData?:  {
        __typename: "OrderPricingData",
        preTip?: number | null,
        loan?: number | null,
      } | null,
      externalTransactions?:  Array< {
        __typename: "ExternalTransaction",
        id: string,
        description: string,
        amount: number,
        image?: string | null,
        attachment?: string | null,
      } | null > | null,
      assignedTo?: Array< string > | null,
      lockoutHours?: number | null,
      parentOrder?:  {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } | null,
      childOrders?:  Array< {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } > | null,
      credits?:  Array< {
        __typename: "OrderCredit",
        id: string,
        description: string,
        amount: number,
      } > | null,
    } | null > | null,
    nextToken?: string | null,
    prevToken?: string | null,
    pageNumber?: number | null,
  } | null,
};

export type ClientOrdersFilteredQueryVariables = {
  orderStatus?: string | null,
  reverse?: boolean | null,
  count?: number | null,
  nextToken?: string | null,
  serviceName?: string | null,
};

export type ClientOrdersFilteredQuery = {
  clientOrdersFiltered?:  {
    __typename: "PaginatedOrders",
    orders?:  Array< {
      __typename: "Order",
      version?: string | null,
      id?: string | null,
      clientId?: string | null,
      shopperId?: string | null,
      shopperInfo?:  {
        __typename: "ShopperInfo",
        image?: string | null,
        displayName?: string | null,
        email?: string | null,
      } | null,
      // These next five fields are dynamically added to the lookup when doing linkedOrders.
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      clientImage?: string | null,
      note?: string | null,
      privateNote?: string | null,
      adminNote?: string | null,
      conciergeNote?: string | null,
      orderStatus?: string | null,
      orderDateTime?: string | null,
      orderTimestamp?: string | null,
      deliveryDate?: string | null,
      deliveryTime?: string | null,
      deliveryTimestamp?: string | null,
      deliveryStartDateTime?: string | null,
      deliveryEndDateTime?: string | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      orderPaymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      serviceRequestList?:  Array< {
        __typename: "ServiceRequest",
        serviceId?: string | null,
        serviceName?: string | null,
        image?: string | null,
        errandList?:  Array< {
          __typename: "Errand",
          businessName?: string | null,
          shoppingItemCount?: number | null,
          shoppingList?:  Array< {
            __typename: "ShoppingItem",
            id?: string | null,
            itemName?: string | null,
            itemNote?: string | null,
            isDone?: boolean | null,
          } | null > | null,
        } | null > | null,
      } | null > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      tip?: number | null,
      feeAndPreGratuityDisplay?: string | null,
      deliveryFee?: number | null,
      transactions?: Array< string | null > | null,
      couponCode?: string | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
      adjustments?:  Array< {
        __typename: "Adjustment",
        id: string,
        description: string,
        amount: number,
      } > | null,
      lineItems?:  {
        __typename: "LineItems",
        deliveryFee?: number | null,
        tipPercentage?: number | null,
        tipAmount?: number | null,
        platformPercentage?: number | null,
        platformAmount?: number | null,
        subtotal?: number | null,
        coupon?: number | null,
        total?: number | null,
        earnings?: number | null,
        stores?:  Array< {
          __typename: "StoreAmount",
          storeName?: string | null,
          storeAmount?: number | null,
        } | null > | null,
        couponCode?: string | null,
        additionalTipAmount?: number | null,
        adjustmentDescription?: string | null,
        adjustmentAmount?: number | null,
      } | null,
      priceBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      earningsBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      review?:  {
        __typename: "Review",
        id?: string | null,
        quote?: string | null,
        rating?: number | null,
        timestamp?: string | null,
      } | null,
      sharedListIdentifiers?:  Array< {
        __typename: "SharedListIdentifier",
        owner?: string | null,
        listId?: string | null,
        snapshotId?: string | null,
        listName?: string | null,
        storeName?: string | null,
        hasOpenOrder?: boolean | null,
        clientId?: string | null,
        orderId?: string | null,
        orderTimestamp?: string | null,
        serviceImage?: string | null,
        itemCount?: number | null,
        numItems?: number | null,
        numUnits?: number | null,
      } | null > | null,
      listReferences:  Array< {
        __typename: "ListReference",
        storeName: string,
        storeImage: string,
        storeId: string,
        id: string,
        listName: string,
        listItemCount: number,
        listVersion: string,
        lastCompletedOrderId?: string | null,
        savedListId?: string | null,
        savedListItemCount: number,
        savedListVersion?: string | null,
      } >,
      additionalTipAmount?: number | null,
      additionalTipDismissed?: boolean | null,
      pricingData?:  {
        __typename: "OrderPricingData",
        preTip?: number | null,
        loan?: number | null,
      } | null,
      externalTransactions?:  Array< {
        __typename: "ExternalTransaction",
        id: string,
        description: string,
        amount: number,
        image?: string | null,
        attachment?: string | null,
      } | null > | null,
      assignedTo?: Array< string > | null,
      lockoutHours?: number | null,
      parentOrder?:  {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } | null,
      childOrders?:  Array< {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } > | null,
      credits?:  Array< {
        __typename: "OrderCredit",
        id: string,
        description: string,
        amount: number,
      } > | null,
    } | null > | null,
    nextToken?: string | null,
    prevToken?: string | null,
    pageNumber?: number | null,
  } | null,
};

export type ClientPastOrderListsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
  serviceName?: string | null,
};

export type ClientPastOrderListsQuery = {
  clientPastOrderLists?:  {
    __typename: "PaginatedPastOrderLists",
    pastOrderLists:  Array< {
      __typename: "PastOrderList",
      title: string,
      deliveryTimestamp?: string | null,
      categorizedListProducts:  Array< {
        __typename: "CategorizedListProducts",
        category: string,
        categoryEmoji: string,
        listProducts:  Array< {
          __typename: "ListProduct",
          id: string,
          catalogId?: string | null,
          media:  Array<( {
              __typename: "ProductImage",
              imageUrl: string,
            } | {
              __typename: "ProductVideo",
              videoUrl: string,
            }
          ) >,
          attributedMedia:  Array< {
            __typename: "AttributedMedia",
            sourceUrl: string,
            hostPageUrl?: string | null,
            hostPageName?: string | null,
          } >,
          count: number,
          note?: string | null,
          isCustom?: boolean | null,
          name: string,
          priceCents?: number | null,
          displayPrice: string,
          salePriceCents?: number | null,
          saleDisplayPrice?: string | null,
          position: number,
          category: string,
          categoryEmoji: string,
          displayUnit?: string | null,
          referenceLink: string,
          deleted: boolean,
          available: boolean,
          lastUpdatedTimestamp: string,
          shopperNote?: string | null,
          createdByShopperId?: string | null,
          shopperPosition?: number | null,
          shopperCategoryPosition?: number | null,
          shopperCheckedOff: boolean,
          shopperCheckedOffTimestamp: string,
          shopperNotAvailable: boolean,
          selectedProductOptions?:  Array< {
            __typename: "SelectedProductOption",
            name: string,
            selection: string,
          } | null > | null,
          packageLineItems?:  Array< {
            __typename: "PackageLineItem",
            productId: string,
            name: string,
            quantity: number,
            note: string,
          } | null > | null,
        } >,
      } >,
    } >,
    nextToken?: string | null,
  } | null,
};

export type ClientOrderQueryVariables = {
  clientId: string,
  orderId: string,
  orderTimestamp: string,
};

export type ClientOrderQuery = {
  clientOrder?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type AllAccessibleOrdersQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type AllAccessibleOrdersQuery = {
  allAccessibleOrders?:  {
    __typename: "PaginatedSharedOrders",
    sharedOrders?:  Array< {
      __typename: "SharedOrder",
      version?: string | null,
      id?: string | null,
      clientId?: string | null,
      shopperId?: string | null,
      // These next five fields are dynamically added to the lookup when doing linkedOrders.
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      clientImage?: string | null,
      orderStatus?: string | null,
      orderDateTime?: string | null,
      orderTimestamp?: string | null,
      deliveryDate?: string | null,
      deliveryTime?: string | null,
      deliveryTimestamp?: string | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      orderPaymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      serviceRequestList?:  Array< {
        __typename: "ServiceRequest",
        serviceId?: string | null,
        serviceName?: string | null,
        image?: string | null,
        errandList?:  Array< {
          __typename: "Errand",
          businessName?: string | null,
          shoppingItemCount?: number | null,
          shoppingList?:  Array< {
            __typename: "ShoppingItem",
            id?: string | null,
            itemName?: string | null,
            itemNote?: string | null,
            isDone?: boolean | null,
          } | null > | null,
        } | null > | null,
      } | null > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      tip?: number | null,
      deliveryFee?: number | null,
      transactions?: Array< string | null > | null,
      couponCode?: string | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
      lineItems?:  {
        __typename: "LineItems",
        deliveryFee?: number | null,
        tipPercentage?: number | null,
        tipAmount?: number | null,
        platformPercentage?: number | null,
        platformAmount?: number | null,
        subtotal?: number | null,
        coupon?: number | null,
        total?: number | null,
        earnings?: number | null,
        stores?:  Array< {
          __typename: "StoreAmount",
          storeName?: string | null,
          storeAmount?: number | null,
        } | null > | null,
        couponCode?: string | null,
        additionalTipAmount?: number | null,
        adjustmentDescription?: string | null,
        adjustmentAmount?: number | null,
      } | null,
      // rating
      // testimonial
      sharedListIdentifiers?:  Array< {
        __typename: "SharedListIdentifier",
        owner?: string | null,
        listId?: string | null,
        snapshotId?: string | null,
        listName?: string | null,
        storeName?: string | null,
        hasOpenOrder?: boolean | null,
        clientId?: string | null,
        orderId?: string | null,
        orderTimestamp?: string | null,
        serviceImage?: string | null,
        itemCount?: number | null,
        numItems?: number | null,
        numUnits?: number | null,
      } | null > | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type LinkedShopperQueryVariables = {
  id: string,
};

export type LinkedShopperQuery = {
  linkedShopper?:  {
    __typename: "LinkedShopper",
    id?: string | null,
    shopper?:  {
      __typename: "Shopper",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      displayName?: string | null,
      deliveryArea?: string | null,
      websiteUrl?: string | null,
      phone?: string | null,
      businessPhone?: string | null,
      email?: string | null,
      bio?: string | null,
      image?: string | null,
      businessName?: string | null,
      availabilityDescription?: string | null,
      announcement?: string | null,
      rating?: string | null,
      repeatClientCount?: number | null,
      orderCount?: number | null,
      reviewCount?: number | null,
      specialtyTags?: Array< string | null > | null,
      tagline?: string | null,
      metaTitle?: string | null,
      metaImage?: string | null,
      metaDescription?: string | null,
      deliveryAreaZipcode?: string | null,
      deliveryAreaZipcodes?: Array< string > | null,
      deliveryRadius?: number | null,
      lowestPrice?: string | null,
      subscriptionPlan?: string | null,
      subscriptionPlanDetails?:  {
        __typename: "SubscriptionPlanDetails",
        id?: string | null,
        // Name of the plan ... same as subscriptionPlan for now.
        textComponents?:  Array< {
          __typename: "TextComponent",
          text?: string | null,
          bold?: boolean | null,
        } | null > | null,
        phases?:  Array< {
          __typename: "Phase",
          id?: string | null,
          // Name of a plan ... Starter, etc.
          status?: string | null,
        } | null > | null,
      } | null,
      branding?:  {
        __typename: "Branding",
        coverColor?: string | null,
      } | null,
      typicalPricing?:  {
        __typename: "TypicalPricing",
        summary?:  {
          __typename: "TypicalPricingSummary",
          title?: string | null,
          description?: string | null,
        } | null,
        groceries?: string | null,
        shoppingAndDelivery?: string | null,
        minGratuity?: string | null,
        platform?: string | null,
      } | null,
      allowClientConnection?: boolean | null,
      stripeConnectAcctExists?: boolean | null,
      fullSSNRequired?: boolean | null,
      attnBizProfile?: boolean | null,
      attnDirectDeposit?: boolean | null,
      attnCreditCard?: boolean | null,
      attnServices?: boolean | null,
      attnPassword?: boolean | null,
      statusIdentityVerification?:  {
        __typename: "shopperStatusVariable",
        state?: string | null,
        message?: string | null,
        externalLink?: string | null,
      } | null,
      statusChargeCard?:  {
        __typename: "shopperStatusVariable",
        state?: string | null,
        message?: string | null,
        externalLink?: string | null,
      } | null,
      optInEngage?: boolean | null,
      optInZipcode?: boolean | null,
      deactivated?: boolean | null,
      acceptsReferralNetwork?: boolean | null,
    } | null,
    serviceOfferings?:  Array< {
      __typename: "ServiceOffering",
      id?: string | null,
      serviceName?: string | null,
      serviceImage?: string | null,
      serviceDescription?: string | null,
      defaultErrandBusinessNames?: Array< string | null > | null,
      baseFee?: number | null,
      maxErrands?: number | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      disclaimerText?: string | null,
      useSuggestedPricing?: boolean | null,
    } | null > | null,
    serviceArea?:  {
      __typename: "ServiceArea",
      id?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      description?: string | null,
    } | null,
    serviceTimes?:  Array< {
      __typename: "ServiceTime",
      dayOfWeek?: string | null,
      startTime?: string | null,
      endTime?: string | null,
    } | null > | null,
  } | null,
};

export type CheckCouponCodeQueryVariables = {
  couponCode?: string | null,
};

export type CheckCouponCodeQuery = {
  checkCouponCode?:  {
    __typename: "Coupon",
    id?: string | null,
    couponCode?: string | null,
    couponValue?: number | null,
    paidByShopper?: number | null,
    validClientIds?: Array< string | null > | null,
    usesPerClient?: number | null,
  } | null,
};

export type ShopperQueryVariables = {
  id: string,
};

export type ShopperQuery = {
  // Shopper related.
  shopper?:  {
    __typename: "Shopper",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    displayName?: string | null,
    deliveryArea?: string | null,
    websiteUrl?: string | null,
    phone?: string | null,
    businessPhone?: string | null,
    email?: string | null,
    bio?: string | null,
    image?: string | null,
    businessName?: string | null,
    availabilityDescription?: string | null,
    announcement?: string | null,
    rating?: string | null,
    repeatClientCount?: number | null,
    orderCount?: number | null,
    reviewCount?: number | null,
    specialtyTags?: Array< string | null > | null,
    tagline?: string | null,
    metaTitle?: string | null,
    metaImage?: string | null,
    metaDescription?: string | null,
    deliveryAreaZipcode?: string | null,
    deliveryAreaZipcodes?: Array< string > | null,
    deliveryRadius?: number | null,
    lowestPrice?: string | null,
    subscriptionPlan?: string | null,
    subscriptionPlanDetails?:  {
      __typename: "SubscriptionPlanDetails",
      id?: string | null,
      // Name of the plan ... same as subscriptionPlan for now.
      textComponents?:  Array< {
        __typename: "TextComponent",
        text?: string | null,
        bold?: boolean | null,
      } | null > | null,
      phases?:  Array< {
        __typename: "Phase",
        id?: string | null,
        // Name of a plan ... Starter, etc.
        status?: string | null,
      } | null > | null,
    } | null,
    branding?:  {
      __typename: "Branding",
      coverColor?: string | null,
    } | null,
    typicalPricing?:  {
      __typename: "TypicalPricing",
      summary?:  {
        __typename: "TypicalPricingSummary",
        title?: string | null,
        description?: string | null,
      } | null,
      groceries?: string | null,
      shoppingAndDelivery?: string | null,
      minGratuity?: string | null,
      platform?: string | null,
    } | null,
    allowClientConnection?: boolean | null,
    stripeConnectAcctExists?: boolean | null,
    fullSSNRequired?: boolean | null,
    attnBizProfile?: boolean | null,
    attnDirectDeposit?: boolean | null,
    attnCreditCard?: boolean | null,
    attnServices?: boolean | null,
    attnPassword?: boolean | null,
    statusIdentityVerification?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    statusChargeCard?:  {
      __typename: "shopperStatusVariable",
      state?: string | null,
      message?: string | null,
      externalLink?: string | null,
    } | null,
    optInEngage?: boolean | null,
    optInZipcode?: boolean | null,
    deactivated?: boolean | null,
    acceptsReferralNetwork?: boolean | null,
  } | null,
};

export type ShopperIdentityQueryVariables = {
};

export type ShopperIdentityQuery = {
  shopperIdentity?:  {
    __typename: "Identity",
    firstName?: string | null,
    lastName?: string | null,
    dob?: string | null,
    phone?: string | null,
    email?: string | null,
    addressLine1?: string | null,
    addressLine2?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    ssn?: string | null,
    completed?: boolean | null,
  } | null,
};

export type ShopperBusinessProfileQueryVariables = {
  id: string,
};

export type ShopperBusinessProfileQuery = {
  shopperBusinessProfile?:  {
    __typename: "ShopperBusinessProfile",
    shopper?:  {
      __typename: "Shopper",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      displayName?: string | null,
      deliveryArea?: string | null,
      websiteUrl?: string | null,
      phone?: string | null,
      businessPhone?: string | null,
      email?: string | null,
      bio?: string | null,
      image?: string | null,
      businessName?: string | null,
      availabilityDescription?: string | null,
      announcement?: string | null,
      rating?: string | null,
      repeatClientCount?: number | null,
      orderCount?: number | null,
      reviewCount?: number | null,
      specialtyTags?: Array< string | null > | null,
      tagline?: string | null,
      metaTitle?: string | null,
      metaImage?: string | null,
      metaDescription?: string | null,
      deliveryAreaZipcode?: string | null,
      deliveryAreaZipcodes?: Array< string > | null,
      deliveryRadius?: number | null,
      lowestPrice?: string | null,
      subscriptionPlan?: string | null,
      subscriptionPlanDetails?:  {
        __typename: "SubscriptionPlanDetails",
        id?: string | null,
        // Name of the plan ... same as subscriptionPlan for now.
        textComponents?:  Array< {
          __typename: "TextComponent",
          text?: string | null,
          bold?: boolean | null,
        } | null > | null,
        phases?:  Array< {
          __typename: "Phase",
          id?: string | null,
          // Name of a plan ... Starter, etc.
          status?: string | null,
        } | null > | null,
      } | null,
      branding?:  {
        __typename: "Branding",
        coverColor?: string | null,
      } | null,
      typicalPricing?:  {
        __typename: "TypicalPricing",
        summary?:  {
          __typename: "TypicalPricingSummary",
          title?: string | null,
          description?: string | null,
        } | null,
        groceries?: string | null,
        shoppingAndDelivery?: string | null,
        minGratuity?: string | null,
        platform?: string | null,
      } | null,
      allowClientConnection?: boolean | null,
      stripeConnectAcctExists?: boolean | null,
      fullSSNRequired?: boolean | null,
      attnBizProfile?: boolean | null,
      attnDirectDeposit?: boolean | null,
      attnCreditCard?: boolean | null,
      attnServices?: boolean | null,
      attnPassword?: boolean | null,
      statusIdentityVerification?:  {
        __typename: "shopperStatusVariable",
        state?: string | null,
        message?: string | null,
        externalLink?: string | null,
      } | null,
      statusChargeCard?:  {
        __typename: "shopperStatusVariable",
        state?: string | null,
        message?: string | null,
        externalLink?: string | null,
      } | null,
      optInEngage?: boolean | null,
      optInZipcode?: boolean | null,
      deactivated?: boolean | null,
      acceptsReferralNetwork?: boolean | null,
    } | null,
    serviceOfferings?:  Array< {
      __typename: "ServiceOffering",
      id?: string | null,
      serviceName?: string | null,
      serviceImage?: string | null,
      serviceDescription?: string | null,
      defaultErrandBusinessNames?: Array< string | null > | null,
      baseFee?: number | null,
      maxErrands?: number | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      disclaimerText?: string | null,
      useSuggestedPricing?: boolean | null,
    } | null > | null,
  } | null,
};

export type ChargeCardsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type ChargeCardsQuery = {
  chargeCards?:  {
    __typename: "PaginatedChargeCards",
    chargeCards?:  Array< {
      __typename: "ChargeCard",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      status?: string | null,
      message?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ShopperScheduleQueryVariables = {
  id: string,
};

export type ShopperScheduleQuery = {
  // To be depricated
  shopperSchedule?:  {
    __typename: "ShopperSchedule",
    id?: string | null,
    dailySchedules?:  Array< {
      __typename: "DailySchedule",
      id?: string | null,
      day?: string | null,
      timeSlots?:  Array< {
        __typename: "TimeSlot",
        id?: string | null,
        slotStart?: string | null,
        slotEnd?: string | null,
        isActive?: boolean | null,
        bufferDuration?: number | null,
        bufferMode?: BufferMode | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type LinkedShopperScheduleQueryVariables = {
  id: string,
};

export type LinkedShopperScheduleQuery = {
  // To be depricated
  linkedShopperSchedule?:  {
    __typename: "ShopperSchedule",
    id?: string | null,
    dailySchedules?:  Array< {
      __typename: "DailySchedule",
      id?: string | null,
      day?: string | null,
      timeSlots?:  Array< {
        __typename: "TimeSlot",
        id?: string | null,
        slotStart?: string | null,
        slotEnd?: string | null,
        isActive?: boolean | null,
        bufferDuration?: number | null,
        bufferMode?: BufferMode | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type ShopperScheduleV2QueryVariables = {
  id?: string | null,
};

export type ShopperScheduleV2Query = {
  shopperScheduleV2?:  {
    __typename: "ShopperScheduleV2",
    dailySchedules?:  Array< {
      __typename: "DailyScheduleV2",
      id?: string | null,
      day?: string | null,
      timeSlots?:  Array< {
        __typename: "TimeSlotV2",
        id?: string | null,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        bufferDuration?: number | null,
        bufferMode?: BufferMode | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type LinkedShopperScheduleV2QueryVariables = {
  id?: string | null,
};

export type LinkedShopperScheduleV2Query = {
  linkedShopperScheduleV2?:  {
    __typename: "ShopperScheduleV2",
    dailySchedules?:  Array< {
      __typename: "DailyScheduleV2",
      id?: string | null,
      day?: string | null,
      timeSlots?:  Array< {
        __typename: "TimeSlotV2",
        id?: string | null,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        bufferDuration?: number | null,
        bufferMode?: BufferMode | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type ShopperClosedDateRangesQueryVariables = {
  id?: string | null,
  input: ShopperClosedDateRangesInput,
};

export type ShopperClosedDateRangesQuery = {
  shopperClosedDateRanges?:  {
    __typename: "ShopperClosedDateRanges",
    closedDateRanges?:  Array< {
      __typename: "ClosedDateRange",
      id?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      description?: string | null,
    } | null > | null,
  } | null,
};

export type LinkedShopperAvailableScheduleQueryVariables = {
  id?: string | null,
  input: ShopperAvailableScheduleInput,
};

export type LinkedShopperAvailableScheduleQuery = {
  linkedShopperAvailableSchedule?:  {
    __typename: "ShopperAvailableSchedule",
    firstAvailableDayIndex?: number | null,
    firstAvailableTimeSlotOfDayIndex?: number | null,
    dailyAvailableSchedules?:  Array< {
      __typename: "DailyAvailableSchedule",
      day?: string | null,
      date?: string | null,
      isClosed?: boolean | null,
      availableTimeSlots?:  Array< {
        __typename: "AvailableTimeSlot",
        id: string,
        slotStartIso: string,
        slotEndIso: string,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        scheduledOrders?: number | null,
        bufferDuration: number,
        bufferMode: BufferMode,
        isAvailable?: boolean | null,
        inBuffer: boolean,
        inTimeSlot: boolean,
        availablePromos?:  Array< {
          __typename: "PromoDetails",
          id: string,
          type: PromoType,
          code: string,
          displayName?: string | null,
          discountFixed?: number | null,
          discountPercent?: number | null,
        } > | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type ShopperScheduleOptionsQueryVariables = {
  id?: string | null,
};

export type ShopperScheduleOptionsQuery = {
  shopperScheduleOptions?:  {
    __typename: "ShopperScheduleOptions",
    defaultMaxOrders?: number | null,
    defaultTimeSlotDuration?: number | null,
    isScheduleAvailable?: boolean | null,
    defaultBufferDuration: number,
    defaultBufferMode: BufferMode,
  } | null,
};

export type ServiceAreaQueryVariables = {
  id: string,
};

export type ServiceAreaQuery = {
  serviceArea?:  {
    __typename: "ServiceArea",
    id?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    description?: string | null,
  } | null,
};

export type ServiceTimesQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type ServiceTimesQuery = {
  serviceTimes?:  {
    __typename: "PaginatedServiceTimes",
    serviceTimes?:  Array< {
      __typename: "ServiceTime",
      dayOfWeek?: string | null,
      startTime?: string | null,
      endTime?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetLinkedClientQueryVariables = {
  clientId: string,
};

export type GetLinkedClientQuery = {
  getLinkedClient:  {
    __typename: "LinkedClient",
    id?: string | null,
    client?:  {
      __typename: "Client",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      image?: string | null,
      referralSource?: string | null,
      hasShopper?: boolean | null,
      signupTimestamp?: string | null,
      attnPassword?: boolean | null,
      deactivated?: boolean | null,
      hasStreamUser?: boolean | null,
      preferences:  {
        __typename: "ClientPreferences",
        id: string,
        surveys:  Array< {
          __typename: "Survey",
          id: string,
          completedTimestamp: string,
          name: string,
          responses:  Array< {
            __typename: "SurveyResponse",
            id: string,
            question: string,
            response?: string | null,
          } >,
        } >,
      },
    } | null,
    note?: string | null,
    orderCount?: number | null,
    lastOrderTimestamp?: string | null,
    firstConnectTimestamp?: string | null,
    referralSourceMessage?: string | null,
    clientAnnotation:  {
      __typename: "LinkedClientAnnotations",
      id: string,
      note?: string | null,
      image?: string | null,
      noteLastUpdatedTimestamp?: number | null,
      preferencesLastUpdatedTimestamp?: number | null,
      preferencesLastSeenTimestamp?: number | null,
      needsToSeePreferences: boolean,
    },
    lastInviteTimestamp?: string | null,
  },
};

export type LinkedClientsQueryVariables = {
  sortOrder?: string | null,
  count?: number | null,
  nextToken?: string | null,
};

export type LinkedClientsQuery = {
  linkedClients?:  {
    __typename: "PaginatedLinkedClients",
    linkedClients?:  Array< {
      __typename: "LinkedClient",
      id?: string | null,
      client?:  {
        __typename: "Client",
        id?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        email?: string | null,
        image?: string | null,
        referralSource?: string | null,
        hasShopper?: boolean | null,
        signupTimestamp?: string | null,
        attnPassword?: boolean | null,
        deactivated?: boolean | null,
        hasStreamUser?: boolean | null,
        preferences:  {
          __typename: "ClientPreferences",
          id: string,
          surveys:  Array< {
            __typename: "Survey",
            id: string,
            completedTimestamp: string,
            name: string,
          } >,
        },
      } | null,
      note?: string | null,
      orderCount?: number | null,
      lastOrderTimestamp?: string | null,
      firstConnectTimestamp?: string | null,
      referralSourceMessage?: string | null,
      clientAnnotation:  {
        __typename: "LinkedClientAnnotations",
        id: string,
        note?: string | null,
        image?: string | null,
        noteLastUpdatedTimestamp?: number | null,
        preferencesLastUpdatedTimestamp?: number | null,
        preferencesLastSeenTimestamp?: number | null,
        needsToSeePreferences: boolean,
      },
      lastInviteTimestamp?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type FilteredLinkedClientsQueryVariables = {
  sort?: QuerySortInput | null,
  filters?: Array< QueryFilterInput > | null,
  count?: number | null,
  nextToken?: string | null,
};

export type FilteredLinkedClientsQuery = {
  filteredLinkedClients?:  {
    __typename: "PaginatedLinkedClients",
    linkedClients?:  Array< {
      __typename: "LinkedClient",
      id?: string | null,
      client?:  {
        __typename: "Client",
        id?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        email?: string | null,
        image?: string | null,
        referralSource?: string | null,
        hasShopper?: boolean | null,
        signupTimestamp?: string | null,
        attnPassword?: boolean | null,
        deactivated?: boolean | null,
        hasStreamUser?: boolean | null,
        preferences:  {
          __typename: "ClientPreferences",
          id: string,
          surveys:  Array< {
            __typename: "Survey",
            id: string,
            completedTimestamp: string,
            name: string,
          } >,
        },
      } | null,
      note?: string | null,
      orderCount?: number | null,
      lastOrderTimestamp?: string | null,
      firstConnectTimestamp?: string | null,
      referralSourceMessage?: string | null,
      clientAnnotation:  {
        __typename: "LinkedClientAnnotations",
        id: string,
        note?: string | null,
        image?: string | null,
        noteLastUpdatedTimestamp?: number | null,
        preferencesLastUpdatedTimestamp?: number | null,
        preferencesLastSeenTimestamp?: number | null,
        needsToSeePreferences: boolean,
      },
      lastInviteTimestamp?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type LinkedClientsSortFilterOptionsQueryVariables = {
};

export type LinkedClientsSortFilterOptionsQuery = {
  linkedClientsSortFilterOptions?:  {
    __typename: "QuerySortFilterOptions",
    sortOptions:  Array< {
      __typename: "QuerySortOption",
      name: string,
      property: string,
    } >,
    filterOptions:  Array< {
      __typename: "QueryFilterOption",
      name: string,
      property: string,
      type: ( {
          __typename: "DateRangeFilterType",
          minTimestamp?: string | null,
          // smallest timestamp we let them pick (null = no min)
          maxTimestamp?: string | null,
        } | {
          __typename: "IntRangeFilterType",
          minRange?: number | null,
          // smallest number we let them pick (null = no min)
          minValue?: number | null,
          // smallest number of all possible values (null = unknown)
          maxRange?: number | null,
          // largest number we let them pick (null = no max)
          maxValue?: number | null,
        } | {
          __typename: "ChoiceFilterType",
          options:  Array< {
            __typename: string,
            name: string,
            property: string,
          } >,
          isRadioButton: boolean,
        } | {
          __typename: "BooleanFilterType",
          name: string,
        }
      ),
    } >,
  } | null,
};

export type LinkedClientsSortFilterPresetsQueryVariables = {
};

export type LinkedClientsSortFilterPresetsQuery = {
  linkedClientsSortFilterPresets:  Array< {
    __typename: "QuerySortFilterPreset",
    name: string,
    description?: string | null,
    sort?:  {
      __typename: "QuerySort",
      property: string,
      direction: SortDirection,
    } | null,
    filters:  Array< {
      __typename: "QueryFilter",
      operator: FilterOperator,
      property: string,
      values: Array< string >,
    } >,
    children:  Array< {
      __typename: "QuerySortFilterPreset",
      name: string,
      description?: string | null,
      sort?:  {
        __typename: "QuerySort",
        property: string,
        direction: SortDirection,
      } | null,
      filters:  Array< {
        __typename: "QueryFilter",
        operator: FilterOperator,
        property: string,
        values: Array< string >,
      } >,
      children:  Array< {
        __typename: "QuerySortFilterPreset",
        name: string,
        description?: string | null,
        sort?:  {
          __typename: "QuerySort",
          property: string,
          direction: SortDirection,
        } | null,
        filters:  Array< {
          __typename: "QueryFilter",
          operator: FilterOperator,
          property: string,
          values: Array< string >,
        } >,
        children:  Array< {
          __typename: "QuerySortFilterPreset",
          name: string,
          description?: string | null,
          sort?:  {
            __typename: "QuerySort",
            property: string,
            direction: SortDirection,
          } | null,
          filters:  Array< {
            __typename: "QueryFilter",
            operator: FilterOperator,
            property: string,
            values: Array< string >,
          } >,
          children:  Array< {
            __typename: "QuerySortFilterPreset",
            name: string,
            description?: string | null,
          } >,
        } >,
      } >,
    } >,
  } >,
};

export type InvitedClientsQueryVariables = {
  sortOrder?: string | null,
  count?: number | null,
  nextToken?: string | null,
};

export type InvitedClientsQuery = {
  invitedClients?:  {
    __typename: "PaginatedLinkedClients",
    linkedClients?:  Array< {
      __typename: "LinkedClient",
      id?: string | null,
      client?:  {
        __typename: "Client",
        id?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        phone?: string | null,
        email?: string | null,
        image?: string | null,
        referralSource?: string | null,
        hasShopper?: boolean | null,
        signupTimestamp?: string | null,
        attnPassword?: boolean | null,
        deactivated?: boolean | null,
        hasStreamUser?: boolean | null,
        preferences:  {
          __typename: "ClientPreferences",
          id: string,
          surveys:  Array< {
            __typename: "Survey",
            id: string,
            completedTimestamp: string,
            name: string,
          } >,
        },
      } | null,
      note?: string | null,
      orderCount?: number | null,
      lastOrderTimestamp?: string | null,
      firstConnectTimestamp?: string | null,
      referralSourceMessage?: string | null,
      clientAnnotation:  {
        __typename: "LinkedClientAnnotations",
        id: string,
        note?: string | null,
        image?: string | null,
        noteLastUpdatedTimestamp?: number | null,
        preferencesLastUpdatedTimestamp?: number | null,
        preferencesLastSeenTimestamp?: number | null,
        needsToSeePreferences: boolean,
      },
      lastInviteTimestamp?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type DirectDepositAccountsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type DirectDepositAccountsQuery = {
  directDepositAccounts?:  {
    __typename: "PaginatedDirectDepositAccounts",
    directDepositAccounts?:  Array< {
      __typename: "DirectDepositAccount",
      id?: string | null,
      bankName?: string | null,
      accountHolderName?: string | null,
      routingNumber?: string | null,
      last4?: string | null,
      error?: string | null,
      isDefault?: boolean | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ShopperServicesQueryVariables = {
  id: string,
};

export type ShopperServicesQuery = {
  shopperServices?:  Array< {
    __typename: "ServiceOffering",
    id?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
    serviceDescription?: string | null,
    defaultErrandBusinessNames?: Array< string | null > | null,
    baseFee?: number | null,
    maxErrands?: number | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    disclaimerText?: string | null,
    useSuggestedPricing?: boolean | null,
  } | null > | null,
};

export type AllPossibleShopperServicesQueryVariables = {
  id: string,
};

export type AllPossibleShopperServicesQuery = {
  allPossibleShopperServices?:  Array< {
    __typename: "ServiceOffering",
    id?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
    serviceDescription?: string | null,
    defaultErrandBusinessNames?: Array< string | null > | null,
    baseFee?: number | null,
    maxErrands?: number | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    disclaimerText?: string | null,
    useSuggestedPricing?: boolean | null,
  } | null > | null,
};

export type UsedServiceOfferingsListQueryVariables = {
  id?: string | null,
};

export type UsedServiceOfferingsListQuery = {
  usedServiceOfferingsList:  Array< {
    __typename: "ServiceOfferingListItem",
    id?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
  } >,
};

export type UnusedServiceOfferingsListQueryVariables = {
  id?: string | null,
};

export type UnusedServiceOfferingsListQuery = {
  unusedServiceOfferingsList:  Array< {
    __typename: "ServiceOfferingListItem",
    id?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
  } >,
};

export type ServiceOfferingQueryVariables = {
  id: string,
  isNewService: boolean,
};

export type ServiceOfferingQuery = {
  serviceOffering:  {
    __typename: "ServiceOffering",
    id?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
    serviceDescription?: string | null,
    defaultErrandBusinessNames?: Array< string | null > | null,
    baseFee?: number | null,
    maxErrands?: number | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    disclaimerText?: string | null,
    useSuggestedPricing?: boolean | null,
  },
};

export type ShopperCouponsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type ShopperCouponsQuery = {
  shopperCoupons?:  {
    __typename: "PaginatedCoupons",
    coupons?:  Array< {
      __typename: "Coupon",
      id?: string | null,
      couponCode?: string | null,
      couponValue?: number | null,
      paidByShopper?: number | null,
      validClientIds?: Array< string | null > | null,
      usesPerClient?: number | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type LinkedOrdersQueryVariables = {
  orderStatus?: string | null,
  count?: number | null,
  nextToken?: string | null,
};

export type LinkedOrdersQuery = {
  linkedOrders?:  {
    __typename: "PaginatedOrders",
    orders?:  Array< {
      __typename: "Order",
      version?: string | null,
      id?: string | null,
      clientId?: string | null,
      shopperId?: string | null,
      shopperInfo?:  {
        __typename: "ShopperInfo",
        image?: string | null,
        displayName?: string | null,
        email?: string | null,
      } | null,
      // These next five fields are dynamically added to the lookup when doing linkedOrders.
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      clientImage?: string | null,
      note?: string | null,
      privateNote?: string | null,
      adminNote?: string | null,
      conciergeNote?: string | null,
      orderStatus?: string | null,
      orderDateTime?: string | null,
      orderTimestamp?: string | null,
      deliveryDate?: string | null,
      deliveryTime?: string | null,
      deliveryTimestamp?: string | null,
      deliveryStartDateTime?: string | null,
      deliveryEndDateTime?: string | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      orderPaymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      serviceRequestList?:  Array< {
        __typename: "ServiceRequest",
        serviceId?: string | null,
        serviceName?: string | null,
        image?: string | null,
        errandList?:  Array< {
          __typename: "Errand",
          businessName?: string | null,
          shoppingItemCount?: number | null,
          shoppingList?:  Array< {
            __typename: "ShoppingItem",
            id?: string | null,
            itemName?: string | null,
            itemNote?: string | null,
            isDone?: boolean | null,
          } | null > | null,
        } | null > | null,
      } | null > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      tip?: number | null,
      feeAndPreGratuityDisplay?: string | null,
      deliveryFee?: number | null,
      transactions?: Array< string | null > | null,
      couponCode?: string | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
      adjustments?:  Array< {
        __typename: "Adjustment",
        id: string,
        description: string,
        amount: number,
      } > | null,
      lineItems?:  {
        __typename: "LineItems",
        deliveryFee?: number | null,
        tipPercentage?: number | null,
        tipAmount?: number | null,
        platformPercentage?: number | null,
        platformAmount?: number | null,
        subtotal?: number | null,
        coupon?: number | null,
        total?: number | null,
        earnings?: number | null,
        stores?:  Array< {
          __typename: "StoreAmount",
          storeName?: string | null,
          storeAmount?: number | null,
        } | null > | null,
        couponCode?: string | null,
        additionalTipAmount?: number | null,
        adjustmentDescription?: string | null,
        adjustmentAmount?: number | null,
      } | null,
      priceBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      earningsBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      review?:  {
        __typename: "Review",
        id?: string | null,
        quote?: string | null,
        rating?: number | null,
        timestamp?: string | null,
      } | null,
      sharedListIdentifiers?:  Array< {
        __typename: "SharedListIdentifier",
        owner?: string | null,
        listId?: string | null,
        snapshotId?: string | null,
        listName?: string | null,
        storeName?: string | null,
        hasOpenOrder?: boolean | null,
        clientId?: string | null,
        orderId?: string | null,
        orderTimestamp?: string | null,
        serviceImage?: string | null,
        itemCount?: number | null,
        numItems?: number | null,
        numUnits?: number | null,
      } | null > | null,
      listReferences:  Array< {
        __typename: "ListReference",
        storeName: string,
        storeImage: string,
        storeId: string,
        id: string,
        listName: string,
        listItemCount: number,
        listVersion: string,
        lastCompletedOrderId?: string | null,
        savedListId?: string | null,
        savedListItemCount: number,
        savedListVersion?: string | null,
      } >,
      additionalTipAmount?: number | null,
      additionalTipDismissed?: boolean | null,
      pricingData?:  {
        __typename: "OrderPricingData",
        preTip?: number | null,
        loan?: number | null,
      } | null,
      externalTransactions?:  Array< {
        __typename: "ExternalTransaction",
        id: string,
        description: string,
        amount: number,
        image?: string | null,
        attachment?: string | null,
      } | null > | null,
      assignedTo?: Array< string > | null,
      lockoutHours?: number | null,
      parentOrder?:  {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } | null,
      childOrders?:  Array< {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } > | null,
      credits?:  Array< {
        __typename: "OrderCredit",
        id: string,
        description: string,
        amount: number,
      } > | null,
    } | null > | null,
    nextToken?: string | null,
    prevToken?: string | null,
    pageNumber?: number | null,
  } | null,
};

export type FilteredLinkedOrdersQueryVariables = {
  sort?: QuerySortInput | null,
  filters?: Array< QueryFilterInput > | null,
  text?: string | null,
  count?: number | null,
  nextToken?: string | null,
};

export type FilteredLinkedOrdersQuery = {
  filteredLinkedOrders?:  {
    __typename: "PaginatedOrders",
    orders?:  Array< {
      __typename: "Order",
      version?: string | null,
      id?: string | null,
      clientId?: string | null,
      shopperId?: string | null,
      shopperInfo?:  {
        __typename: "ShopperInfo",
        image?: string | null,
        displayName?: string | null,
        email?: string | null,
      } | null,
      // These next five fields are dynamically added to the lookup when doing linkedOrders.
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      clientImage?: string | null,
      note?: string | null,
      privateNote?: string | null,
      adminNote?: string | null,
      conciergeNote?: string | null,
      orderStatus?: string | null,
      orderDateTime?: string | null,
      orderTimestamp?: string | null,
      deliveryDate?: string | null,
      deliveryTime?: string | null,
      deliveryTimestamp?: string | null,
      deliveryStartDateTime?: string | null,
      deliveryEndDateTime?: string | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      orderPaymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      serviceRequestList?:  Array< {
        __typename: "ServiceRequest",
        serviceId?: string | null,
        serviceName?: string | null,
        image?: string | null,
        errandList?:  Array< {
          __typename: "Errand",
          businessName?: string | null,
          shoppingItemCount?: number | null,
          shoppingList?:  Array< {
            __typename: "ShoppingItem",
            id?: string | null,
            itemName?: string | null,
            itemNote?: string | null,
            isDone?: boolean | null,
          } | null > | null,
        } | null > | null,
      } | null > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      tip?: number | null,
      feeAndPreGratuityDisplay?: string | null,
      deliveryFee?: number | null,
      transactions?: Array< string | null > | null,
      couponCode?: string | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
      adjustments?:  Array< {
        __typename: "Adjustment",
        id: string,
        description: string,
        amount: number,
      } > | null,
      lineItems?:  {
        __typename: "LineItems",
        deliveryFee?: number | null,
        tipPercentage?: number | null,
        tipAmount?: number | null,
        platformPercentage?: number | null,
        platformAmount?: number | null,
        subtotal?: number | null,
        coupon?: number | null,
        total?: number | null,
        earnings?: number | null,
        stores?:  Array< {
          __typename: "StoreAmount",
          storeName?: string | null,
          storeAmount?: number | null,
        } | null > | null,
        couponCode?: string | null,
        additionalTipAmount?: number | null,
        adjustmentDescription?: string | null,
        adjustmentAmount?: number | null,
      } | null,
      priceBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      earningsBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      review?:  {
        __typename: "Review",
        id?: string | null,
        quote?: string | null,
        rating?: number | null,
        timestamp?: string | null,
      } | null,
      sharedListIdentifiers?:  Array< {
        __typename: "SharedListIdentifier",
        owner?: string | null,
        listId?: string | null,
        snapshotId?: string | null,
        listName?: string | null,
        storeName?: string | null,
        hasOpenOrder?: boolean | null,
        clientId?: string | null,
        orderId?: string | null,
        orderTimestamp?: string | null,
        serviceImage?: string | null,
        itemCount?: number | null,
        numItems?: number | null,
        numUnits?: number | null,
      } | null > | null,
      listReferences:  Array< {
        __typename: "ListReference",
        storeName: string,
        storeImage: string,
        storeId: string,
        id: string,
        listName: string,
        listItemCount: number,
        listVersion: string,
        lastCompletedOrderId?: string | null,
        savedListId?: string | null,
        savedListItemCount: number,
        savedListVersion?: string | null,
      } >,
      additionalTipAmount?: number | null,
      additionalTipDismissed?: boolean | null,
      pricingData?:  {
        __typename: "OrderPricingData",
        preTip?: number | null,
        loan?: number | null,
      } | null,
      externalTransactions?:  Array< {
        __typename: "ExternalTransaction",
        id: string,
        description: string,
        amount: number,
        image?: string | null,
        attachment?: string | null,
      } | null > | null,
      assignedTo?: Array< string > | null,
      lockoutHours?: number | null,
      parentOrder?:  {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } | null,
      childOrders?:  Array< {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } > | null,
      credits?:  Array< {
        __typename: "OrderCredit",
        id: string,
        description: string,
        amount: number,
      } > | null,
    } | null > | null,
    nextToken?: string | null,
    prevToken?: string | null,
    pageNumber?: number | null,
  } | null,
};

export type LinkedOrderQueryVariables = {
  id: string,
  deliveryTimestamp: string,
};

export type LinkedOrderQuery = {
  linkedOrder?:  {
    __typename: "Order",
    version?: string | null,
    id?: string | null,
    clientId?: string | null,
    shopperId?: string | null,
    shopperInfo?:  {
      __typename: "ShopperInfo",
      image?: string | null,
      displayName?: string | null,
      email?: string | null,
    } | null,
    // These next five fields are dynamically added to the lookup when doing linkedOrders.
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    clientImage?: string | null,
    note?: string | null,
    privateNote?: string | null,
    adminNote?: string | null,
    conciergeNote?: string | null,
    orderStatus?: string | null,
    orderDateTime?: string | null,
    orderTimestamp?: string | null,
    deliveryDate?: string | null,
    deliveryTime?: string | null,
    deliveryTimestamp?: string | null,
    deliveryStartDateTime?: string | null,
    deliveryEndDateTime?: string | null,
    deliveryAddress?:  {
      __typename: "Address",
      id?: string | null,
      addressName?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      country?: string | null,
      isDefault?: boolean | null,
    } | null,
    orderPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    serviceRequestList?:  Array< {
      __typename: "ServiceRequest",
      serviceId?: string | null,
      serviceName?: string | null,
      image?: string | null,
      errandList?:  Array< {
        __typename: "Errand",
        businessName?: string | null,
        shoppingItemCount?: number | null,
        shoppingList?:  Array< {
          __typename: "ShoppingItem",
          id?: string | null,
          itemName?: string | null,
          itemNote?: string | null,
          isDone?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    pricingModel?:  {
      __typename: "PricingModel",
      version?: string | null,
      // This is displayed on the storefront page.
      // It is meant as a terse description of the pricing model.
      // E.g. "My whiteglove service:  $10 + 15%"
      description?: string | null,
      // Term1: flat fee for service.
      flatPm?:  {
        __typename: "FlatPM",
        fee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term2: hourly fee for service.
      hourlyPm?:  {
        __typename: "HourlyPM",
        rate?: string | null,
        billableHours?: string | null,
        minBillableHours?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term3: working capital loan.
      // pexBalance: Int
      // pexBalanceDisplay: Boolean
      // Term4: percent service fee, based on term3, with a floor.
      percentPm?:  {
        __typename: "PercentPM",
        percent?: string | null,
        minFee?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      // Term5: mostly for backwards compatibility with the current model.
      // This is applaied to (pexBalance+serviceFee)
      preTipPm?:  {
        __typename: "PreTipPM",
        chosenPercent?: string | null,
        percentages?: Array< string | null > | null,
        defaultPercentagesIndex?: number | null,
        footer?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
        fixedGratuityOptions?: Array< number | null > | null,
        defaultFixedGratuityOptionsIndex?: number | null,
        chosenFixedGratuity?: number | null,
        gratuityType?: GratuityType | null,
        showPreGratuityByDefault?: boolean | null,
        allowOptionalGratuity?: boolean | null,
        showCustomGratuity?: boolean | null,
      } | null,
      // Term6: client platform fee.
      clientPlatformPm?:  {
        __typename: "ClientPlatformPM",
        percent?: string | null,
        feeTitle?: string | null,
        display?: boolean | null,
      } | null,
      suggestedFlatPm?:  {
        __typename: "SuggestedFlatPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percentages?: Array< number | null > | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedPercentPm?:  {
        __typename: "SuggestedPercentPM",
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
      suggestedFlatPlusPercentPm?:  {
        __typename: "SuggestedFlatPlusPercentPM",
        fee?: number | null,
        feeWarningThreshold?: number | null,
        percent?: number | null,
        minFee?: number | null,
        percentWarningThreshold?: number | null,
        minFeeWarningThreshold?: number | null,
        gratuityType?: GratuityType | null,
        gratuityOptions?: Array< number | null > | null,
        defaultGratuityOptionsIndex?: number | null,
        clientPaysPlatform?: boolean | null,
        showCustomGratuity?: boolean | null,
        title?: string | null,
        description?: string | null,
      } | null,
    } | null,
    tip?: number | null,
    feeAndPreGratuityDisplay?: string | null,
    deliveryFee?: number | null,
    transactions?: Array< string | null > | null,
    couponCode?: string | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
    adjustments?:  Array< {
      __typename: "Adjustment",
      id: string,
      description: string,
      amount: number,
    } > | null,
    lineItems?:  {
      __typename: "LineItems",
      deliveryFee?: number | null,
      tipPercentage?: number | null,
      tipAmount?: number | null,
      platformPercentage?: number | null,
      platformAmount?: number | null,
      subtotal?: number | null,
      coupon?: number | null,
      total?: number | null,
      earnings?: number | null,
      stores?:  Array< {
        __typename: "StoreAmount",
        storeName?: string | null,
        storeAmount?: number | null,
      } | null > | null,
      couponCode?: string | null,
      additionalTipAmount?: number | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
    } | null,
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    review?:  {
      __typename: "Review",
      id?: string | null,
      quote?: string | null,
      rating?: number | null,
      timestamp?: string | null,
    } | null,
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
    additionalTipAmount?: number | null,
    additionalTipDismissed?: boolean | null,
    pricingData?:  {
      __typename: "OrderPricingData",
      preTip?: number | null,
      loan?: number | null,
    } | null,
    externalTransactions?:  Array< {
      __typename: "ExternalTransaction",
      id: string,
      description: string,
      amount: number,
      image?: string | null,
      attachment?: string | null,
      moreAttachments?: Array< string > | null,
    } | null > | null,
    assignedTo?: Array< string > | null,
    lockoutHours?: number | null,
    parentOrder?:  {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } | null,
    childOrders?:  Array< {
      __typename: "OrderReference",
      deliveryTimestamp: string,
      orderTimestamp: string,
      orderId: string,
      clientId: string,
      shopperId: string,
    } > | null,
    credits?:  Array< {
      __typename: "OrderCredit",
      id: string,
      description: string,
      amount: number,
    } > | null,
  } | null,
};

export type LinkedOrderPaymentsBreakdownQueryVariables = {
  id: string,
  deliveryTimestamp: string,
};

export type LinkedOrderPaymentsBreakdownQuery = {
  linkedOrderPaymentsBreakdown?:  {
    __typename: "PriceBreakdown",
    title?: string | null,
    lineItems?:  Array< {
      __typename: "KeyValue",
      key?: string | null,
      value?: string | null,
      type?: KVType | null,
      metadata?:  {
        __typename: "KVMetadata",
        txId?: string | null,
        adjustmentDescription?: string | null,
        paymentUTCTimestamp?: string | null,
        image?: string | null,
      } | null,
    } | null > | null,
    final?:  {
      __typename: "KeyValue",
      key?: string | null,
      value?: string | null,
      type?: KVType | null,
      metadata?:  {
        __typename: "KVMetadata",
        txId?: string | null,
        adjustmentDescription?: string | null,
        paymentUTCTimestamp?: string | null,
        image?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UnusedTransactionsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type UnusedTransactionsQuery = {
  // This is deprecated.
  // allLinkedOrders(count: Int, nextToken: String): PaginatedOrders
  unusedTransactions?:  {
    __typename: "PaginatedTransactions",
    transactions?:  Array< {
      __typename: "Transaction",
      id?: string | null,
      update_time?: string | null,
      merchantName?: string | null,
      merchantCity?: string | null,
      merchantState?: string | null,
      merchantZip?: string | null,
      merchantCountry?: string | null,
      merchantLocalTime?: string | null,
      transactionUtcTime?: string | null,
      transactionAmount?: number | null,
      image?: string | null,
      last4?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type OrderTransactionsQueryVariables = {
  id: string,
  deliveryTimestamp: string,
};

export type OrderTransactionsQuery = {
  orderTransactions?:  Array< {
    __typename: "Transaction",
    id?: string | null,
    update_time?: string | null,
    merchantName?: string | null,
    merchantCity?: string | null,
    merchantState?: string | null,
    merchantZip?: string | null,
    merchantCountry?: string | null,
    merchantLocalTime?: string | null,
    transactionUtcTime?: string | null,
    transactionAmount?: number | null,
    image?: string | null,
    moreImages?: Array< string > | null,
    last4?: string | null,
  } | null > | null,
};

export type OrderLineItemsQueryVariables = {
  id: string,
  deliveryTimestamp: string,
};

export type OrderLineItemsQuery = {
  orderLineItems?:  {
    __typename: "LineItems",
    deliveryFee?: number | null,
    tipPercentage?: number | null,
    tipAmount?: number | null,
    platformPercentage?: number | null,
    platformAmount?: number | null,
    subtotal?: number | null,
    coupon?: number | null,
    total?: number | null,
    earnings?: number | null,
    stores?:  Array< {
      __typename: "StoreAmount",
      storeName?: string | null,
      storeAmount?: number | null,
    } | null > | null,
    couponCode?: string | null,
    additionalTipAmount?: number | null,
    adjustmentDescription?: string | null,
    adjustmentAmount?: number | null,
  } | null,
};

export type PresignedPostUrlQueryVariables = {
  fileName: string,
  contentType: string,
};

export type PresignedPostUrlQuery = {
  presignedPostUrl?:  {
    __typename: "PresignedPostUrlAndUrl",
    presignedPostUrl?: string | null,
    presignedPostUrlFields?: string | null,
    url?: string | null,
  } | null,
};

export type TransactionPresignedPostUrlQueryVariables = {
  contentType: string,
};

export type TransactionPresignedPostUrlQuery = {
  transactionPresignedPostUrl?:  {
    __typename: "TransactionPresignedPostUrlAndUrl",
    fileName?: string | null,
    presignedPostUrl?: string | null,
    presignedPostUrlFields?: string | null,
    url?: string | null,
  } | null,
};

export type ProfileQueryVariables = {
  id: string,
};

export type ProfileQuery = {
  // SHARED LIST!
  // How will profile work?
  profile?:  {
    __typename: "Profile",
    userId?: string | null,
    phone?: string | null,
  } | null,
};

export type GetSharedListByServiceNameQueryVariables = {
  serviceName?: string | null,
};

export type GetSharedListByServiceNameQuery = {
  getSharedListByServiceName?:  {
    __typename: "SharedList",
    id?: string | null,
    owner?: string | null,
    listId?: string | null,
    listName?: string | null,
    storeName?: string | null,
    items?:  Array< {
      __typename: "SharedListItem",
      owner?: string | null,
      listId?: string | null,
      itemId?: string | null,
      catalogId?: string | null,
      position?: number | null,
      name?: string | null,
      image?: string | null,
      unit?: string | null,
      count?: number | null,
      note?: string | null,
      checkedOff?: boolean | null,
      checkedOffTimestamp?: string | null,
      shopperPosition?: number | null,
      shopperCheckedOff?: boolean | null,
      shopperCheckedOffTimestamp?: string | null,
      description?: string | null,
      price?: number | null,
      pricePerUnit?: number | null,
      weight?: number | null,
      weightUnit?: string | null,
      displaySize?: string | null,
      link?: string | null,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
    } | null > | null,
    sharedWith?: Array< string | null > | null,
    clientId?: string | null,
    orderId?: string | null,
    orderTimestamp?: string | null,
    serviceImage?: string | null,
  } | null,
};

export type SharedListQueryVariables = {
  owner: string,
  listId: string,
  snapshotId?: string | null,
};

export type SharedListQuery = {
  sharedList:  {
    __typename: "SharedList",
    id?: string | null,
    owner?: string | null,
    listId?: string | null,
    listName?: string | null,
    storeName?: string | null,
    items?:  Array< {
      __typename: "SharedListItem",
      owner?: string | null,
      listId?: string | null,
      itemId?: string | null,
      catalogId?: string | null,
      position?: number | null,
      name?: string | null,
      image?: string | null,
      unit?: string | null,
      count?: number | null,
      note?: string | null,
      checkedOff?: boolean | null,
      checkedOffTimestamp?: string | null,
      shopperPosition?: number | null,
      shopperCheckedOff?: boolean | null,
      shopperCheckedOffTimestamp?: string | null,
      description?: string | null,
      price?: number | null,
      pricePerUnit?: number | null,
      weight?: number | null,
      weightUnit?: string | null,
      displaySize?: string | null,
      link?: string | null,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
    } | null > | null,
    sharedWith?: Array< string | null > | null,
    clientId?: string | null,
    orderId?: string | null,
    orderTimestamp?: string | null,
    serviceImage?: string | null,
  },
};

export type GetSharedListByServiceNameOrIdsQueryVariables = {
  serviceName?: string | null,
  owner?: string | null,
  listId?: string | null,
  snapshotId?: string | null,
};

export type GetSharedListByServiceNameOrIdsQuery = {
  getSharedListByServiceNameOrIds?:  {
    __typename: "SharedList",
    id?: string | null,
    owner?: string | null,
    listId?: string | null,
    listName?: string | null,
    storeName?: string | null,
    items?:  Array< {
      __typename: "SharedListItem",
      owner?: string | null,
      listId?: string | null,
      itemId?: string | null,
      catalogId?: string | null,
      position?: number | null,
      name?: string | null,
      image?: string | null,
      unit?: string | null,
      count?: number | null,
      note?: string | null,
      checkedOff?: boolean | null,
      checkedOffTimestamp?: string | null,
      shopperPosition?: number | null,
      shopperCheckedOff?: boolean | null,
      shopperCheckedOffTimestamp?: string | null,
      description?: string | null,
      price?: number | null,
      pricePerUnit?: number | null,
      weight?: number | null,
      weightUnit?: string | null,
      displaySize?: string | null,
      link?: string | null,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
    } | null > | null,
    sharedWith?: Array< string | null > | null,
    clientId?: string | null,
    orderId?: string | null,
    orderTimestamp?: string | null,
    serviceImage?: string | null,
  } | null,
};

export type AllSharedListIdentifiersQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type AllSharedListIdentifiersQuery = {
  allSharedListIdentifiers?:  {
    __typename: "PaginatedSharedListIdentifiers",
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type SharedListIdentifiersForServiceNameQueryVariables = {
  serviceName?: string | null,
  count?: number | null,
  nextToken?: string | null,
};

export type SharedListIdentifiersForServiceNameQuery = {
  sharedListIdentifiersForServiceName?:  {
    __typename: "PaginatedSharedListIdentifiers",
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ClientServiceNameSharedListsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type ClientServiceNameSharedListsQuery = {
  clientServiceNameSharedLists?:  {
    __typename: "PaginatedSharedListIdentifiers",
    sharedListIdentifiers?:  Array< {
      __typename: "SharedListIdentifier",
      owner?: string | null,
      listId?: string | null,
      snapshotId?: string | null,
      listName?: string | null,
      storeName?: string | null,
      hasOpenOrder?: boolean | null,
      clientId?: string | null,
      orderId?: string | null,
      orderTimestamp?: string | null,
      serviceImage?: string | null,
      itemCount?: number | null,
      numItems?: number | null,
      numUnits?: number | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type CustomSuggestQueryVariables = {
  store: string,
  text: string,
  timestamp: string,
};

export type CustomSuggestQuery = {
  customSuggest?:  {
    __typename: "ImageLinkResults",
    text?: string | null,
    timestamp?: string | null,
    results?:  Array< {
      __typename: "ImageLinkResult",
      image?: string | null,
      text?: string | null,
    } | null > | null,
  } | null,
};

export type CustomSearchQueryVariables = {
  store: string,
  text: string,
  timestamp: string,
};

export type CustomSearchQuery = {
  customSearch?:  {
    __typename: "ImageLinkResults",
    text?: string | null,
    timestamp?: string | null,
    results?:  Array< {
      __typename: "ImageLinkResult",
      image?: string | null,
      text?: string | null,
    } | null > | null,
  } | null,
};

export type ProductDetailsQueryVariables = {
  productId: string,
  listId?: string | null,
};

export type ProductDetailsQuery = {
  productDetails?:  {
    __typename: "ProductDetails",
    id: string,
    product:  {
      __typename: "Product",
      id: string,
      name: string,
      // The description of the item __cannot__ contain HTML entities or tags.
      description?: string | null,
      // A 2D array of category paths. Each sub-array is a unique, hierarchical path to the item.
      categories?: Array< string > | null,
      price?:  {
        __typename: "ProductPrice",
        cents: number,
        text: string,
      } | null,
      salePrice?:  {
        __typename: "ProductPrice",
        cents: number,
        text: string,
      } | null,
      displaySize?: string | null,
      media:  Array<( {
          __typename: "MediaImage",
          small?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          medium?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          large?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          xlarge?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          full:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          },
        }
      ) | null >,
      link?: string | null,
      isCustom: boolean,
    },
    note?: string | null,
    quantity?: number | null,
  } | null,
};

export type GetStreamTokenQueryVariables = {
  id: string,
};

export type GetStreamTokenQuery = {
  getStreamToken?:  {
    __typename: "StreamToken",
    token: string,
  } | null,
};

export type ProductV3SearchQueryVariables = {
  store: string,
  breadcrumbs: Array< string | null >,
  text: string,
  sortType?: SearchResultsSortOptionType | null,
  count?: number | null,
  listId?: string | null,
  maxDepth?: number | null,
};

export type ProductV3SearchQuery = {
  productV3Search?:  {
    __typename: "ProductV3Results",
    store?: string | null,
    category?: string | null,
    text?: string | null,
    results?:  Array< {
      __typename: "ProductV3Result",
      id?: string | null,
      dumplingId?: string | null,
      sellerName?: string | null,
      name?: string | null,
      // The store's own unique ID for the product. This could be the SKU.
      sellerId?: string | null,
      available?: boolean | null,
      allowed?: boolean | null,
      // The description of the item should _not_ contain HTML entities or tags.
      description?: string | null,
      upc?: string | null,
      // A 2D array of category paths. Each sub-array is a unique, hierarchical path to the item.
      categories?: Array< string | null > | null,
      price?: number | null,
      salePrice?: number | null,
      clubPrice?: number | null,
      // This is the price per unit (in cents) that this item is measured in.
      pricePerUnit?: number | null,
      salePricePerUnit?: number | null,
      // Sale prices may have effective date range
      // saleStartDate: String
      // saleEndDate: String
      // Either EACH or WEIGHT
      unitType?: string | null,
      // A human-readable unit that this item is weighed or measured by.
      weightUnit?: string | null,
      // If available, the weight or measure of the item specified by `weightUnit`
      weight?: number | null,
      // If provided by the seller, how they represent the size info of a product.
      displaySize?: string | null,
      // A URL of the item image hosted by the store (not our own server).
      imageLink?: string | null,
      // A URL of the item image hosted in our own S3 bucket.
      image?: string | null,
      link?: string | null,
      // This field is only used to convey the note field on the past items screen.
      note?: string | null,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
    } | null > | null,
    categories: Array< string >,
  } | null,
};

export type ProductV3StoreCategoriesQueryVariables = {
  store: string,
  breadcrumbs?: Array< string | null > | null,
};

export type ProductV3StoreCategoriesQuery = {
  productV3StoreCategories?:  {
    __typename: "ProductV3StoreCategories",
    store?: string | null,
    categories?: Array< string | null > | null,
  } | null,
};

export type ProductV3StoreCategories2QueryVariables = {
  store: string,
  breadcrumbs?: Array< string | null > | null,
};

export type ProductV3StoreCategories2Query = {
  productV3StoreCategories2?:  {
    __typename: "ProductV3StoreCategories",
    store?: string | null,
    categories?: Array< string | null > | null,
  } | null,
};

export type ProductV3SuggestQueryVariables = {
  store: string,
  text: string,
  timestamp: string,
};

export type ProductV3SuggestQuery = {
  productV3Suggest?:  {
    __typename: "ImageLinkResults",
    text?: string | null,
    timestamp?: string | null,
    results?:  Array< {
      __typename: "ImageLinkResult",
      image?: string | null,
      text?: string | null,
    } | null > | null,
  } | null,
};

export type GenericProductSearchQueryVariables = {
  store: string,
  text: string,
  breadcrumbs?: Array< string | null > | null,
  count?: number | null,
  listId?: string | null,
  maxDepth?: number | null,
  limitGroupTypes?: Array< GenericProductResultsGroupType | null > | null,
};

export type GenericProductSearchQuery = {
  genericProductSearch?:  Array< {
    __typename: "GenericProductResultsGroup",
    store: string,
    title: string,
    subTitle?: string | null,
    description?: string | null,
    externalUrl?: string | null,
    internalUrl?: string | null,
    type: GenericProductResultsGroupType,
    results?:  Array< {
      __typename: "ProductV3Result",
      id?: string | null,
      dumplingId?: string | null,
      sellerName?: string | null,
      name?: string | null,
      // The store's own unique ID for the product. This could be the SKU.
      sellerId?: string | null,
      available?: boolean | null,
      allowed?: boolean | null,
      // The description of the item should _not_ contain HTML entities or tags.
      description?: string | null,
      upc?: string | null,
      // A 2D array of category paths. Each sub-array is a unique, hierarchical path to the item.
      categories?: Array< string | null > | null,
      price?: number | null,
      salePrice?: number | null,
      clubPrice?: number | null,
      // This is the price per unit (in cents) that this item is measured in.
      pricePerUnit?: number | null,
      salePricePerUnit?: number | null,
      // Sale prices may have effective date range
      // saleStartDate: String
      // saleEndDate: String
      // Either EACH or WEIGHT
      unitType?: string | null,
      // A human-readable unit that this item is weighed or measured by.
      weightUnit?: string | null,
      // If available, the weight or measure of the item specified by `weightUnit`
      weight?: number | null,
      // If provided by the seller, how they represent the size info of a product.
      displaySize?: string | null,
      // A URL of the item image hosted by the store (not our own server).
      imageLink?: string | null,
      // A URL of the item image hosted in our own S3 bucket.
      image?: string | null,
      link?: string | null,
      // This field is only used to convey the note field on the past items screen.
      note?: string | null,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
    } | null > | null,
  } | null > | null,
};

export type PastItemsQueryVariables = {
  store: string,
};

export type PastItemsQuery = {
  pastItems?:  {
    __typename: "ProductV3Results",
    store?: string | null,
    category?: string | null,
    text?: string | null,
    results?:  Array< {
      __typename: "ProductV3Result",
      id?: string | null,
      dumplingId?: string | null,
      sellerName?: string | null,
      name?: string | null,
      // The store's own unique ID for the product. This could be the SKU.
      sellerId?: string | null,
      available?: boolean | null,
      allowed?: boolean | null,
      // The description of the item should _not_ contain HTML entities or tags.
      description?: string | null,
      upc?: string | null,
      // A 2D array of category paths. Each sub-array is a unique, hierarchical path to the item.
      categories?: Array< string | null > | null,
      price?: number | null,
      salePrice?: number | null,
      clubPrice?: number | null,
      // This is the price per unit (in cents) that this item is measured in.
      pricePerUnit?: number | null,
      salePricePerUnit?: number | null,
      // Sale prices may have effective date range
      // saleStartDate: String
      // saleEndDate: String
      // Either EACH or WEIGHT
      unitType?: string | null,
      // A human-readable unit that this item is weighed or measured by.
      weightUnit?: string | null,
      // If available, the weight or measure of the item specified by `weightUnit`
      weight?: number | null,
      // If provided by the seller, how they represent the size info of a product.
      displaySize?: string | null,
      // A URL of the item image hosted by the store (not our own server).
      imageLink?: string | null,
      // A URL of the item image hosted in our own S3 bucket.
      image?: string | null,
      link?: string | null,
      // This field is only used to convey the note field on the past items screen.
      note?: string | null,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
    } | null > | null,
    categories: Array< string >,
  } | null,
};

export type ClientReviewsQueryVariables = {
  sortOrder?: string | null,
  count?: number | null,
  nextToken?: string | null,
};

export type ClientReviewsQuery = {
  // Reveiw related queries.
  clientReviews?:  {
    __typename: "PaginatedClientReviews",
    clientReviews?:  Array< {
      __typename: "ClientReview",
      id?: string | null,
      quote?: string | null,
      date?: string | null,
      rating?: number | null,
      clientName?: string | null,
      clientImage?: string | null,
      pinned?: boolean | null,
      hidden?: boolean | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ShopperReviewsQueryVariables = {
  shopperId: string,
  count?: number | null,
  nextToken?: string | null,
};

export type ShopperReviewsQuery = {
  // This query will not return hidden reviews.
  shopperReviews?:  {
    __typename: "PaginatedClientReviews",
    clientReviews?:  Array< {
      __typename: "ClientReview",
      id?: string | null,
      quote?: string | null,
      date?: string | null,
      rating?: number | null,
      clientName?: string | null,
      clientImage?: string | null,
      pinned?: boolean | null,
      hidden?: boolean | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ShopperGeoSearchQueryVariables = {
  zipcode?: string | null,
  count?: number | null,
  nextToken?: string | null,
};

export type ShopperGeoSearchQuery = {
  // For geosearch and drill in results.
  shopperGeoSearch?:  {
    __typename: "PaginatedShopperGeoSearchResults",
    announcement?: string | null,
    shoppers?:  Array< {
      __typename: "Shopper",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      displayName?: string | null,
      deliveryArea?: string | null,
      websiteUrl?: string | null,
      phone?: string | null,
      businessPhone?: string | null,
      email?: string | null,
      bio?: string | null,
      image?: string | null,
      businessName?: string | null,
      availabilityDescription?: string | null,
      announcement?: string | null,
      rating?: string | null,
      repeatClientCount?: number | null,
      orderCount?: number | null,
      reviewCount?: number | null,
      specialtyTags?: Array< string | null > | null,
      tagline?: string | null,
      metaTitle?: string | null,
      metaImage?: string | null,
      metaDescription?: string | null,
      deliveryAreaZipcode?: string | null,
      deliveryAreaZipcodes?: Array< string > | null,
      deliveryRadius?: number | null,
      lowestPrice?: string | null,
      subscriptionPlan?: string | null,
      subscriptionPlanDetails?:  {
        __typename: "SubscriptionPlanDetails",
        id?: string | null,
        // Name of the plan ... same as subscriptionPlan for now.
        textComponents?:  Array< {
          __typename: "TextComponent",
          text?: string | null,
          bold?: boolean | null,
        } | null > | null,
        phases?:  Array< {
          __typename: "Phase",
          id?: string | null,
          // Name of a plan ... Starter, etc.
          status?: string | null,
        } | null > | null,
      } | null,
      branding?:  {
        __typename: "Branding",
        coverColor?: string | null,
      } | null,
      typicalPricing?:  {
        __typename: "TypicalPricing",
        summary?:  {
          __typename: "TypicalPricingSummary",
          title?: string | null,
          description?: string | null,
        } | null,
        groceries?: string | null,
        shoppingAndDelivery?: string | null,
        minGratuity?: string | null,
        platform?: string | null,
      } | null,
      allowClientConnection?: boolean | null,
      stripeConnectAcctExists?: boolean | null,
      fullSSNRequired?: boolean | null,
      attnBizProfile?: boolean | null,
      attnDirectDeposit?: boolean | null,
      attnCreditCard?: boolean | null,
      attnServices?: boolean | null,
      attnPassword?: boolean | null,
      statusIdentityVerification?:  {
        __typename: "shopperStatusVariable",
        state?: string | null,
        message?: string | null,
        externalLink?: string | null,
      } | null,
      statusChargeCard?:  {
        __typename: "shopperStatusVariable",
        state?: string | null,
        message?: string | null,
        externalLink?: string | null,
      } | null,
      optInEngage?: boolean | null,
      optInZipcode?: boolean | null,
      deactivated?: boolean | null,
      acceptsReferralNetwork?: boolean | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ShopperDetailsQueryVariables = {
  shopperId: string,
};

export type ShopperDetailsQuery = {
  shopperDetails?:  {
    __typename: "ShopperDetails",
    // This ID is the ID inside of shopper.
    id?: string | null,
    shopper?:  {
      __typename: "Shopper",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      displayName?: string | null,
      deliveryArea?: string | null,
      websiteUrl?: string | null,
      phone?: string | null,
      businessPhone?: string | null,
      email?: string | null,
      bio?: string | null,
      image?: string | null,
      businessName?: string | null,
      availabilityDescription?: string | null,
      announcement?: string | null,
      rating?: string | null,
      repeatClientCount?: number | null,
      orderCount?: number | null,
      reviewCount?: number | null,
      specialtyTags?: Array< string | null > | null,
      tagline?: string | null,
      metaTitle?: string | null,
      metaImage?: string | null,
      metaDescription?: string | null,
      deliveryAreaZipcode?: string | null,
      deliveryAreaZipcodes?: Array< string > | null,
      deliveryRadius?: number | null,
      lowestPrice?: string | null,
      subscriptionPlan?: string | null,
      subscriptionPlanDetails?:  {
        __typename: "SubscriptionPlanDetails",
        id?: string | null,
        // Name of the plan ... same as subscriptionPlan for now.
        textComponents?:  Array< {
          __typename: "TextComponent",
          text?: string | null,
          bold?: boolean | null,
        } | null > | null,
        phases?:  Array< {
          __typename: "Phase",
          id?: string | null,
          // Name of a plan ... Starter, etc.
          status?: string | null,
        } | null > | null,
      } | null,
      branding?:  {
        __typename: "Branding",
        coverColor?: string | null,
      } | null,
      typicalPricing?:  {
        __typename: "TypicalPricing",
        summary?:  {
          __typename: "TypicalPricingSummary",
          title?: string | null,
          description?: string | null,
        } | null,
        groceries?: string | null,
        shoppingAndDelivery?: string | null,
        minGratuity?: string | null,
        platform?: string | null,
      } | null,
      allowClientConnection?: boolean | null,
      stripeConnectAcctExists?: boolean | null,
      fullSSNRequired?: boolean | null,
      attnBizProfile?: boolean | null,
      attnDirectDeposit?: boolean | null,
      attnCreditCard?: boolean | null,
      attnServices?: boolean | null,
      attnPassword?: boolean | null,
      statusIdentityVerification?:  {
        __typename: "shopperStatusVariable",
        state?: string | null,
        message?: string | null,
        externalLink?: string | null,
      } | null,
      statusChargeCard?:  {
        __typename: "shopperStatusVariable",
        state?: string | null,
        message?: string | null,
        externalLink?: string | null,
      } | null,
      optInEngage?: boolean | null,
      optInZipcode?: boolean | null,
      deactivated?: boolean | null,
      acceptsReferralNetwork?: boolean | null,
    } | null,
    serviceOfferings?:  Array< {
      __typename: "ServiceOffering",
      id?: string | null,
      serviceName?: string | null,
      serviceImage?: string | null,
      serviceDescription?: string | null,
      defaultErrandBusinessNames?: Array< string | null > | null,
      baseFee?: number | null,
      maxErrands?: number | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      disclaimerText?: string | null,
      useSuggestedPricing?: boolean | null,
    } | null > | null,
    shopperSchedule?:  {
      __typename: "ShopperSchedule",
      id?: string | null,
      dailySchedules?:  Array< {
        __typename: "DailySchedule",
        id?: string | null,
        day?: string | null,
        timeSlots?:  Array< {
          __typename: "TimeSlot",
          id?: string | null,
          slotStart?: string | null,
          slotEnd?: string | null,
          isActive?: boolean | null,
          bufferDuration?: number | null,
          bufferMode?: BufferMode | null,
        } | null > | null,
      } | null > | null,
    } | null,
  } | null,
};

export type EstimatedCartTotalQueryVariables = {
  owner: string,
  listId: string,
  snapshotId?: string | null,
};

export type EstimatedCartTotalQuery = {
  // List total related.
  estimatedCartTotal?:  {
    __typename: "EstimatedCartTotal",
    owner?: string | null,
    listId?: string | null,
    snapshotId?: string | null,
    cartTotalLines?:  Array< {
      __typename: "EstimatedCartTotalLine",
      count?: number | null,
      label?: string | null,
      value?: string | null,
    } | null > | null,
    cartTotal?:  {
      __typename: "EstimatedCartTotalLine",
      count?: number | null,
      label?: string | null,
      value?: string | null,
    } | null,
  } | null,
};

export type EstimatedOrderTotalQueryVariables = {
  deliveryFee: number,
  tip?: number | null,
  couponCode?: string | null,
  owner: string,
  listId: string,
  snapshotId?: string | null,
};

export type EstimatedOrderTotalQuery = {
  estimatedOrderTotal?:  {
    __typename: "EstimatedOrderTotal",
    deliveryFee?: number | null,
    tip?: number | null,
    couponCode?: string | null,
    owner?: string | null,
    listId?: string | null,
    snapshotId?: string | null,
    orderTotalLines?:  Array< {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null > | null,
    orderCoupon?:  {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null,
    orderTotal?:  {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null,
    authValue?: string | null,
  } | null,
};

export type EstimatedOrderTotalPreviewQueryVariables = {
  input?: OrderPreviewInput | null,
};

export type EstimatedOrderTotalPreviewQuery = {
  estimatedOrderTotalPreview?:  {
    __typename: "EstimatedOrderTotal",
    deliveryFee?: number | null,
    tip?: number | null,
    couponCode?: string | null,
    owner?: string | null,
    listId?: string | null,
    snapshotId?: string | null,
    orderTotalLines?:  Array< {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null > | null,
    orderCoupon?:  {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null,
    orderTotal?:  {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null,
    authValue?: string | null,
  } | null,
};

export type EstimatedOrderTotalClientQueryVariables = {
  orderId?: string | null,
  orderTimestamp?: string | null,
};

export type EstimatedOrderTotalClientQuery = {
  estimatedOrderTotalClient?:  {
    __typename: "EstimatedOrderTotal",
    deliveryFee?: number | null,
    tip?: number | null,
    couponCode?: string | null,
    owner?: string | null,
    listId?: string | null,
    snapshotId?: string | null,
    orderTotalLines?:  Array< {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null > | null,
    orderCoupon?:  {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null,
    orderTotal?:  {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null,
    authValue?: string | null,
  } | null,
};

export type PostTipQueryVariables = {
  orderId?: string | null,
  orderTimestamp?: string | null,
};

export type PostTipQuery = {
  postTip?:  {
    __typename: "PostTip",
    baseDisplayAmount?: string | null,
  } | null,
};

export type EstimatedOrderTotalShopperQueryVariables = {
  orderId?: string | null,
  deliveryTimestamp?: string | null,
};

export type EstimatedOrderTotalShopperQuery = {
  estimatedOrderTotalShopper?:  {
    __typename: "EstimatedOrderTotal",
    deliveryFee?: number | null,
    tip?: number | null,
    couponCode?: string | null,
    owner?: string | null,
    listId?: string | null,
    snapshotId?: string | null,
    orderTotalLines?:  Array< {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null > | null,
    orderCoupon?:  {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null,
    orderTotal?:  {
      __typename: "EstimatedOrderTotalLine",
      label?: string | null,
      value?: string | null,
      icon?: IconType | null,
    } | null,
    authValue?: string | null,
  } | null,
};

export type PostTipReferencesQueryVariables = {
  clientId: string,
};

export type PostTipReferencesQuery = {
  postTipReferences?:  Array< {
    __typename: "PostTipReference",
    orderId?: string | null,
    clientId?: string | null,
    orderTimestamp?: string | null,
  } | null > | null,
};

export type PostTipInfoQueryVariables = {
  clientId: string,
  orderId: string,
  orderTimestamp: string,
};

export type PostTipInfoQuery = {
  postTipInfo?:  {
    __typename: "PostTipInfo",
    orderId?: string | null,
    clientId?: string | null,
    orderTimestamp?: string | null,
    orderTotal?: number | null,
    preTipAmount?: string | null,
    shopperDisplayName?: string | null,
    shopperImage?: string | null,
    serviceName?: string | null,
    serviceImage?: string | null,
  } | null,
};

export type OrderPostGratuityAndReviewInfosQueryVariables = {
  clientId: string,
};

export type OrderPostGratuityAndReviewInfosQuery = {
  orderPostGratuityAndReviewInfos?:  Array< {
    __typename: "OrderPostGratuityAndReviewInfo",
    showPostGratuity: boolean,
    showReview: boolean,
    order:  {
      __typename: "Order",
      version?: string | null,
      id?: string | null,
      clientId?: string | null,
      shopperId?: string | null,
      shopperInfo?:  {
        __typename: "ShopperInfo",
        image?: string | null,
        displayName?: string | null,
        email?: string | null,
      } | null,
      // These next five fields are dynamically added to the lookup when doing linkedOrders.
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      clientImage?: string | null,
      note?: string | null,
      privateNote?: string | null,
      adminNote?: string | null,
      conciergeNote?: string | null,
      orderStatus?: string | null,
      orderDateTime?: string | null,
      orderTimestamp?: string | null,
      deliveryDate?: string | null,
      deliveryTime?: string | null,
      deliveryTimestamp?: string | null,
      deliveryStartDateTime?: string | null,
      deliveryEndDateTime?: string | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      orderPaymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      serviceRequestList?:  Array< {
        __typename: "ServiceRequest",
        serviceId?: string | null,
        serviceName?: string | null,
        image?: string | null,
        errandList?:  Array< {
          __typename: "Errand",
          businessName?: string | null,
          shoppingItemCount?: number | null,
          shoppingList?:  Array< {
            __typename: "ShoppingItem",
            id?: string | null,
            itemName?: string | null,
            itemNote?: string | null,
            isDone?: boolean | null,
          } | null > | null,
        } | null > | null,
      } | null > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      tip?: number | null,
      feeAndPreGratuityDisplay?: string | null,
      deliveryFee?: number | null,
      transactions?: Array< string | null > | null,
      couponCode?: string | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
      adjustments?:  Array< {
        __typename: "Adjustment",
        id: string,
        description: string,
        amount: number,
      } > | null,
      lineItems?:  {
        __typename: "LineItems",
        deliveryFee?: number | null,
        tipPercentage?: number | null,
        tipAmount?: number | null,
        platformPercentage?: number | null,
        platformAmount?: number | null,
        subtotal?: number | null,
        coupon?: number | null,
        total?: number | null,
        earnings?: number | null,
        stores?:  Array< {
          __typename: "StoreAmount",
          storeName?: string | null,
          storeAmount?: number | null,
        } | null > | null,
        couponCode?: string | null,
        additionalTipAmount?: number | null,
        adjustmentDescription?: string | null,
        adjustmentAmount?: number | null,
      } | null,
      priceBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      earningsBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      review?:  {
        __typename: "Review",
        id?: string | null,
        quote?: string | null,
        rating?: number | null,
        timestamp?: string | null,
      } | null,
      sharedListIdentifiers?:  Array< {
        __typename: "SharedListIdentifier",
        owner?: string | null,
        listId?: string | null,
        snapshotId?: string | null,
        listName?: string | null,
        storeName?: string | null,
        hasOpenOrder?: boolean | null,
        clientId?: string | null,
        orderId?: string | null,
        orderTimestamp?: string | null,
        serviceImage?: string | null,
        itemCount?: number | null,
        numItems?: number | null,
        numUnits?: number | null,
      } | null > | null,
      listReferences:  Array< {
        __typename: "ListReference",
        storeName: string,
        storeImage: string,
        storeId: string,
        id: string,
        listName: string,
        listItemCount: number,
        listVersion: string,
        lastCompletedOrderId?: string | null,
        savedListId?: string | null,
        savedListItemCount: number,
        savedListVersion?: string | null,
      } >,
      additionalTipAmount?: number | null,
      additionalTipDismissed?: boolean | null,
      pricingData?:  {
        __typename: "OrderPricingData",
        preTip?: number | null,
        loan?: number | null,
      } | null,
      externalTransactions?:  Array< {
        __typename: "ExternalTransaction",
        id: string,
        description: string,
        amount: number,
        image?: string | null,
        attachment?: string | null,
      } | null > | null,
      assignedTo?: Array< string > | null,
      lockoutHours?: number | null,
      parentOrder?:  {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } | null,
      childOrders?:  Array< {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } > | null,
      credits?:  Array< {
        __typename: "OrderCredit",
        id: string,
        description: string,
        amount: number,
      } > | null,
    },
    baseAmount: number,
    defaultPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    gratuityType: GratuityType,
    gratuityOptions: Array< number >,
  } | null > | null,
};

export type OrderPostGratuityInfoQueryVariables = {
  clientId: string,
  orderId: string,
  orderTimestamp: string,
};

export type OrderPostGratuityInfoQuery = {
  orderPostGratuityInfo?:  {
    __typename: "OrderPostGratuityInfo",
    order:  {
      __typename: "Order",
      version?: string | null,
      id?: string | null,
      clientId?: string | null,
      shopperId?: string | null,
      shopperInfo?:  {
        __typename: "ShopperInfo",
        image?: string | null,
        displayName?: string | null,
        email?: string | null,
      } | null,
      // These next five fields are dynamically added to the lookup when doing linkedOrders.
      firstName?: string | null,
      lastName?: string | null,
      phone?: string | null,
      email?: string | null,
      clientImage?: string | null,
      note?: string | null,
      privateNote?: string | null,
      adminNote?: string | null,
      conciergeNote?: string | null,
      orderStatus?: string | null,
      orderDateTime?: string | null,
      orderTimestamp?: string | null,
      deliveryDate?: string | null,
      deliveryTime?: string | null,
      deliveryTimestamp?: string | null,
      deliveryStartDateTime?: string | null,
      deliveryEndDateTime?: string | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      orderPaymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      serviceRequestList?:  Array< {
        __typename: "ServiceRequest",
        serviceId?: string | null,
        serviceName?: string | null,
        image?: string | null,
        errandList?:  Array< {
          __typename: "Errand",
          businessName?: string | null,
          shoppingItemCount?: number | null,
          shoppingList?:  Array< {
            __typename: "ShoppingItem",
            id?: string | null,
            itemName?: string | null,
            itemNote?: string | null,
            isDone?: boolean | null,
          } | null > | null,
        } | null > | null,
      } | null > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      tip?: number | null,
      feeAndPreGratuityDisplay?: string | null,
      deliveryFee?: number | null,
      transactions?: Array< string | null > | null,
      couponCode?: string | null,
      adjustmentDescription?: string | null,
      adjustmentAmount?: number | null,
      adjustments?:  Array< {
        __typename: "Adjustment",
        id: string,
        description: string,
        amount: number,
      } > | null,
      lineItems?:  {
        __typename: "LineItems",
        deliveryFee?: number | null,
        tipPercentage?: number | null,
        tipAmount?: number | null,
        platformPercentage?: number | null,
        platformAmount?: number | null,
        subtotal?: number | null,
        coupon?: number | null,
        total?: number | null,
        earnings?: number | null,
        stores?:  Array< {
          __typename: "StoreAmount",
          storeName?: string | null,
          storeAmount?: number | null,
        } | null > | null,
        couponCode?: string | null,
        additionalTipAmount?: number | null,
        adjustmentDescription?: string | null,
        adjustmentAmount?: number | null,
      } | null,
      priceBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      earningsBreakdown?:  {
        __typename: "PriceBreakdown",
        title?: string | null,
        lineItems?:  Array< {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null > | null,
        final?:  {
          __typename: "KeyValue",
          key?: string | null,
          value?: string | null,
          type?: KVType | null,
          metadata?:  {
            __typename: "KVMetadata",
            txId?: string | null,
            adjustmentDescription?: string | null,
            paymentUTCTimestamp?: string | null,
            image?: string | null,
          } | null,
        } | null,
      } | null,
      review?:  {
        __typename: "Review",
        id?: string | null,
        quote?: string | null,
        rating?: number | null,
        timestamp?: string | null,
      } | null,
      sharedListIdentifiers?:  Array< {
        __typename: "SharedListIdentifier",
        owner?: string | null,
        listId?: string | null,
        snapshotId?: string | null,
        listName?: string | null,
        storeName?: string | null,
        hasOpenOrder?: boolean | null,
        clientId?: string | null,
        orderId?: string | null,
        orderTimestamp?: string | null,
        serviceImage?: string | null,
        itemCount?: number | null,
        numItems?: number | null,
        numUnits?: number | null,
      } | null > | null,
      listReferences:  Array< {
        __typename: "ListReference",
        storeName: string,
        storeImage: string,
        storeId: string,
        id: string,
        listName: string,
        listItemCount: number,
        listVersion: string,
        lastCompletedOrderId?: string | null,
        savedListId?: string | null,
        savedListItemCount: number,
        savedListVersion?: string | null,
      } >,
      additionalTipAmount?: number | null,
      additionalTipDismissed?: boolean | null,
      pricingData?:  {
        __typename: "OrderPricingData",
        preTip?: number | null,
        loan?: number | null,
      } | null,
      externalTransactions?:  Array< {
        __typename: "ExternalTransaction",
        id: string,
        description: string,
        amount: number,
        image?: string | null,
        attachment?: string | null,
      } | null > | null,
      assignedTo?: Array< string > | null,
      lockoutHours?: number | null,
      parentOrder?:  {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } | null,
      childOrders?:  Array< {
        __typename: "OrderReference",
        deliveryTimestamp: string,
        orderTimestamp: string,
        orderId: string,
        clientId: string,
        shopperId: string,
      } > | null,
      credits?:  Array< {
        __typename: "OrderCredit",
        id: string,
        description: string,
        amount: number,
      } > | null,
    },
    baseAmount: number,
    defaultPaymentMethod?:  {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null,
    gratuityType: GratuityType,
    gratuityOptions: Array< number >,
  } | null,
};

export type BossPlansQueryVariables = {
};

export type BossPlansQuery = {
  bossPlans?:  Array< {
    __typename: "BossPlan",
    id?: string | null,
    // Starter, Legacy Starter, Pro, Legacy Pro, Tycoon
    title?: string | null,
    // Probably be same as id.
    description?: string | null,
    // blah
    cost?: string | null,
    // This is just the money portion e.g "$99"
    interval?: string | null,
    // e.g. Month, Week, Year, etc.  ... probably just Month
    mostPopular?: boolean | null,
  } | null > | null,
};

export type BossPlanPreviewQueryVariables = {
  id?: string | null,
};

export type BossPlanPreviewQuery = {
  bossPlanPreview?:  {
    __typename: "BossPlanPreview",
    title?: string | null,
    // "Changing your plan"
    description?: string | null,
    // "Are you sure you want to move from X to Y" In case a legacy plan is being abandoned it would be mentioned here.
    breakdown?:  Array< {
      __typename: "KeyValue",
      key?: string | null,
      value?: string | null,
      type?: KVType | null,
      metadata?:  {
        __typename: "KVMetadata",
        txId?: string | null,
        adjustmentDescription?: string | null,
        paymentUTCTimestamp?: string | null,
        image?: string | null,
      } | null,
    } | null > | null,
    cta?: string | null,
    paymentRequired?: boolean | null,
  } | null,
};

export type BossPaymentMethodsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type BossPaymentMethodsQuery = {
  bossPaymentMethods?:  {
    __typename: "PaginatedPaymentMethods",
    paymentMethods?:  Array< {
      __typename: "PaymentMethod",
      id?: string | null,
      brand?: string | null,
      expirationMonth?: number | null,
      expirationYear?: number | null,
      last4?: string | null,
      isDefault?: boolean | null,
      address?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type BossPayoutsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type BossPayoutsQuery = {
  bossPayouts?:  {
    __typename: "PaginatedPayouts",
    futurePayoutAmount?: string | null,
    payouts?:  Array< {
      __typename: "Payout",
      id?: string | null,
      amount?: string | null,
      status?: string | null,
      arrivalTimestamp?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type BossPayoutDetailsQueryVariables = {
  payoutId: string,
};

export type BossPayoutDetailsQuery = {
  bossPayoutDetails?:  {
    __typename: "BossPayoutDetails",
    id?: string | null,
    header?:  Array< {
      __typename: "KeyValue",
      key?: string | null,
      value?: string | null,
      type?: KVType | null,
      metadata?:  {
        __typename: "KVMetadata",
        txId?: string | null,
        adjustmentDescription?: string | null,
        paymentUTCTimestamp?: string | null,
        image?: string | null,
      } | null,
    } | null > | null,
    payments?:  Array< {
      __typename: "BossPayment",
      id?: string | null,
      // payment ID
      amount?: string | null,
      client?: string | null,
      date?: string | null,
      orderId?: string | null,
      deliveryTimestamp?: string | null,
      postTip?: boolean | null,
    } | null > | null,
  } | null,
};

export type BossInsightsBasicQueryVariables = {
};

export type BossInsightsBasicQuery = {
  bossInsightsBasic:  {
    __typename: "InsightsBasic",
    profileImage: string,
    ratings:  {
      __typename: "InsightsRatings",
      score: string,
      // e.g 4.6/5
      reviewCount: number,
      reviewCountBreakdown: Array< number >,
    },
    trends:  {
      __typename: "InsightsTrends",
      charts:  Array< {
        __typename: "InsightsChart",
        tab: string,
        // e.g Earnings, Orders
        maxBarHeight: number,
        // e.g 2000
        bars:  Array< {
          __typename: "InsightsBar",
          xLabel: string,
          // e.g JUN
          barLabel: string,
          // e.g $1,532
          barHeight: number,
        } >,
      } >,
    },
  },
};

export type BossInsightsMetricsQueryVariables = {
  period: string,
};

export type BossInsightsMetricsQuery = {
  bossInsightsMetrics:  {
    __typename: "InsightsMetrics",
    tab: string,
    // e.g 4w, 3m, etc
    dateRange: string,
    // e.g Aug 11 - Sept 2, 2020
    earnings: string,
    // e.g. $1,234,567
    orderCount: number,
    clientCount: number,
    repeatClientCount: number,
  },
};

export type BossAvailableScheduleQueryVariables = {
  id?: string | null,
  input: ShopperAvailableScheduleInput,
};

export type BossAvailableScheduleQuery = {
  bossAvailableSchedule?:  {
    __typename: "ShopperAvailableSchedule",
    firstAvailableDayIndex?: number | null,
    firstAvailableTimeSlotOfDayIndex?: number | null,
    dailyAvailableSchedules?:  Array< {
      __typename: "DailyAvailableSchedule",
      day?: string | null,
      date?: string | null,
      isClosed?: boolean | null,
      availableTimeSlots?:  Array< {
        __typename: "AvailableTimeSlot",
        id: string,
        slotStartIso: string,
        slotEndIso: string,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        scheduledOrders?: number | null,
        bufferDuration: number,
        bufferMode: BufferMode,
        isAvailable?: boolean | null,
        inBuffer: boolean,
        inTimeSlot: boolean,
        availablePromos?:  Array< {
          __typename: "PromoDetails",
          id: string,
          type: PromoType,
          code: string,
          displayName?: string | null,
          discountFixed?: number | null,
          discountPercent?: number | null,
        } > | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type BossStripeAccountVerifyLinkQueryVariables = {
  id?: string | null,
};

export type BossStripeAccountVerifyLinkQuery = {
  bossStripeAccountVerifyLink?:  {
    __typename: "StripeAccountVerifyLink",
    url?: string | null,
    expiresAt?: string | null,
  } | null,
};

export type GetAutoMessagesQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type GetAutoMessagesQuery = {
  getAutoMessages:  {
    __typename: "PaginatedAutoMessages",
    autoMessages?:  Array< {
      __typename: "AutoMessage",
      id?: string | null,
      type?: string | null,
      title?: string | null,
      action?: string | null,
      message?: string | null,
      defaultMessage?: string | null,
      description?: string | null,
      enabled?: boolean | null,
      delaySeconds?: number | null,
      defaultDelaySeconds?: number | null,
    } | null > | null,
    nextToken?: string | null,
  },
};

export type ClientAvailableUpdateQueryVariables = {
};

export type ClientAvailableUpdateQuery = {
  clientAvailableUpdate?:  {
    __typename: "AvailableUpdate",
    isRequired: boolean,
    availableVersion: string,
    note: string,
    infoUrl?: string | null,
  } | null,
};

export type GetListReferencesQueryVariables = {
  count: number,
  nextToken: string,
};

export type GetListReferencesQuery = {
  // New List experience queries.
  getListReferences:  {
    __typename: "PaginatedListReferences",
    nextToken?: string | null,
    listReferences:  Array< {
      __typename: "ListReference",
      storeName: string,
      storeImage: string,
      storeId: string,
      id: string,
      listName: string,
      listItemCount: number,
      listVersion: string,
      lastCompletedOrderId?: string | null,
      savedListId?: string | null,
      savedListItemCount: number,
      savedListVersion?: string | null,
    } >,
  },
};

export type GetListDetailsQueryVariables = {
  listId: string,
};

export type GetListDetailsQuery = {
  getListDetails:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type GetCardFundingOrderQueryVariables = {
  deliveryTimestamp: string,
  orderId: string,
};

export type GetCardFundingOrderQuery = {
  getCardFundingOrder:  {
    __typename: "CardFundingOrder",
    userId: string,
    orderId: string,
    deliveryTimestamp: string,
    fundingCents: number,
    fundingDisplayCents: string,
    fundingDisplayDollars: string,
    fundingStatus: string,
    fundingWarning?: string | null,
    contactMessage?: string | null,
    displayFunding: boolean,
  },
};

export type GetAvailableStoresQueryVariables = {
  shopperId?: string | null,
  request?: string | null,
};

export type GetAvailableStoresQuery = {
  getAvailableStores:  {
    __typename: "AvailableStores",
    displayShopperFee?: boolean | null,
    displayRequestFee?: boolean | null,
    displayRequestBanner?: boolean | null,
    disclaimer: string,
    storesSections:  Array< {
      __typename: "StoresSection",
      title: string,
      description?: string | null,
      storeReferences:  Array< {
        __typename: "StoreReference",
        storeImage: string,
        storeName: string,
        id: string,
        storeReferencePricing?:  {
          __typename: "StoreReferencePricing",
          type: StorePriceType,
          price: string,
        } | null,
      } >,
    } >,
  },
};

export type GetStoreQueryVariables = {
  storeId: string,
};

export type GetStoreQuery = {
  getStore:  {
    __typename: "Store",
    name: string,
    image: string,
    id: string,
    disclaimer?: string | null,
    isCustom?: boolean | null,
  },
};

export type GetSearchTermsQueryVariables = {
  searchText: string,
  storeId: string,
  breadcrumbs?: Array< string > | null,
};

export type GetSearchTermsQuery = {
  getSearchTerms:  Array<( {
      __typename: "SearchTermAutocompleteResult",
      completedTerm: string,
    } | {
      __typename: "SearchTermAutosuggestResult",
      suggestedTerm: string,
    } | {
      __typename: "SearchTermProductResult",
      name: string,
      itemId: string,
    } | {
      __typename: "SearchTermInCategoryResult",
      name: string,
      breadcrumbs: Array< string >,
    }
  ) >,
};

export type GetDefaultSearchTermsQueryVariables = {
  storeId: string,
};

export type GetDefaultSearchTermsQuery = {
  getDefaultSearchTerms:  Array<( {
      __typename: "SearchTermAutocompleteResult",
      completedTerm: string,
    } | {
      __typename: "SearchTermAutosuggestResult",
      suggestedTerm: string,
    } | {
      __typename: "SearchTermProductResult",
      name: string,
      itemId: string,
    } | {
      __typename: "SearchTermInCategoryResult",
      name: string,
      breadcrumbs: Array< string >,
    }
  ) >,
};

export type GetPricingModelQueryVariables = {
  shopperId: string,
  storeId: string,
};

export type GetPricingModelQuery = {
  getPricingModel:  {
    __typename: "PricingModel",
    version?: string | null,
    // This is displayed on the storefront page.
    // It is meant as a terse description of the pricing model.
    // E.g. "My whiteglove service:  $10 + 15%"
    description?: string | null,
    // Term1: flat fee for service.
    flatPm?:  {
      __typename: "FlatPM",
      fee?: string | null,
      feeTitle?: string | null,
      display?: boolean | null,
    } | null,
    // Term2: hourly fee for service.
    hourlyPm?:  {
      __typename: "HourlyPM",
      rate?: string | null,
      billableHours?: string | null,
      minBillableHours?: string | null,
      feeTitle?: string | null,
      display?: boolean | null,
    } | null,
    // Term3: working capital loan.
    // pexBalance: Int
    // pexBalanceDisplay: Boolean
    // Term4: percent service fee, based on term3, with a floor.
    percentPm?:  {
      __typename: "PercentPM",
      percent?: string | null,
      minFee?: string | null,
      feeTitle?: string | null,
      display?: boolean | null,
    } | null,
    // Term5: mostly for backwards compatibility with the current model.
    // This is applaied to (pexBalance+serviceFee)
    preTipPm?:  {
      __typename: "PreTipPM",
      chosenPercent?: string | null,
      percentages?: Array< string | null > | null,
      defaultPercentagesIndex?: number | null,
      footer?: string | null,
      feeTitle?: string | null,
      display?: boolean | null,
      fixedGratuityOptions?: Array< number | null > | null,
      defaultFixedGratuityOptionsIndex?: number | null,
      chosenFixedGratuity?: number | null,
      gratuityType?: GratuityType | null,
      showPreGratuityByDefault?: boolean | null,
      allowOptionalGratuity?: boolean | null,
      showCustomGratuity?: boolean | null,
    } | null,
    // Term6: client platform fee.
    clientPlatformPm?:  {
      __typename: "ClientPlatformPM",
      percent?: string | null,
      feeTitle?: string | null,
      display?: boolean | null,
    } | null,
    suggestedFlatPm?:  {
      __typename: "SuggestedFlatPM",
      fee?: number | null,
      feeWarningThreshold?: number | null,
      percentages?: Array< number | null > | null,
      gratuityType?: GratuityType | null,
      gratuityOptions?: Array< number | null > | null,
      defaultGratuityOptionsIndex?: number | null,
      clientPaysPlatform?: boolean | null,
      showCustomGratuity?: boolean | null,
      title?: string | null,
      description?: string | null,
    } | null,
    suggestedPercentPm?:  {
      __typename: "SuggestedPercentPM",
      percent?: number | null,
      minFee?: number | null,
      percentWarningThreshold?: number | null,
      minFeeWarningThreshold?: number | null,
      gratuityType?: GratuityType | null,
      gratuityOptions?: Array< number | null > | null,
      defaultGratuityOptionsIndex?: number | null,
      clientPaysPlatform?: boolean | null,
      showCustomGratuity?: boolean | null,
      title?: string | null,
      description?: string | null,
    } | null,
    suggestedFlatPlusPercentPm?:  {
      __typename: "SuggestedFlatPlusPercentPM",
      fee?: number | null,
      feeWarningThreshold?: number | null,
      percent?: number | null,
      minFee?: number | null,
      percentWarningThreshold?: number | null,
      minFeeWarningThreshold?: number | null,
      gratuityType?: GratuityType | null,
      gratuityOptions?: Array< number | null > | null,
      defaultGratuityOptionsIndex?: number | null,
      clientPaysPlatform?: boolean | null,
      showCustomGratuity?: boolean | null,
      title?: string | null,
      description?: string | null,
    } | null,
  },
};

export type GetShopperSupportedStoresQueryVariables = {
  shopperId: string,
  listIds: Array< string >,
};

export type GetShopperSupportedStoresQuery = {
  getShopperSupportedStores:  {
    __typename: "ShopperSupportedStores",
    supportedStores:  Array< {
      __typename: "StoreReference",
      storeImage: string,
      storeName: string,
      id: string,
      storeReferencePricing?:  {
        __typename: "StoreReferencePricing",
        type: StorePriceType,
        price: string,
      } | null,
    } >,
    unsupportedStores:  Array< {
      __typename: "StoreReference",
      storeImage: string,
      storeName: string,
      id: string,
      storeReferencePricing?:  {
        __typename: "StoreReferencePricing",
        type: StorePriceType,
        price: string,
      } | null,
    } >,
  },
};

export type ShopperAvailabilityQueryVariables = {
  shopperId: string,
  shopperAvailableScheduleInput: ShopperAvailableScheduleInput,
};

export type ShopperAvailabilityQuery = {
  shopperAvailability:  {
    __typename: "ShopperAvailability",
    id?: string | null,
    shopperAvailabilityDays:  Array< {
      __typename: "ShopperDayAvailability",
      dayOfWeekType: DayOfWeekType,
      shopperAvailabilityType: ShopperAvailabilityType,
    } >,
  },
};

export type GetListNoticeQueryVariables = {
  listId: string,
};

export type GetListNoticeQuery = {
  getListNotice?:  {
    __typename: "ListNotice",
    id: string,
    type: ListNoticeType,
    title: string,
    body: string,
  } | null,
};

export type ShopperAvailabilityDescriptionQueryVariables = {
  shopperId: string,
  shopperAvailableScheduleInput: ShopperAvailableScheduleInput,
};

export type ShopperAvailabilityDescriptionQuery = {
  shopperAvailabilityDescription:  {
    __typename: "ShopperAvailabilityDescription",
    id?: string | null,
    description: string,
  },
};

export type ShopperGetListDetailsQueryVariables = {
  listId: string,
  owner?: string | null,
  snapshotId?: string | null,
};

export type ShopperGetListDetailsQuery = {
  shopperGetListDetails:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  },
};

export type ShopperProductDetailsQueryVariables = {
  productId: string,
  listId?: string | null,
  owner?: string | null,
  snapshot?: string | null,
};

export type ShopperProductDetailsQuery = {
  shopperProductDetails?:  {
    __typename: "ProductDetails",
    id: string,
    product:  {
      __typename: "Product",
      id: string,
      name: string,
      // The description of the item __cannot__ contain HTML entities or tags.
      description?: string | null,
      // A 2D array of category paths. Each sub-array is a unique, hierarchical path to the item.
      categories?: Array< string > | null,
      price?:  {
        __typename: "ProductPrice",
        cents: number,
        text: string,
      } | null,
      salePrice?:  {
        __typename: "ProductPrice",
        cents: number,
        text: string,
      } | null,
      displaySize?: string | null,
      media:  Array<( {
          __typename: "MediaImage",
          small?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          medium?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          large?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          xlarge?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          full:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          },
        }
      ) | null >,
      link?: string | null,
      isCustom: boolean,
    },
    note?: string | null,
    quantity?: number | null,
  } | null,
};

export type StoreSearchOptionsQueryVariables = {
  storeId: string,
  maxDepth: number,
};

export type StoreSearchOptionsQuery = {
  storeSearchOptions:  {
    __typename: "SearchOptions",
    id: string,
    categories:  Array< {
      __typename: "ProductCategory",
      name: string,
      breadcrumbs: Array< string >,
      children?:  Array< {
        __typename: "ProductCategory",
        name: string,
        breadcrumbs: Array< string >,
        children?:  Array< {
          __typename: "ProductCategory",
          name: string,
          breadcrumbs: Array< string >,
          children?:  Array< {
            __typename: "ProductCategory",
            name: string,
            breadcrumbs: Array< string >,
            image?: string | null,
            categoryEmoji: string,
          } > | null,
          image?: string | null,
          categoryEmoji: string,
        } > | null,
        image?: string | null,
        categoryEmoji: string,
      } > | null,
      image?: string | null,
      categoryEmoji: string,
    } >,
    sort:  Array< {
      __typename: "SearchResultsSortOption",
      name: string,
      type: SearchResultsSortOptionType,
    } >,
  },
};

export type StoreListActionsQueryVariables = {
  storeId: string,
  listId?: string | null,
};

export type StoreListActionsQuery = {
  storeListActions:  {
    __typename: "StoreListActions",
    id: string,
    actions:  Array<( {
        __typename: "SearchStoreListAction",
        name: string,
        buyAgainBreadcrumbs?: Array< string > | null,
      } | {
        __typename: "BrowseListAction",
        name: string,
        buyAgainBreadcrumbs?: Array< string > | null,
      } | {
        __typename: "BuyAgainListAction",
        name: string,
        breadcrumbs: Array< string >,
      } | {
        __typename: "AddItemsListAction",
        name: string,
      } | {
        __typename: "PastItemsListAction",
        name: string,
        breadcrumbs: Array< string >,
      } | {
        __typename: "FilterListAction",
        name: string,
        breadcrumbs: Array< string >,
        sortType?: SearchResultsSortOptionType | null,
      } | {
        __typename: "SavedItemsListAction",
        name: string,
        listId: string,
        listItemCount: number,
      } | {
        __typename: "BrowseStoreListAction",
        name: string,
      }
    ) >,
  },
};

export type StoreHighlightsCarouselsQueryVariables = {
  storeId: string,
  listId: string,
};

export type StoreHighlightsCarouselsQuery = {
  storeHighlightsCarousels:  {
    __typename: "ProductCarouselList",
    id: string,
    carousels:  Array< {
      __typename: "ProductCarousel",
      id: string,
      name: string,
      products:  Array< {
        __typename: "ProductV3Result",
        id?: string | null,
        dumplingId?: string | null,
        sellerName?: string | null,
        name?: string | null,
        // The store's own unique ID for the product. This could be the SKU.
        sellerId?: string | null,
        available?: boolean | null,
        allowed?: boolean | null,
        // The description of the item should _not_ contain HTML entities or tags.
        description?: string | null,
        upc?: string | null,
        // A 2D array of category paths. Each sub-array is a unique, hierarchical path to the item.
        categories?: Array< string | null > | null,
        price?: number | null,
        salePrice?: number | null,
        clubPrice?: number | null,
        // This is the price per unit (in cents) that this item is measured in.
        pricePerUnit?: number | null,
        salePricePerUnit?: number | null,
        // Sale prices may have effective date range
        // saleStartDate: String
        // saleEndDate: String
        // Either EACH or WEIGHT
        unitType?: string | null,
        // A human-readable unit that this item is weighed or measured by.
        weightUnit?: string | null,
        // If available, the weight or measure of the item specified by `weightUnit`
        weight?: number | null,
        // If provided by the seller, how they represent the size info of a product.
        displaySize?: string | null,
        // A URL of the item image hosted by the store (not our own server).
        imageLink?: string | null,
        // A URL of the item image hosted in our own S3 bucket.
        image?: string | null,
        link?: string | null,
        // This field is only used to convey the note field on the past items screen.
        note?: string | null,
        attributedMedia:  Array< {
          __typename: "AttributedMedia",
          sourceUrl: string,
          hostPageUrl?: string | null,
          hostPageName?: string | null,
        } >,
      } | null >,
      action: ( {
          __typename: "ProductFilterAction",
          breadcrumbs?: Array< string > | null,
          sortType?: SearchResultsSortOptionType | null,
        }
      ) | null,
    } >,
  },
};

export type StoreCanonicalCategoriesQueryVariables = {
  storeId: string,
  maxDepth: number,
};

export type StoreCanonicalCategoriesQuery = {
  storeCanonicalCategories:  {
    __typename: "ProductCategoryList",
    id: string,
    categories:  Array< {
      __typename: "ProductCategory",
      name: string,
      breadcrumbs: Array< string >,
      children?:  Array< {
        __typename: "ProductCategory",
        name: string,
        breadcrumbs: Array< string >,
        children?:  Array< {
          __typename: "ProductCategory",
          name: string,
          breadcrumbs: Array< string >,
          children?:  Array< {
            __typename: "ProductCategory",
            name: string,
            breadcrumbs: Array< string >,
            image?: string | null,
            categoryEmoji: string,
          } > | null,
          image?: string | null,
          categoryEmoji: string,
        } > | null,
        image?: string | null,
        categoryEmoji: string,
      } > | null,
      image?: string | null,
      categoryEmoji: string,
    } >,
  },
};

export type ShopperGetListChangesQueryVariables = {
  listId: string,
  owner?: string | null,
  snapshotId?: string | null,
};

export type ShopperGetListChangesQuery = {
  shopperGetListChanges:  {
    __typename: "ListChange",
    id: string,
    fromListVersion: string,
    toListVersion: string,
    changes:  Array< {
      __typename: "ListProductChange",
      itemId: string,
      changedBy: Array< string >,
      added: boolean,
      deleted: boolean,
      diff:  {
        __typename: "ListProductDiff",
        added:  Array< {
          __typename: "TypedKeyValue",
          key: string,
          value: string,
          dataType: DataType,
        } >,
        deleted:  Array< {
          __typename: "TypedKeyValue",
          key: string,
          value: string,
          dataType: DataType,
        } >,
        updated:  Array< {
          __typename: "TypedKeyChangedValue",
          key: string,
          old: string,
          new: string,
          dataType: DataType,
        } >,
      },
    } >,
    list:  {
      __typename: "ListDetails",
      id: string,
      savedListId?: string | null,
      listName: string,
      listVersion: string,
      storeName: string,
      storeId: string,
      items:  Array< {
        __typename: "ListProduct",
        id: string,
        catalogId?: string | null,
        media:  Array<( {
            __typename: "ProductImage",
            imageUrl: string,
          } | {
            __typename: "ProductVideo",
            videoUrl: string,
          }
        ) >,
        attributedMedia:  Array< {
          __typename: "AttributedMedia",
          sourceUrl: string,
          hostPageUrl?: string | null,
          hostPageName?: string | null,
        } >,
        count: number,
        note?: string | null,
        isCustom?: boolean | null,
        name: string,
        priceCents?: number | null,
        displayPrice: string,
        salePriceCents?: number | null,
        saleDisplayPrice?: string | null,
        position: number,
        category: string,
        categoryEmoji: string,
        displayUnit?: string | null,
        referenceLink: string,
        deleted: boolean,
        available: boolean,
        lastUpdatedTimestamp: string,
        shopperNote?: string | null,
        createdByShopperId?: string | null,
        shopperPosition?: number | null,
        shopperCategoryPosition?: number | null,
        shopperCheckedOff: boolean,
        shopperCheckedOffTimestamp: string,
        shopperNotAvailable: boolean,
        selectedProductOptions?:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } | null > | null,
        packageLineItems?:  Array< {
          __typename: "PackageLineItem",
          productId: string,
          name: string,
          quantity: number,
          note: string,
          selectedProductOptions:  Array< {
            __typename: "SelectedProductOption",
            name: string,
            selection: string,
          } >,
        } | null > | null,
      } >,
      estimatedTotal:  {
        __typename: "EstimatedTotal",
        id: string,
        displayPrice: string,
      },
      estimatedCheckoutTotal:  {
        __typename: "EstimatedTotal",
        id: string,
        displayPrice: string,
      },
    },
  },
};

export type GetInstantPayoutAccountsQueryVariables = {
};

export type GetInstantPayoutAccountsQuery = {
  getInstantPayoutAccounts:  Array< {
    __typename: "InstantPayoutAccount",
    id: string,
    brand?: string | null,
    expirationMonth?: number | null,
    expirationYear?: number | null,
    last4?: string | null,
    isDefault: boolean,
    isVerified: boolean,
  } >,
};

export type GetAvailableInstantPayoutDetailsQueryVariables = {
};

export type GetAvailableInstantPayoutDetailsQuery = {
  getAvailableInstantPayoutDetails:  {
    __typename: "AvailableInstantPayoutDetails",
    balance: number,
    fee: number,
    amount: number,
    calculatedTimestamp: number,
  },
};

export type GetFeatureStatesQueryVariables = {
  id: Array< string >,
  isClientRequest?: boolean | null,
};

export type GetFeatureStatesQuery = {
  getFeatureStates:  Array< {
    __typename: "FeatureState",
    id: string,
    enabled: boolean,
    state:  Array< {
      __typename: "TypedKeyValue",
      key: string,
      value: string,
      dataType: DataType,
    } >,
  } >,
};

export type GetCartQueryVariables = {
  id?: string | null,
};

export type GetCartQuery = {
  // Can be a Client's Cart or a Proposed Cart, if null assume Client's Cart
  getCart:  {
    __typename: "CartResponse",
    cart:  {
      __typename: "Cart",
      id: string,
      type: CartType,
      clientId?: string | null,
      shopper?:  {
        __typename: "CartShopper",
        id: string,
        image?: string | null,
        displayName?: string | null,
        isPro: boolean,
        clientCount: number,
        repeatClientCount: number,
      } | null,
      deliveryTimeSlot?:  {
        __typename: "AvailableTimeSlot",
        id: string,
        slotStartIso: string,
        slotEndIso: string,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        scheduledOrders?: number | null,
        bufferDuration: number,
        bufferMode: BufferMode,
        isAvailable?: boolean | null,
        inBuffer: boolean,
        inTimeSlot: boolean,
        availablePromos?:  Array< {
          __typename: "PromoDetails",
          id: string,
          type: PromoType,
          code: string,
          displayName?: string | null,
          discountFixed?: number | null,
          discountPercent?: number | null,
        } > | null,
      } | null,
      preTip?:  {
        __typename: "ChosenPreTip",
        percent?: number | null,
        fixed?: number | null,
      } | null,
      note?: string | null,
      services?:  Array< {
        __typename: "ServiceLists",
        id: string,
        serviceName: string,
        serviceImage?: string | null,
        listIds: Array< string >,
      } > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      paymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      appliedPromos?:  Array< {
        __typename: "PromoDetails",
        id: string,
        type: PromoType,
        code: string,
        displayName?: string | null,
        discountFixed?: number | null,
        discountPercent?: number | null,
      } > | null,
      estimatedTotals?:  Array< {
        __typename: "CartTotalLine",
        type: CartTotalLineType,
        label: string,
        value: string,
      } > | null,
      createdOn: string,
      lastUpdated: string,
    },
    errors?:  Array< {
      __typename: "CartError",
      code: CartErrorCode,
      message: string,
    } > | null,
  },
};

export type GetMarketplaceInfoQueryVariables = {
  zipcode: string,
};

export type GetMarketplaceInfoQuery = {
  // Activity/Neighborhood Marketplace
  getMarketplaceInfo:  {
    __typename: "MarketplaceInfo",
    zipcode: string,
    marketplaceType: MarketplaceType,
  },
};

export type GetActivityListQueryVariables = {
  currentFilterStores: Array< string >,
  zipcode?: string | null,
  shopperIds?: Array< string > | null,
};

export type GetActivityListQuery = {
  getActivityList:  {
    __typename: "ActivityList",
    storeFilters:  Array< {
      __typename: "StoreInfo",
      name: string,
      imageUri: string,
    } >,
    upcomingActivities:  Array<( {
        __typename: "OrderActivity",
        id: string,
        pinCoordinate?:  {
          __typename: "MapCoordinate",
          lat: number,
          lon: number,
        } | null,
        activityType: OrderActivityType,
        performerId: string,
        shopperId: string,
        performerBadge: PerformerBadgeType,
        performerDisplayName: string,
        performerImageUri: string,
        performerActionText: string,
        timeDisplay: string,
        deliveryStartTimestamp: string,
        deliveryEndTimestamp: string,
        timeslotSpotsRemaining: number,
        timeslotSpotsTotal?: number | null,
        storeDisplayName: string,
        storeDisplayImageUri: string,
        pricingDisplayBase: string,
        pricingDisplayMin?: string | null,
        ctaHeaderDisplay?: string | null,
        discountDisplay?: string | null,
      }
    ) >,
    pastActivities:  Array<( {
        __typename: "OrderActivity",
        id: string,
        pinCoordinate?:  {
          __typename: "MapCoordinate",
          lat: number,
          lon: number,
        } | null,
        activityType: OrderActivityType,
        performerId: string,
        shopperId: string,
        performerBadge: PerformerBadgeType,
        performerDisplayName: string,
        performerImageUri: string,
        performerActionText: string,
        timeDisplay: string,
        deliveryStartTimestamp: string,
        deliveryEndTimestamp: string,
        timeslotSpotsRemaining: number,
        timeslotSpotsTotal?: number | null,
        storeDisplayName: string,
        storeDisplayImageUri: string,
        pricingDisplayBase: string,
        pricingDisplayMin?: string | null,
        ctaHeaderDisplay?: string | null,
        discountDisplay?: string | null,
      }
    ) >,
    neCorner:  {
      __typename: "MapCoordinate",
      lat: number,
      lon: number,
    },
    swCorner:  {
      __typename: "MapCoordinate",
      lat: number,
      lon: number,
    },
  },
};

export type GetCartFromActivityQueryVariables = {
  activityId: string,
};

export type GetCartFromActivityQuery = {
  getCartFromActivity:  {
    __typename: "CartResponse",
    cart:  {
      __typename: "Cart",
      id: string,
      type: CartType,
      clientId?: string | null,
      shopper?:  {
        __typename: "CartShopper",
        id: string,
        image?: string | null,
        displayName?: string | null,
        isPro: boolean,
        clientCount: number,
        repeatClientCount: number,
      } | null,
      deliveryTimeSlot?:  {
        __typename: "AvailableTimeSlot",
        id: string,
        slotStartIso: string,
        slotEndIso: string,
        slotStart?: number | null,
        slotEnd?: number | null,
        maxOrders?: number | null,
        scheduledOrders?: number | null,
        bufferDuration: number,
        bufferMode: BufferMode,
        isAvailable?: boolean | null,
        inBuffer: boolean,
        inTimeSlot: boolean,
        availablePromos?:  Array< {
          __typename: "PromoDetails",
          id: string,
          type: PromoType,
          code: string,
          displayName?: string | null,
          discountFixed?: number | null,
          discountPercent?: number | null,
        } > | null,
      } | null,
      preTip?:  {
        __typename: "ChosenPreTip",
        percent?: number | null,
        fixed?: number | null,
      } | null,
      note?: string | null,
      services?:  Array< {
        __typename: "ServiceLists",
        id: string,
        serviceName: string,
        serviceImage?: string | null,
        listIds: Array< string >,
      } > | null,
      pricingModel?:  {
        __typename: "PricingModel",
        version?: string | null,
        // This is displayed on the storefront page.
        // It is meant as a terse description of the pricing model.
        // E.g. "My whiteglove service:  $10 + 15%"
        description?: string | null,
        // Term1: flat fee for service.
        flatPm?:  {
          __typename: "FlatPM",
          fee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term2: hourly fee for service.
        hourlyPm?:  {
          __typename: "HourlyPM",
          rate?: string | null,
          billableHours?: string | null,
          minBillableHours?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term3: working capital loan.
        // pexBalance: Int
        // pexBalanceDisplay: Boolean
        // Term4: percent service fee, based on term3, with a floor.
        percentPm?:  {
          __typename: "PercentPM",
          percent?: string | null,
          minFee?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        // Term5: mostly for backwards compatibility with the current model.
        // This is applaied to (pexBalance+serviceFee)
        preTipPm?:  {
          __typename: "PreTipPM",
          chosenPercent?: string | null,
          percentages?: Array< string | null > | null,
          defaultPercentagesIndex?: number | null,
          footer?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
          fixedGratuityOptions?: Array< number | null > | null,
          defaultFixedGratuityOptionsIndex?: number | null,
          chosenFixedGratuity?: number | null,
          gratuityType?: GratuityType | null,
          showPreGratuityByDefault?: boolean | null,
          allowOptionalGratuity?: boolean | null,
          showCustomGratuity?: boolean | null,
        } | null,
        // Term6: client platform fee.
        clientPlatformPm?:  {
          __typename: "ClientPlatformPM",
          percent?: string | null,
          feeTitle?: string | null,
          display?: boolean | null,
        } | null,
        suggestedFlatPm?:  {
          __typename: "SuggestedFlatPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percentages?: Array< number | null > | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedPercentPm?:  {
          __typename: "SuggestedPercentPM",
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
        suggestedFlatPlusPercentPm?:  {
          __typename: "SuggestedFlatPlusPercentPM",
          fee?: number | null,
          feeWarningThreshold?: number | null,
          percent?: number | null,
          minFee?: number | null,
          percentWarningThreshold?: number | null,
          minFeeWarningThreshold?: number | null,
          gratuityType?: GratuityType | null,
          gratuityOptions?: Array< number | null > | null,
          defaultGratuityOptionsIndex?: number | null,
          clientPaysPlatform?: boolean | null,
          showCustomGratuity?: boolean | null,
          title?: string | null,
          description?: string | null,
        } | null,
      } | null,
      paymentMethod?:  {
        __typename: "PaymentMethod",
        id?: string | null,
        brand?: string | null,
        expirationMonth?: number | null,
        expirationYear?: number | null,
        last4?: string | null,
        isDefault?: boolean | null,
        address?:  {
          __typename: "Address",
          id?: string | null,
          addressName?: string | null,
          addressLine1?: string | null,
          addressLine2?: string | null,
          city?: string | null,
          state?: string | null,
          zipcode?: string | null,
          country?: string | null,
          isDefault?: boolean | null,
        } | null,
      } | null,
      deliveryAddress?:  {
        __typename: "Address",
        id?: string | null,
        addressName?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        city?: string | null,
        state?: string | null,
        zipcode?: string | null,
        country?: string | null,
        isDefault?: boolean | null,
      } | null,
      appliedPromos?:  Array< {
        __typename: "PromoDetails",
        id: string,
        type: PromoType,
        code: string,
        displayName?: string | null,
        discountFixed?: number | null,
        discountPercent?: number | null,
      } > | null,
      estimatedTotals?:  Array< {
        __typename: "CartTotalLine",
        type: CartTotalLineType,
        label: string,
        value: string,
      } > | null,
      createdOn: string,
      lastUpdated: string,
    },
    errors?:  Array< {
      __typename: "CartError",
      code: CartErrorCode,
      message: string,
    } > | null,
  },
};

export type CustomItemImageSearchQueryVariables = {
  query: string,
  storeId: string,
  count?: number | null,
  offset?: number | null,
};

export type CustomItemImageSearchQuery = {
  customItemImageSearch:  {
    __typename: "CustomItemImages",
    images:  Array< {
      __typename: "AttributedMedia",
      media: ( {
          __typename: "MediaImage",
          small?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          medium?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          large?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          xlarge?:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          } | null,
          full:  {
            __typename: "SizedMediaImage",
            width?: number | null,
            height?: number | null,
            path: string,
            mimeType?: string | null,
          },
        }
      ) | null,
      sourceUrl: string,
      hostPageUrl?: string | null,
      hostPageName?: string | null,
    } >,
    title?: string | null,
    subTitle?: string | null,
    nextOffset?: number | null,
  },
};

export type PriceAndEarningsBreakdownQueryVariables = {
  shopperId: string,
  orderId: string,
  deliveryTimestamp: string,
};

export type PriceAndEarningsBreakdownQuery = {
  priceAndEarningsBreakdown?:  {
    __typename: "PriceAndEarningsBreakdown",
    priceBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    earningsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
    paymentsBreakdown?:  {
      __typename: "PriceBreakdown",
      title?: string | null,
      lineItems?:  Array< {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null > | null,
      final?:  {
        __typename: "KeyValue",
        key?: string | null,
        value?: string | null,
        type?: KVType | null,
        metadata?:  {
          __typename: "KVMetadata",
          txId?: string | null,
          adjustmentDescription?: string | null,
          paymentUTCTimestamp?: string | null,
          image?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type BossForgotPasswordQueryVariables = {
  phone?: string | null,
};

export type BossForgotPasswordQuery = {
  // API Key access for methods that allow password reset and account creation for new clients.
  bossForgotPassword?:  {
    __typename: "ForgotPasswordStatus",
    status?: boolean | null,
  } | null,
};

export type ClientForgotPasswordQueryVariables = {
  phone?: string | null,
};

export type ClientForgotPasswordQuery = {
  clientForgotPassword?:  {
    __typename: "ForgotPasswordStatus",
    status?: boolean | null,
  } | null,
};

export type LoginClientByOrderIdQueryVariables = {
  id?: string | null,
};

export type LoginClientByOrderIdQuery = {
  loginClientByOrderId?:  {
    __typename: "LoginClientStatus",
    status?: boolean | null,
  } | null,
};

export type GetBossBuddiesQueryVariables = {
};

export type GetBossBuddiesQuery = {
  // Boss Web interface:
  getBossBuddies:  {
    __typename: "BossBuddyInfo",
    bossBuddyProfiles:  Array< {
      __typename: "BossBuddyProfile",
      id: string,
      name: string,
      phone: string,
      permissionLevel: BuddyPermissions,
    } >,
  },
};

export type ResortClosedDatesQueryVariables = {
};

export type ResortClosedDatesQuery = {
  resortClosedDates:  {
    __typename: "ResortClosedDates",
    dates:  Array< {
      __typename: "ResortClosedDate",
      id: string,
      date: string,
    } >,
  },
};

export type GetMapviewDataQueryVariables = {
  zipcodes: Array< string | null >,
};

export type GetMapviewDataQuery = {
  // EXPERIMENTAL ... may get yanked.
  GetMapviewData?:  {
    __typename: "MapviewData",
    geoJsons: Array< string | null >,
    swLonLat: Array< number >,
    neLonLat: Array< number >,
  } | null,
};

export type ResortCatalogQueryVariables = {
  serviceName: string,
  breadcrumbs?: Array< string | null > | null,
  productId?: string | null,
  searchText?: string | null,
  productIds?: Array< string | null > | null,
  categoriesToBlock?: Array< string | null > | null,
};

export type ResortCatalogQuery = {
  // Wix Resort
  resortCatalog?:  {
    __typename: "ResortCatalog",
    serviceName?: string | null,
    products?:  Array< {
      __typename: "ResortProduct",
      id?: string | null,
      name?: string | null,
      description?: string | null,
      image?: string | null,
      thumbnail?: string | null,
      options?:  Array< {
        __typename: "ProductOption",
        name: string,
        choices: Array< string | null >,
        required: boolean,
        placeholderText?: string | null,
      } | null > | null,
      customizations?:  Array< {
        __typename: "ProductCustomization",
        name: string,
        maxLength?: number | null,
        required: boolean,
        placeholderText?: string | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type ResortConciergeQueryVariables = {
  id: string,
};

export type ResortConciergeQuery = {
  // Resort Concierge
  resortConcierge?:  {
    __typename: "Concierge",
    id?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    businessName?: string | null,
    phone?: string | null,
    email?: string | null,
    image?: string | null,
    signupTimestamp?: string | null,
    deactivated?: boolean | null,
  } | null,
};

export type SubscribeToSharedListSubscriptionVariables = {
  owner: string,
  listId: string,
};

export type SubscribeToSharedListSubscription = {
  subscribeToSharedList?:  {
    __typename: "SharedListOperation",
    // Dictates what happened.
    operation?: string | null,
    // IDs for identifying the list, and potentially the item in question.
    owner?: string | null,
    listId?: string | null,
    itemId?: string | null,
    // Related to changing the list itself.
    listName?: string | null,
    storeName?: string | null,
    // Related to add/update/delete items.
    position?: number | null,
    name?: string | null,
    image?: string | null,
    unit?: string | null,
    count?: number | null,
    note?: string | null,
    checkedOff?: boolean | null,
    checkedOffTimestamp?: string | null,
    shopperPosition?: number | null,
    shopperCheckedOff?: boolean | null,
    shopperCheckedOffTimestamp?: string | null,
  } | null,
};

export type SubscribeToSharedList2SubscriptionVariables = {
  owner: string,
  listId: string,
};

export type SubscribeToSharedList2Subscription = {
  subscribeToSharedList2?:  {
    __typename: "SharedListOperation2",
    // Dictates what happened.
    operation?: string | null,
    // IDs for identifying the list, and potentially the item in question.
    owner?: string | null,
    listId?: string | null,
    itemId?: string | null,
    // Related to changing the list itself.
    listName?: string | null,
    storeName?: string | null,
    // Related to add/update/delete items.
    position?: number | null,
    name?: string | null,
    image?: string | null,
    unit?: string | null,
    count?: number | null,
    note?: string | null,
    checkedOff?: boolean | null,
    checkedOffTimestamp?: string | null,
    shopperPosition?: number | null,
    shopperCheckedOff?: boolean | null,
    shopperCheckedOffTimestamp?: string | null,
    description?: string | null,
    price?: number | null,
    pricePerUnit?: number | null,
    weight?: number | null,
    weightUnit?: string | null,
    displaySize?: string | null,
    link?: string | null,
  } | null,
};

export type SubscribeToNotifyListChangeSubscriptionVariables = {
  id: string,
};

export type SubscribeToNotifyListChangeSubscription = {
  subscribeToNotifyListChange?:  {
    __typename: "ListDetails",
    id: string,
    savedListId?: string | null,
    listName: string,
    listVersion: string,
    storeName: string,
    storeId: string,
    items:  Array< {
      __typename: "ListProduct",
      id: string,
      catalogId?: string | null,
      media:  Array<( {
          __typename: "ProductImage",
          imageUrl: string,
        } | {
          __typename: "ProductVideo",
          videoUrl: string,
        }
      ) >,
      attributedMedia:  Array< {
        __typename: "AttributedMedia",
        media: ( {
            __typename: "MediaImage",
            small?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            medium?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            large?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            xlarge?:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            } | null,
            full:  {
              __typename: "SizedMediaImage",
              width?: number | null,
              height?: number | null,
              path: string,
              mimeType?: string | null,
            },
          }
        ) | null,
        sourceUrl: string,
        hostPageUrl?: string | null,
        hostPageName?: string | null,
      } >,
      count: number,
      note?: string | null,
      isCustom?: boolean | null,
      name: string,
      priceCents?: number | null,
      displayPrice: string,
      salePriceCents?: number | null,
      saleDisplayPrice?: string | null,
      position: number,
      category: string,
      categoryEmoji: string,
      displayUnit?: string | null,
      referenceLink: string,
      deleted: boolean,
      available: boolean,
      lastUpdatedTimestamp: string,
      shopperNote?: string | null,
      createdByShopperId?: string | null,
      shopperPosition?: number | null,
      shopperCategoryPosition?: number | null,
      shopperCheckedOff: boolean,
      shopperCheckedOffTimestamp: string,
      shopperNotAvailable: boolean,
      selectedProductOptions?:  Array< {
        __typename: "SelectedProductOption",
        name: string,
        selection: string,
      } | null > | null,
      packageLineItems?:  Array< {
        __typename: "PackageLineItem",
        productId: string,
        name: string,
        quantity: number,
        note: string,
        selectedProductOptions:  Array< {
          __typename: "SelectedProductOption",
          name: string,
          selection: string,
        } >,
      } | null > | null,
    } >,
    estimatedTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
    estimatedCheckoutTotal:  {
      __typename: "EstimatedTotal",
      id: string,
      displayPrice: string,
    },
  } | null,
};

export type SubscribeToNotifyCardFundingChangeSubscriptionVariables = {
  userId: string,
};

export type SubscribeToNotifyCardFundingChangeSubscription = {
  subscribeToNotifyCardFundingChange?:  {
    __typename: "CardFunding",
    userId: string,
    fundingCents: number,
  } | null,
};
